
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirede3a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirede3a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cgW3F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8ef403c7735f95db$export$2e2bcd8739ae039);
parcelRequire("ifmbe");
var $lG4lo = parcelRequire("lG4lo");
parcelRequire("4b4cS");
var $dU9dn = parcelRequire("dU9dn");

var $7fVR2 = parcelRequire("7fVR2");

var $e1hCE = parcelRequire("e1hCE");
var $8ef403c7735f95db$export$2e2bcd8739ae039 = {
    name: 'ControllerDemo',
    components: {
        HeadphoneControls: $7fVR2.default,
        MicrophoneControls: $e1hCE.default
    },
    data () {
        return {
            controllers: []
        };
    },
    methods: {
        async addController () {
            const rawController = new (0, $dU9dn.DualShock4)();
            (0, $lG4lo.markRaw)(rawController.audio);
            // HID callbacks use the original instance captured in the constructor.
            rawController.state = (0, $lG4lo.reactive)(rawController.state);
            const controller = (0, $lG4lo.reactive)(rawController);
            rawController.addEventListener('disconnect', ()=>{
                rawController.state = (0, $lG4lo.reactive)(rawController.state);
                this.controllers = [
                    ...this.controllers
                ];
            });
            if (await controller.connect()) this.controllers.push(controller);
        }
    },
    computed: {
        hidSupported () {
            return !!(window.navigator.hid && window.navigator.hid.requestDevice);
        }
    }
};

});
parcelRegister("ifmbe", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("9Xpaa")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("9Xpaa")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("9Xpaa")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("9Xpaa")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("9Xpaa")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("9Xpaa")).createVNode);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("9Xpaa")).Fragment);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("9Xpaa")).initCustomFormatter);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("lG4lo")).markRaw);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("h3IIu")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("9Xpaa")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("9Xpaa")).onMounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("9Xpaa")).openBlock);
$parcel$export(module.exports, "reactive", () => (parcelRequire("lG4lo")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("lG4lo")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("9Xpaa")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("9Xpaa")).resolveComponent);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("lG4lo")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("lG4lo")).toRaw);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("9Xpaa")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("jE6au")).createApp);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("jE6au")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("jE6au")).vModelText);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("h3IIu")).toDisplayString);
/**
* vue v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $9Xpaa = parcelRequire("9Xpaa");parcelRequire("jE6au");parcelRequire("h3IIu");
function $d48ad53a92e958bf$var$initDev() {
    (0, $9Xpaa.initCustomFormatter)();
}
const $d48ad53a92e958bf$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("9Xpaa", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $73fd249b5e055961$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $73fd249b5e055961$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $73fd249b5e055961$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $73fd249b5e055961$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $73fd249b5e055961$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withDirectives", () => $73fd249b5e055961$export$49729353e7c1e6c5);
$parcel$export(module.exports, "getCurrentInstance", () => $73fd249b5e055961$export$f13e630aa3915748);
$parcel$export(module.exports, "watch", () => $73fd249b5e055961$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $73fd249b5e055961$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $73fd249b5e055961$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $73fd249b5e055961$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $73fd249b5e055961$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $73fd249b5e055961$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $73fd249b5e055961$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $73fd249b5e055961$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $73fd249b5e055961$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $73fd249b5e055961$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $73fd249b5e055961$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $73fd249b5e055961$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $73fd249b5e055961$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUnmounted", () => $73fd249b5e055961$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $73fd249b5e055961$export$5876c47052fb88b1);
$parcel$export(module.exports, "onBeforeUpdate", () => $73fd249b5e055961$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $73fd249b5e055961$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "renderList", () => $73fd249b5e055961$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $73fd249b5e055961$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "computed", () => $73fd249b5e055961$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $73fd249b5e055961$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $73fd249b5e055961$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $73fd249b5e055961$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $73fd249b5e055961$export$42098e0eaa15c48e);
$parcel$export(module.exports, "isRuntimeOnly", () => $73fd249b5e055961$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $73fd249b5e055961$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $73fd249b5e055961$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $73fd249b5e055961$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("lG4lo")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("lG4lo")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("lG4lo")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("lG4lo")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("lG4lo")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("h3IIu")).camelize);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("h3IIu")).normalizeStyle);
/**
* @vue/runtime-core v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $lG4lo = parcelRequire("lG4lo");

var $h3IIu = parcelRequire("h3IIu");
const $73fd249b5e055961$var$stack = [];
function $73fd249b5e055961$var$pushWarningContext(vnode) {
    $73fd249b5e055961$var$stack.push(vnode);
}
function $73fd249b5e055961$var$popWarningContext() {
    $73fd249b5e055961$var$stack.pop();
}
let $73fd249b5e055961$var$isWarning = false;
function $73fd249b5e055961$var$warn$1(msg, ...args) {
    if ($73fd249b5e055961$var$isWarning) return;
    $73fd249b5e055961$var$isWarning = true;
    (0, $lG4lo.pauseTracking)();
    const instance = $73fd249b5e055961$var$stack.length ? $73fd249b5e055961$var$stack[$73fd249b5e055961$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $73fd249b5e055961$var$getComponentTrace();
    if (appWarnHandler) $73fd249b5e055961$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$73fd249b5e055961$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$73fd249b5e055961$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $lG4lo.resetTracking)();
    $73fd249b5e055961$var$isWarning = false;
}
function $73fd249b5e055961$var$getComponentTrace() {
    let currentVNode = $73fd249b5e055961$var$stack[$73fd249b5e055961$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $73fd249b5e055961$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$73fd249b5e055961$var$formatTraceEntry(entry));
    });
    return logs;
}
function $73fd249b5e055961$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$73fd249b5e055961$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$73fd249b5e055961$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $73fd249b5e055961$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$73fd249b5e055961$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $73fd249b5e055961$var$formatProp(key, value, raw) {
    if ((0, $h3IIu.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $lG4lo.isRef)(value)) {
        value = $73fd249b5e055961$var$formatProp(key, (0, $lG4lo.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $h3IIu.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $lG4lo.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $73fd249b5e055961$export$dfbcecb440255e4a(val, type) {
    return;
}
const $73fd249b5e055961$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $73fd249b5e055961$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $73fd249b5e055961$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $73fd249b5e055961$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $h3IIu.isFunction)(fn)) {
        const res = $73fd249b5e055961$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $h3IIu.isPromise)(res)) res.catch((err)=>{
            $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $h3IIu.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($73fd249b5e055961$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $h3IIu.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $lG4lo.pauseTracking)();
            $73fd249b5e055961$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $lG4lo.resetTracking)();
            return;
        }
    }
    $73fd249b5e055961$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $73fd249b5e055961$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $73fd249b5e055961$var$queue = [];
let $73fd249b5e055961$var$flushIndex = -1;
const $73fd249b5e055961$var$pendingPostFlushCbs = [];
let $73fd249b5e055961$var$activePostFlushCbs = null;
let $73fd249b5e055961$var$postFlushIndex = 0;
const $73fd249b5e055961$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $73fd249b5e055961$var$currentFlushPromise = null;
const $73fd249b5e055961$var$RECURSION_LIMIT = 100;
function $73fd249b5e055961$export$bdd553fddd433dcb(fn) {
    const p = $73fd249b5e055961$var$currentFlushPromise || $73fd249b5e055961$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $73fd249b5e055961$var$findInsertionIndex(id) {
    let start = $73fd249b5e055961$var$flushIndex + 1;
    let end = $73fd249b5e055961$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $73fd249b5e055961$var$queue[middle];
        const middleJobId = $73fd249b5e055961$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $73fd249b5e055961$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $73fd249b5e055961$var$getId(job);
        const lastJob = $73fd249b5e055961$var$queue[$73fd249b5e055961$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $73fd249b5e055961$var$getId(lastJob)) $73fd249b5e055961$var$queue.push(job);
        else $73fd249b5e055961$var$queue.splice($73fd249b5e055961$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $73fd249b5e055961$var$queueFlush();
    }
}
function $73fd249b5e055961$var$queueFlush() {
    if (!$73fd249b5e055961$var$currentFlushPromise) $73fd249b5e055961$var$currentFlushPromise = $73fd249b5e055961$var$resolvedPromise.then($73fd249b5e055961$var$flushJobs);
}
function $73fd249b5e055961$export$59536a0199721cab(cb) {
    if (!(0, $h3IIu.isArray)(cb)) {
        if ($73fd249b5e055961$var$activePostFlushCbs && cb.id === -1) $73fd249b5e055961$var$activePostFlushCbs.splice($73fd249b5e055961$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $73fd249b5e055961$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$73fd249b5e055961$var$pendingPostFlushCbs.push(cb[i]);
    $73fd249b5e055961$var$queueFlush();
}
function $73fd249b5e055961$var$flushPreFlushCbs(instance, seen, i = $73fd249b5e055961$var$flushIndex + 1) {
    for(; i < $73fd249b5e055961$var$queue.length; i++){
        const cb = $73fd249b5e055961$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $73fd249b5e055961$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $73fd249b5e055961$var$flushPostFlushCbs(seen) {
    if ($73fd249b5e055961$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($73fd249b5e055961$var$pendingPostFlushCbs)
        ].sort((a, b)=>$73fd249b5e055961$var$getId(a) - $73fd249b5e055961$var$getId(b));
        $73fd249b5e055961$var$pendingPostFlushCbs.length = 0;
        if ($73fd249b5e055961$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$73fd249b5e055961$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $73fd249b5e055961$var$activePostFlushCbs = deduped;
        for($73fd249b5e055961$var$postFlushIndex = 0; $73fd249b5e055961$var$postFlushIndex < $73fd249b5e055961$var$activePostFlushCbs.length; $73fd249b5e055961$var$postFlushIndex++){
            const cb = $73fd249b5e055961$var$activePostFlushCbs[$73fd249b5e055961$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $73fd249b5e055961$var$activePostFlushCbs = null;
        $73fd249b5e055961$var$postFlushIndex = 0;
    }
}
const $73fd249b5e055961$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $73fd249b5e055961$var$flushJobs(seen) {
    const check = (0, $h3IIu.NOOP);
    try {
        for($73fd249b5e055961$var$flushIndex = 0; $73fd249b5e055961$var$flushIndex < $73fd249b5e055961$var$queue.length; $73fd249b5e055961$var$flushIndex++){
            const job = $73fd249b5e055961$var$queue[$73fd249b5e055961$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $73fd249b5e055961$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $73fd249b5e055961$var$flushIndex < $73fd249b5e055961$var$queue.length; $73fd249b5e055961$var$flushIndex++){
            const job = $73fd249b5e055961$var$queue[$73fd249b5e055961$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $73fd249b5e055961$var$flushIndex = -1;
        $73fd249b5e055961$var$queue.length = 0;
        $73fd249b5e055961$var$flushPostFlushCbs(seen);
        $73fd249b5e055961$var$currentFlushPromise = null;
        if ($73fd249b5e055961$var$queue.length || $73fd249b5e055961$var$pendingPostFlushCbs.length) $73fd249b5e055961$var$flushJobs(seen);
    }
}
function $73fd249b5e055961$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $73fd249b5e055961$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $73fd249b5e055961$var$getComponentName(instance.type);
        $73fd249b5e055961$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $73fd249b5e055961$var$isHmrUpdating = false;
const $73fd249b5e055961$var$setHmrUpdating = (v1)=>{
    try {
        return $73fd249b5e055961$var$isHmrUpdating;
    } finally{
        $73fd249b5e055961$var$isHmrUpdating = v1;
    }
};
const $73fd249b5e055961$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $73fd249b5e055961$var$map = /* @__PURE__ */ new Map();
function $73fd249b5e055961$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $73fd249b5e055961$var$map.get(id);
    if (!record) {
        $73fd249b5e055961$var$createRecord(id, instance.type);
        record = $73fd249b5e055961$var$map.get(id);
    }
    record.instances.add(instance);
}
function $73fd249b5e055961$var$unregisterHMR(instance) {
    $73fd249b5e055961$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $73fd249b5e055961$var$createRecord(id, initialDef) {
    if ($73fd249b5e055961$var$map.has(id)) return false;
    $73fd249b5e055961$var$map.set(id, {
        initialDef: $73fd249b5e055961$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $73fd249b5e055961$var$normalizeClassComponent(component) {
    return $73fd249b5e055961$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $73fd249b5e055961$var$rerender(id, newRender) {
    const record = $73fd249b5e055961$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $73fd249b5e055961$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $73fd249b5e055961$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $73fd249b5e055961$var$isHmrUpdating = false;
    });
}
function $73fd249b5e055961$var$reload(id, newComp) {
    const record = $73fd249b5e055961$var$map.get(id);
    if (!record) return;
    newComp = $73fd249b5e055961$var$normalizeClassComponent(newComp);
    $73fd249b5e055961$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $73fd249b5e055961$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $73fd249b5e055961$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $73fd249b5e055961$var$updateComponentDef(oldComp, newComp);
            $73fd249b5e055961$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $73fd249b5e055961$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $73fd249b5e055961$var$isHmrUpdating = true;
                instance.parent.update();
                $73fd249b5e055961$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $73fd249b5e055961$export$59536a0199721cab(()=>{
        $73fd249b5e055961$var$hmrDirtyComponents.clear();
    });
}
function $73fd249b5e055961$var$updateComponentDef(oldComp, newComp) {
    (0, $h3IIu.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $73fd249b5e055961$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $73fd249b5e055961$var$devtools$1;
let $73fd249b5e055961$var$buffer = [];
let $73fd249b5e055961$var$devtoolsNotInstalled = false;
function $73fd249b5e055961$var$emit$1(event, ...args) {
    if ($73fd249b5e055961$var$devtools$1) $73fd249b5e055961$var$devtools$1.emit(event, ...args);
    else if (!$73fd249b5e055961$var$devtoolsNotInstalled) $73fd249b5e055961$var$buffer.push({
        event: event,
        args: args
    });
}
function $73fd249b5e055961$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $73fd249b5e055961$var$devtools$1 = hook;
    if ($73fd249b5e055961$var$devtools$1) {
        $73fd249b5e055961$var$devtools$1.enabled = true;
        $73fd249b5e055961$var$buffer.forEach(({ event: event, args: args })=>$73fd249b5e055961$var$devtools$1.emit(event, ...args));
        $73fd249b5e055961$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $73fd249b5e055961$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$73fd249b5e055961$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $73fd249b5e055961$var$devtoolsNotInstalled = true;
                $73fd249b5e055961$var$buffer = [];
            }
        }, 3e3);
    } else {
        $73fd249b5e055961$var$devtoolsNotInstalled = true;
        $73fd249b5e055961$var$buffer = [];
    }
}
function $73fd249b5e055961$var$devtoolsInitApp(app, version) {
    $73fd249b5e055961$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $73fd249b5e055961$export$ffb0004e005737fa,
        Text: $73fd249b5e055961$export$5f1af8db9871e1d6,
        Comment: $73fd249b5e055961$export$4d299b491347818a,
        Static: $73fd249b5e055961$export$c1b9a1d3af45b7b6
    });
}
function $73fd249b5e055961$var$devtoolsUnmountApp(app) {
    $73fd249b5e055961$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $73fd249b5e055961$var$devtoolsComponentAdded = /* @__PURE__ */ $73fd249b5e055961$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $73fd249b5e055961$var$devtoolsComponentUpdated = /* @__PURE__ */ $73fd249b5e055961$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $73fd249b5e055961$var$_devtoolsComponentRemoved = /* @__PURE__ */ $73fd249b5e055961$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $73fd249b5e055961$var$devtoolsComponentRemoved = (component)=>{
    if ($73fd249b5e055961$var$devtools$1 && typeof $73fd249b5e055961$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$73fd249b5e055961$var$devtools$1.cleanupBuffer(component)) $73fd249b5e055961$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $73fd249b5e055961$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $73fd249b5e055961$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $73fd249b5e055961$var$devtoolsPerfStart = /* @__PURE__ */ $73fd249b5e055961$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $73fd249b5e055961$var$devtoolsPerfEnd = /* @__PURE__ */ $73fd249b5e055961$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $73fd249b5e055961$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $73fd249b5e055961$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $73fd249b5e055961$var$devtoolsComponentEmit(component, event, params) {
    $73fd249b5e055961$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $73fd249b5e055961$var$currentRenderingInstance = null;
let $73fd249b5e055961$var$currentScopeId = null;
function $73fd249b5e055961$var$setCurrentRenderingInstance(instance) {
    const prev = $73fd249b5e055961$var$currentRenderingInstance;
    $73fd249b5e055961$var$currentRenderingInstance = instance;
    $73fd249b5e055961$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $73fd249b5e055961$export$ac020265ca2cc4cd(id) {
    $73fd249b5e055961$var$currentScopeId = id;
}
function $73fd249b5e055961$export$f2dc6805dc11834e() {
    $73fd249b5e055961$var$currentScopeId = null;
}
const $73fd249b5e055961$export$15ba313e13f3dd04 = (_id)=>$73fd249b5e055961$export$694b237e827a3d23;
function $73fd249b5e055961$export$694b237e827a3d23(fn, ctx = $73fd249b5e055961$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $73fd249b5e055961$export$c20bee82f26f1e27(-1);
        const prevInstance = $73fd249b5e055961$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $73fd249b5e055961$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $73fd249b5e055961$var$blockStack.length; i > prevStackSize; i--)$73fd249b5e055961$var$closeBlock();
            $73fd249b5e055961$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $73fd249b5e055961$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $73fd249b5e055961$var$validateDirectiveName(name) {
    if ((0, $h3IIu.isBuiltInDirective)(name)) $73fd249b5e055961$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $73fd249b5e055961$export$49729353e7c1e6c5(vnode, directives) {
    if ($73fd249b5e055961$var$currentRenderingInstance === null) return vnode;
    const instance = $73fd249b5e055961$var$getComponentPublicInstance($73fd249b5e055961$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $h3IIu.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $h3IIu.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $lG4lo.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $73fd249b5e055961$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $lG4lo.pauseTracking)();
            $73fd249b5e055961$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $lG4lo.resetTracking)();
        }
    }
}
function $73fd249b5e055961$export$abe1e183e22e10ad(key, value) {
    if ($73fd249b5e055961$var$currentInstance) {
        let provides = $73fd249b5e055961$var$currentInstance.provides;
        const parentProvides = $73fd249b5e055961$var$currentInstance.parent && $73fd249b5e055961$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $73fd249b5e055961$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $73fd249b5e055961$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $73fd249b5e055961$export$f13e630aa3915748();
    if (instance || $73fd249b5e055961$var$currentApp) {
        let provides = $73fd249b5e055961$var$currentApp ? $73fd249b5e055961$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $h3IIu.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $73fd249b5e055961$export$caf6761f24fc571a() {
    return !!($73fd249b5e055961$export$f13e630aa3915748() || $73fd249b5e055961$var$currentApp);
}
const $73fd249b5e055961$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $73fd249b5e055961$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $73fd249b5e055961$export$a976684a0efeb93f($73fd249b5e055961$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $73fd249b5e055961$export$ede35fc0e5500309(effect, options) {
    return $73fd249b5e055961$var$doWatch(effect, null, options);
}
function $73fd249b5e055961$export$b7f27ea67102d543(effect, options) {
    return $73fd249b5e055961$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $73fd249b5e055961$export$2035654f31b0e555(effect, options) {
    return $73fd249b5e055961$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $73fd249b5e055961$export$3db5d71bdb2d5499(source, cb, options) {
    return $73fd249b5e055961$var$doWatch(source, cb, options);
}
function $73fd249b5e055961$var$doWatch(source, cb, options = (0, $h3IIu.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $h3IIu.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($73fd249b5e055961$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $73fd249b5e055961$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $h3IIu.NOOP);
            watchStopHandle.resume = (0, $h3IIu.NOOP);
            watchStopHandle.pause = (0, $h3IIu.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $73fd249b5e055961$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$73fd249b5e055961$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $73fd249b5e055961$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $73fd249b5e055961$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $lG4lo.watch)(source, cb, baseWatchOptions);
    if ($73fd249b5e055961$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $73fd249b5e055961$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $h3IIu.isString)(source) ? source.includes(".") ? $73fd249b5e055961$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $h3IIu.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $73fd249b5e055961$var$setCurrentInstance(this);
    const res = $73fd249b5e055961$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $73fd249b5e055961$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $73fd249b5e055961$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $73fd249b5e055961$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $73fd249b5e055961$var$isTeleport = (type)=>type.__isTeleport;
const $73fd249b5e055961$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $73fd249b5e055961$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $73fd249b5e055961$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $73fd249b5e055961$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $73fd249b5e055961$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $h3IIu.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $73fd249b5e055961$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $73fd249b5e055961$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $73fd249b5e055961$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $73fd249b5e055961$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $73fd249b5e055961$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $73fd249b5e055961$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $73fd249b5e055961$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $73fd249b5e055961$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($73fd249b5e055961$var$pendingMounts.get(vnode) !== mountJob) return;
                $73fd249b5e055961$var$pendingMounts.delete(vnode);
                if ($73fd249b5e055961$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $73fd249b5e055961$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $73fd249b5e055961$var$pendingMounts.set(vnode, mountJob);
            $73fd249b5e055961$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($73fd249b5e055961$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $73fd249b5e055961$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $73fd249b5e055961$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $73fd249b5e055961$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $73fd249b5e055961$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $73fd249b5e055961$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $73fd249b5e055961$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $73fd249b5e055961$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $73fd249b5e055961$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $73fd249b5e055961$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $73fd249b5e055961$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $73fd249b5e055961$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $73fd249b5e055961$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $73fd249b5e055961$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $73fd249b5e055961$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $73fd249b5e055961$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $73fd249b5e055961$var$moveTeleport,
    hydrate: $73fd249b5e055961$var$hydrateTeleport
};
function $73fd249b5e055961$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$73fd249b5e055961$var$pendingMounts.has(vnode) && (!isReorder || $73fd249b5e055961$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $73fd249b5e055961$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $73fd249b5e055961$var$resolveTarget(vnode.props, querySelector);
    const disabled = $73fd249b5e055961$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $73fd249b5e055961$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $73fd249b5e055961$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $73fd249b5e055961$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $73fd249b5e055961$export$76d55a0304a371f4 = $73fd249b5e055961$var$TeleportImpl;
function $73fd249b5e055961$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $73fd249b5e055961$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$73fd249b5e055961$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $73fd249b5e055961$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $73fd249b5e055961$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $73fd249b5e055961$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $73fd249b5e055961$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $73fd249b5e055961$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $73fd249b5e055961$var$TransitionHookValidator = [
    Function,
    Array
];
const $73fd249b5e055961$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $73fd249b5e055961$var$TransitionHookValidator,
    onEnter: $73fd249b5e055961$var$TransitionHookValidator,
    onAfterEnter: $73fd249b5e055961$var$TransitionHookValidator,
    onEnterCancelled: $73fd249b5e055961$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $73fd249b5e055961$var$TransitionHookValidator,
    onLeave: $73fd249b5e055961$var$TransitionHookValidator,
    onAfterLeave: $73fd249b5e055961$var$TransitionHookValidator,
    onLeaveCancelled: $73fd249b5e055961$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $73fd249b5e055961$var$TransitionHookValidator,
    onAppear: $73fd249b5e055961$var$TransitionHookValidator,
    onAfterAppear: $73fd249b5e055961$var$TransitionHookValidator,
    onAppearCancelled: $73fd249b5e055961$var$TransitionHookValidator
};
const $73fd249b5e055961$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $73fd249b5e055961$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $73fd249b5e055961$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $73fd249b5e055961$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $73fd249b5e055961$export$f13e630aa3915748();
        const state = $73fd249b5e055961$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $73fd249b5e055961$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $73fd249b5e055961$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $73fd249b5e055961$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $lG4lo.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $73fd249b5e055961$var$emptyPlaceholder(child);
            const innerChild = $73fd249b5e055961$var$getInnerChild$1(child);
            if (!innerChild) return $73fd249b5e055961$var$emptyPlaceholder(child);
            let enterHooks = $73fd249b5e055961$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $73fd249b5e055961$export$4d299b491347818a) $73fd249b5e055961$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $73fd249b5e055961$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $73fd249b5e055961$export$4d299b491347818a && !$73fd249b5e055961$var$isSameVNodeType(oldInnerChild, innerChild) && $73fd249b5e055961$var$recursiveGetSubtree(instance).type !== $73fd249b5e055961$export$4d299b491347818a) {
                let leavingHooks = $73fd249b5e055961$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $73fd249b5e055961$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $73fd249b5e055961$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $73fd249b5e055961$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $73fd249b5e055961$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $73fd249b5e055961$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$73fd249b5e055961$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$73fd249b5e055961$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $73fd249b5e055961$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $73fd249b5e055961$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $73fd249b5e055961$export$abd95b5f5e8a8837 = $73fd249b5e055961$var$BaseTransitionImpl;
function $73fd249b5e055961$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $73fd249b5e055961$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $73fd249b5e055961$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $73fd249b5e055961$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $h3IIu.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$73fd249b5e055961$var$leaveCbKey]) el[$73fd249b5e055961$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $73fd249b5e055961$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$73fd249b5e055961$var$leaveCbKey]) leavingVNode.el[$73fd249b5e055961$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$73fd249b5e055961$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$73fd249b5e055961$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$73fd249b5e055961$var$enterCbKey] = void 0;
            };
            const done = el[$73fd249b5e055961$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$73fd249b5e055961$var$enterCbKey]) el[$73fd249b5e055961$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$73fd249b5e055961$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$73fd249b5e055961$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$73fd249b5e055961$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $73fd249b5e055961$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $73fd249b5e055961$var$emptyPlaceholder(vnode) {
    if ($73fd249b5e055961$var$isKeepAlive(vnode)) {
        vnode = $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $73fd249b5e055961$var$getInnerChild$1(vnode) {
    if (!$73fd249b5e055961$var$isKeepAlive(vnode)) {
        if ($73fd249b5e055961$var$isTeleport(vnode.type) && vnode.children) return $73fd249b5e055961$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $h3IIu.isFunction)(children.default)) return children.default();
    }
}
function $73fd249b5e055961$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $73fd249b5e055961$export$7770a22486565649($73fd249b5e055961$var$isTeleport(subTree.type) ? $73fd249b5e055961$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $73fd249b5e055961$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $73fd249b5e055961$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($73fd249b5e055961$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $73fd249b5e055961$export$4d299b491347818a) ret.push(key != null ? $73fd249b5e055961$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $73fd249b5e055961$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $h3IIu.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $h3IIu.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $73fd249b5e055961$export$f680877a34711e37() {
    const i = $73fd249b5e055961$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $73fd249b5e055961$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $73fd249b5e055961$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $73fd249b5e055961$export$83a5dbc1f35517ca(key) {
    const i = $73fd249b5e055961$export$f13e630aa3915748();
    const r = (0, $lG4lo.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $h3IIu.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $73fd249b5e055961$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $73fd249b5e055961$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $73fd249b5e055961$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $h3IIu.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$73fd249b5e055961$var$setRef(r, oldRawRef && ((0, $h3IIu.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($73fd249b5e055961$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $73fd249b5e055961$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $73fd249b5e055961$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $h3IIu.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $lG4lo.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $h3IIu.EMPTY_OBJ) ? (0, $h3IIu.NO) : (key)=>{
        if ($73fd249b5e055961$var$isTemplateRefKey(refs, key)) return false;
        return (0, $h3IIu.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $73fd249b5e055961$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $73fd249b5e055961$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $h3IIu.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $lG4lo.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $h3IIu.isFunction)(ref)) $73fd249b5e055961$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $h3IIu.isString)(ref);
        const _isRef = (0, $lG4lo.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $h3IIu.isArray)(existing) && (0, $h3IIu.remove)(existing, refValue);
                    else {
                        if (!(0, $h3IIu.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $73fd249b5e055961$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $73fd249b5e055961$var$pendingSetRefMap.set(rawRef, job);
                $73fd249b5e055961$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $73fd249b5e055961$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $73fd249b5e055961$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $73fd249b5e055961$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $73fd249b5e055961$var$pendingSetRefMap.delete(rawRef);
    }
}
let $73fd249b5e055961$var$hasLoggedMismatchError = false;
const $73fd249b5e055961$var$logMismatchError = ()=>{
    if ($73fd249b5e055961$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $73fd249b5e055961$var$hasLoggedMismatchError = true;
};
const $73fd249b5e055961$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $73fd249b5e055961$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $73fd249b5e055961$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($73fd249b5e055961$var$isSVGContainer(container)) return "svg";
    if ($73fd249b5e055961$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $73fd249b5e055961$var$isComment = (node)=>node.nodeType === 8;
function $73fd249b5e055961$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $73fd249b5e055961$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $73fd249b5e055961$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $73fd249b5e055961$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $h3IIu.def)(node, "__vnode", vnode, true);
            (0, $h3IIu.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $73fd249b5e055961$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $73fd249b5e055961$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $73fd249b5e055961$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $73fd249b5e055961$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $73fd249b5e055961$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($73fd249b5e055961$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $73fd249b5e055961$var$getContainerType(container), optimized);
                    if ($73fd249b5e055961$var$isAsyncWrapper(vnode) && !vnode.component.subTree) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$c1b9a1d3af45b7b6);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $73fd249b5e055961$export$22f9b5ffd89dac9("") : $73fd249b5e055961$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $73fd249b5e055961$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $73fd249b5e055961$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $73fd249b5e055961$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $73fd249b5e055961$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$73fd249b5e055961$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $73fd249b5e055961$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$73fd249b5e055961$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $73fd249b5e055961$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $73fd249b5e055961$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $73fd249b5e055961$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $h3IIu.isOn)(key) && !(0, $h3IIu.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $h3IIu.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($73fd249b5e055961$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $lG4lo.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $73fd249b5e055961$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $73fd249b5e055961$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $73fd249b5e055961$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $73fd249b5e055961$var$normalizeVNode(children[i]);
            const isText = vnode.type === $73fd249b5e055961$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $73fd249b5e055961$var$normalizeVNode(children[i + 1]).type === $73fd249b5e055961$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$73fd249b5e055961$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $73fd249b5e055961$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $73fd249b5e055961$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $73fd249b5e055961$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $73fd249b5e055961$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$73fd249b5e055961$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $73fd249b5e055961$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $73fd249b5e055961$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $73fd249b5e055961$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $73fd249b5e055961$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $73fd249b5e055961$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $73fd249b5e055961$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $73fd249b5e055961$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $73fd249b5e055961$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$73fd249b5e055961$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $73fd249b5e055961$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $h3IIu.normalizeClass)(clientValue);
        if (!$73fd249b5e055961$var$isSetEqual($73fd249b5e055961$var$toClassSet(actual || ""), $73fd249b5e055961$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $h3IIu.isString)(clientValue) ? clientValue : (0, $h3IIu.stringifyStyle)((0, $h3IIu.normalizeStyle)(clientValue));
        const actualMap = $73fd249b5e055961$var$toStyleMap(actual);
        const expectedMap = $73fd249b5e055961$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $73fd249b5e055961$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$73fd249b5e055961$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $h3IIu.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $h3IIu.isBooleanAttr)(key) || (0, $h3IIu.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $73fd249b5e055961$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $73fd249b5e055961$var$normalizeHiddenValue(clientValue);
        } else if ((0, $h3IIu.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $h3IIu.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $h3IIu.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$73fd249b5e055961$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$73fd249b5e055961$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $73fd249b5e055961$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $73fd249b5e055961$var$normalizeHiddenValue(value) {
    if (!(0, $h3IIu.isRenderableAttrValue)(value)) return false;
    if ((0, $h3IIu.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $h3IIu.includeBooleanAttr)(value) ? "" : false;
}
function $73fd249b5e055961$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $73fd249b5e055961$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $73fd249b5e055961$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $73fd249b5e055961$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $73fd249b5e055961$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $73fd249b5e055961$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $h3IIu.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $h3IIu.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $73fd249b5e055961$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $73fd249b5e055961$var$allowMismatchAttr = "data-allow-mismatch";
const $73fd249b5e055961$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $73fd249b5e055961$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($73fd249b5e055961$var$allowMismatchAttr))el = el.parentElement;
    return $73fd249b5e055961$var$isMismatchAllowedByAttr(el && el.getAttribute($73fd249b5e055961$var$allowMismatchAttr), allowedType);
}
function $73fd249b5e055961$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($73fd249b5e055961$var$MismatchTypeString[allowedType]);
    }
}
function $73fd249b5e055961$var$isNodeMismatchAllowed(node, vnode) {
    return $73fd249b5e055961$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $73fd249b5e055961$var$isMismatchAllowedByNode(node) || $73fd249b5e055961$var$isMismatchAllowedByVNode(vnode);
}
function $73fd249b5e055961$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $73fd249b5e055961$var$isMismatchAllowedByAttr(node.getAttribute($73fd249b5e055961$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $73fd249b5e055961$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$73fd249b5e055961$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $73fd249b5e055961$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $73fd249b5e055961$var$requestIdleCallback = (0, $h3IIu.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $73fd249b5e055961$var$cancelIdleCallback = (0, $h3IIu.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $73fd249b5e055961$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $73fd249b5e055961$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$73fd249b5e055961$var$cancelIdleCallback(id);
    };
function $73fd249b5e055961$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $73fd249b5e055961$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($73fd249b5e055961$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $73fd249b5e055961$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $73fd249b5e055961$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $h3IIu.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $73fd249b5e055961$var$forEachElement(node, cb) {
    if ($73fd249b5e055961$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($73fd249b5e055961$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $73fd249b5e055961$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $73fd249b5e055961$export$d75d499b4c16cf21(source) {
    if ((0, $h3IIu.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $73fd249b5e055961$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$73fd249b5e055961$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $73fd249b5e055961$var$currentInstance;
            $73fd249b5e055961$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$73fd249b5e055961$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $73fd249b5e055961$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$73fd249b5e055961$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $73fd249b5e055961$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $lG4lo.ref)(false);
            const error = (0, $lG4lo.ref)();
            const delayed = (0, $lG4lo.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $73fd249b5e055961$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $73fd249b5e055961$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $73fd249b5e055961$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $73fd249b5e055961$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $73fd249b5e055961$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $73fd249b5e055961$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $73fd249b5e055961$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $73fd249b5e055961$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $73fd249b5e055961$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $73fd249b5e055961$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $73fd249b5e055961$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $h3IIu.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $73fd249b5e055961$var$invalidateMount(instance2.m);
            $73fd249b5e055961$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $73fd249b5e055961$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $h3IIu.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $73fd249b5e055961$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $73fd249b5e055961$var$getComponentName($73fd249b5e055961$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$73fd249b5e055961$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $73fd249b5e055961$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $73fd249b5e055961$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$73fd249b5e055961$var$matches(include, name));
            exclude && pruneCache((name)=>!$73fd249b5e055961$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($73fd249b5e055961$var$isSuspense(instance.subTree.type)) $73fd249b5e055961$var$queuePostRenderEffect(()=>{
                    const vnode = $73fd249b5e055961$var$getInnerChild(instance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $73fd249b5e055961$var$getInnerChild(instance.subTree));
            }
        };
        $73fd249b5e055961$export$6d1641039221b5cb(cacheSubtree);
        $73fd249b5e055961$export$5876c47052fb88b1(cacheSubtree);
        $73fd249b5e055961$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $73fd249b5e055961$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $73fd249b5e055961$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $73fd249b5e055961$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$73fd249b5e055961$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $73fd249b5e055961$var$getInnerChild(rawVNode);
            if (vnode.type === $73fd249b5e055961$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $73fd249b5e055961$var$getComponentName($73fd249b5e055961$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$73fd249b5e055961$var$matches(include, name)) || exclude && name && $73fd249b5e055961$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $73fd249b5e055961$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $73fd249b5e055961$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $73fd249b5e055961$export$70eb8a58709972df = $73fd249b5e055961$var$KeepAliveImpl;
function $73fd249b5e055961$var$matches(pattern, name) {
    if ((0, $h3IIu.isArray)(pattern)) return pattern.some((p)=>$73fd249b5e055961$var$matches(p, name));
    else if ((0, $h3IIu.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $h3IIu.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $73fd249b5e055961$export$ba52d824b95a2154(hook, target) {
    $73fd249b5e055961$var$registerKeepAliveHook(hook, "a", target);
}
function $73fd249b5e055961$export$bf1440eeaf5fa709(hook, target) {
    $73fd249b5e055961$var$registerKeepAliveHook(hook, "da", target);
}
function $73fd249b5e055961$var$registerKeepAliveHook(hook, type, target = $73fd249b5e055961$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $73fd249b5e055961$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($73fd249b5e055961$var$isKeepAlive(current.parent.vnode)) $73fd249b5e055961$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $73fd249b5e055961$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $73fd249b5e055961$var$injectHook(type, hook, keepAliveRoot, true);
    $73fd249b5e055961$export$13348a43ccacfe58(()=>{
        (0, $h3IIu.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $73fd249b5e055961$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $73fd249b5e055961$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $73fd249b5e055961$var$injectHook(type, hook, target = $73fd249b5e055961$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $lG4lo.pauseTracking)();
            const reset = $73fd249b5e055961$var$setCurrentInstance(target);
            const res = $73fd249b5e055961$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $lG4lo.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $73fd249b5e055961$var$createHook = (lifecycle)=>(hook, target = $73fd249b5e055961$var$currentInstance)=>{
        if (!$73fd249b5e055961$var$isInSSRComponentSetup || lifecycle === "sp") $73fd249b5e055961$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $73fd249b5e055961$export$23b7aeb0d671f804 = $73fd249b5e055961$var$createHook("bm");
const $73fd249b5e055961$export$6d1641039221b5cb = $73fd249b5e055961$var$createHook("m");
const $73fd249b5e055961$export$ab91988a13872e4c = $73fd249b5e055961$var$createHook("bu");
const $73fd249b5e055961$export$5876c47052fb88b1 = $73fd249b5e055961$var$createHook("u");
const $73fd249b5e055961$export$40c420df62d2614 = $73fd249b5e055961$var$createHook("bum");
const $73fd249b5e055961$export$13348a43ccacfe58 = $73fd249b5e055961$var$createHook("um");
const $73fd249b5e055961$export$ebf0c601f267bceb = $73fd249b5e055961$var$createHook("sp");
const $73fd249b5e055961$export$898295a813d662eb = $73fd249b5e055961$var$createHook("rtg");
const $73fd249b5e055961$export$2b41f4235363e921 = $73fd249b5e055961$var$createHook("rtc");
function $73fd249b5e055961$export$6a3a15856e50ad19(hook, target = $73fd249b5e055961$var$currentInstance) {
    $73fd249b5e055961$var$injectHook("ec", hook, target);
}
const $73fd249b5e055961$var$COMPONENTS = "components";
const $73fd249b5e055961$var$DIRECTIVES = "directives";
function $73fd249b5e055961$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $73fd249b5e055961$var$resolveAsset($73fd249b5e055961$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $73fd249b5e055961$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $73fd249b5e055961$export$b44c564a05ca975(component) {
    if ((0, $h3IIu.isString)(component)) return $73fd249b5e055961$var$resolveAsset($73fd249b5e055961$var$COMPONENTS, component, false) || component;
    else return component || $73fd249b5e055961$var$NULL_DYNAMIC_COMPONENT;
}
function $73fd249b5e055961$export$a1989e995cd481be(name) {
    return $73fd249b5e055961$var$resolveAsset($73fd249b5e055961$var$DIRECTIVES, name);
}
function $73fd249b5e055961$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $73fd249b5e055961$var$currentRenderingInstance || $73fd249b5e055961$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $73fd249b5e055961$var$COMPONENTS) {
            const selfName = $73fd249b5e055961$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $h3IIu.camelize)(name) || selfName === (0, $h3IIu.capitalize)((0, $h3IIu.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $73fd249b5e055961$var$resolve(instance[type] || Component[type], name) || // global registration
        $73fd249b5e055961$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $73fd249b5e055961$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $h3IIu.camelize)(name)] || registry[(0, $h3IIu.capitalize)((0, $h3IIu.camelize)(name))]);
}
function $73fd249b5e055961$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $h3IIu.isArray)(source);
    if (sourceIsArray || (0, $h3IIu.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $lG4lo.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $lG4lo.isShallow)(source);
            isReadonlySource = (0, $lG4lo.isReadonly)(source);
            source = (0, $lG4lo.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $lG4lo.toReadonly)((0, $lG4lo.toReactive)(source[i])) : (0, $lG4lo.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $h3IIu.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $73fd249b5e055961$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $h3IIu.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $73fd249b5e055961$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($73fd249b5e055961$var$currentRenderingInstance.ce || $73fd249b5e055961$var$currentRenderingInstance.parent && $73fd249b5e055961$var$isAsyncWrapper($73fd249b5e055961$var$currentRenderingInstance.parent) && $73fd249b5e055961$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $h3IIu.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $73fd249b5e055961$export$e7eaa45e502fe5cc(), $73fd249b5e055961$export$9f2dfe8048dfb22b($73fd249b5e055961$export$ffb0004e005737fa, null, [
            $73fd249b5e055961$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $73fd249b5e055961$var$blockStack.length;
    $73fd249b5e055961$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $73fd249b5e055961$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $73fd249b5e055961$export$9f2dfe8048dfb22b($73fd249b5e055961$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $h3IIu.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $73fd249b5e055961$var$blockStack.length; i > prevStackSize; i--)$73fd249b5e055961$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $73fd249b5e055961$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$73fd249b5e055961$export$3868d13f8734ae81(child)) return true;
        if (child.type === $73fd249b5e055961$export$4d299b491347818a) return false;
        if (child.type === $73fd249b5e055961$export$ffb0004e005737fa && !$73fd249b5e055961$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $73fd249b5e055961$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $h3IIu.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $73fd249b5e055961$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($73fd249b5e055961$var$isStatefulComponent(i)) return $73fd249b5e055961$var$getComponentPublicInstance(i);
    return $73fd249b5e055961$var$getPublicInstance(i.parent);
};
const $73fd249b5e055961$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $73fd249b5e055961$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $73fd249b5e055961$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $73fd249b5e055961$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
const $73fd249b5e055961$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $h3IIu.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>(0, i.vnode.el),
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$73fd249b5e055961$var$getPublicInstance(i.parent),
    $root: (i)=>$73fd249b5e055961$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $73fd249b5e055961$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $73fd249b5e055961$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $73fd249b5e055961$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $73fd249b5e055961$var$instanceWatch.bind(i) : (0, $h3IIu.NOOP)
});
const $73fd249b5e055961$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $73fd249b5e055961$var$hasSetupBinding = (state, key)=>state !== (0, $h3IIu.EMPTY_OBJ) && !state.__isScriptSetup && (0, $h3IIu.hasOwn)(state, key);
const $73fd249b5e055961$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($73fd249b5e055961$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $h3IIu.EMPTY_OBJ) && (0, $h3IIu.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $h3IIu.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $h3IIu.EMPTY_OBJ) && (0, $h3IIu.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $73fd249b5e055961$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $73fd249b5e055961$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $lG4lo.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $h3IIu.EMPTY_OBJ) && (0, $h3IIu.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $h3IIu.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($73fd249b5e055961$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $h3IIu.EMPTY_OBJ) && (0, $h3IIu.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $h3IIu.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $h3IIu.EMPTY_OBJ) && key[0] !== "$" && (0, $h3IIu.hasOwn)(data, key) || $73fd249b5e055961$var$hasSetupBinding(setupState, key) || (0, $h3IIu.hasOwn)(props, key) || (0, $h3IIu.hasOwn)(ctx, key) || (0, $h3IIu.hasOwn)($73fd249b5e055961$var$publicPropertiesMap, key) || (0, $h3IIu.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $h3IIu.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $73fd249b5e055961$var$target;
const $73fd249b5e055961$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $h3IIu.extend)({}, $73fd249b5e055961$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $73fd249b5e055961$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $h3IIu.isGloballyAllowed)(key);
        return has;
    }
});
function $73fd249b5e055961$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($73fd249b5e055961$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$73fd249b5e055961$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $h3IIu.NOOP)
        });
    });
    return target;
}
function $73fd249b5e055961$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $h3IIu.NOOP)
        });
    });
}
function $73fd249b5e055961$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $lG4lo.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($73fd249b5e055961$var$isReservedPrefix(key[0])) {
                $73fd249b5e055961$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $h3IIu.NOOP)
            });
        }
    });
}
const $73fd249b5e055961$var$warnRuntimeUsage = (method)=>$73fd249b5e055961$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $73fd249b5e055961$export$80b33eababae110e() {
    return null;
}
function $73fd249b5e055961$export$51ecece22fc17ddc() {
    return null;
}
function $73fd249b5e055961$export$da25b65ca24b518a(exposed) {}
function $73fd249b5e055961$export$77e79129327f3d0d(options) {}
function $73fd249b5e055961$export$1b3acd4bb805b712() {
    return null;
}
function $73fd249b5e055961$export$acd55aa037e791bb() {}
function $73fd249b5e055961$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $73fd249b5e055961$export$9203a8e84125433c() {
    return $73fd249b5e055961$var$getContext("useSlots").slots;
}
function $73fd249b5e055961$export$75e29435042cd2ea() {
    return $73fd249b5e055961$var$getContext("useAttrs").attrs;
}
function $73fd249b5e055961$var$getContext(calledFunctionName) {
    const i = $73fd249b5e055961$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $73fd249b5e055961$var$createSetupContext(i));
}
function $73fd249b5e055961$var$normalizePropsOrEmits(props) {
    return (0, $h3IIu.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $73fd249b5e055961$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $73fd249b5e055961$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $h3IIu.isArray)(opt) || (0, $h3IIu.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $73fd249b5e055961$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $h3IIu.isArray)(a) && (0, $h3IIu.isArray)(b)) return a.concat(b);
    return (0, $h3IIu.extend)({}, $73fd249b5e055961$var$normalizePropsOrEmits(a), $73fd249b5e055961$var$normalizePropsOrEmits(b));
}
function $73fd249b5e055961$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $73fd249b5e055961$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $73fd249b5e055961$export$f13e630aa3915748();
    const inSSRSetup = $73fd249b5e055961$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $73fd249b5e055961$var$unsetCurrentInstance();
    if (inSSRSetup) $73fd249b5e055961$var$setInSSRSetupState(false);
    const restore = ()=>{
        $73fd249b5e055961$var$setCurrentInstance(ctx);
        if (inSSRSetup) $73fd249b5e055961$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($73fd249b5e055961$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $73fd249b5e055961$var$unsetCurrentInstance();
        if (inSSRSetup) $73fd249b5e055961$var$setInSSRSetupState(false);
    };
    if ((0, $h3IIu.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $73fd249b5e055961$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $73fd249b5e055961$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $73fd249b5e055961$var$shouldCacheAccess = true;
function $73fd249b5e055961$var$applyOptions(instance) {
    const options = $73fd249b5e055961$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $73fd249b5e055961$var$shouldCacheAccess = false;
    if (options.beforeCreate) $73fd249b5e055961$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $73fd249b5e055961$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $h3IIu.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $h3IIu.isObject)(data)) ;
        else instance.data = (0, $lG4lo.reactive)(data);
    }
    $73fd249b5e055961$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $h3IIu.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $h3IIu.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $h3IIu.NOOP);
        const set = !(0, $h3IIu.isFunction)(opt) && (0, $h3IIu.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $h3IIu.NOOP);
        const c = $73fd249b5e055961$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$73fd249b5e055961$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $h3IIu.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $73fd249b5e055961$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $73fd249b5e055961$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $h3IIu.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($73fd249b5e055961$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($73fd249b5e055961$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($73fd249b5e055961$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($73fd249b5e055961$export$5876c47052fb88b1, updated);
    registerLifecycleHook($73fd249b5e055961$export$ba52d824b95a2154, activated);
    registerLifecycleHook($73fd249b5e055961$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($73fd249b5e055961$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($73fd249b5e055961$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($73fd249b5e055961$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($73fd249b5e055961$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($73fd249b5e055961$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($73fd249b5e055961$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $h3IIu.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $h3IIu.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $73fd249b5e055961$var$markAsyncBoundary(instance);
}
function $73fd249b5e055961$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $h3IIu.NOOP)) {
    if ((0, $h3IIu.isArray)(injectOptions)) injectOptions = $73fd249b5e055961$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $h3IIu.isObject)(opt)) {
            if ("default" in opt) injected = $73fd249b5e055961$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $73fd249b5e055961$export$a976684a0efeb93f(opt.from || key);
        } else injected = $73fd249b5e055961$export$a976684a0efeb93f(opt);
        if ((0, $lG4lo.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $73fd249b5e055961$var$callHook(hook, instance, type) {
    $73fd249b5e055961$export$dae85862a8d94378((0, $h3IIu.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $73fd249b5e055961$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $73fd249b5e055961$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $h3IIu.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $h3IIu.isFunction)(handler)) $73fd249b5e055961$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $h3IIu.isFunction)(raw)) $73fd249b5e055961$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $h3IIu.isObject)(raw)) {
        if ((0, $h3IIu.isArray)(raw)) raw.forEach((r)=>$73fd249b5e055961$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $h3IIu.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $h3IIu.isFunction)(handler)) $73fd249b5e055961$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $73fd249b5e055961$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$73fd249b5e055961$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $73fd249b5e055961$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $h3IIu.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $73fd249b5e055961$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $73fd249b5e055961$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$73fd249b5e055961$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $73fd249b5e055961$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $73fd249b5e055961$var$internalOptionMergeStrats = {
    data: $73fd249b5e055961$var$mergeDataFn,
    props: $73fd249b5e055961$var$mergeEmitsOrPropsOptions,
    emits: $73fd249b5e055961$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $73fd249b5e055961$var$mergeObjectOptions,
    computed: $73fd249b5e055961$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $73fd249b5e055961$var$mergeAsArray,
    created: $73fd249b5e055961$var$mergeAsArray,
    beforeMount: $73fd249b5e055961$var$mergeAsArray,
    mounted: $73fd249b5e055961$var$mergeAsArray,
    beforeUpdate: $73fd249b5e055961$var$mergeAsArray,
    updated: $73fd249b5e055961$var$mergeAsArray,
    beforeDestroy: $73fd249b5e055961$var$mergeAsArray,
    beforeUnmount: $73fd249b5e055961$var$mergeAsArray,
    destroyed: $73fd249b5e055961$var$mergeAsArray,
    unmounted: $73fd249b5e055961$var$mergeAsArray,
    activated: $73fd249b5e055961$var$mergeAsArray,
    deactivated: $73fd249b5e055961$var$mergeAsArray,
    errorCaptured: $73fd249b5e055961$var$mergeAsArray,
    serverPrefetch: $73fd249b5e055961$var$mergeAsArray,
    // assets
    components: $73fd249b5e055961$var$mergeObjectOptions,
    directives: $73fd249b5e055961$var$mergeObjectOptions,
    // watch
    watch: $73fd249b5e055961$var$mergeWatchOptions,
    // provide / inject
    provide: $73fd249b5e055961$var$mergeDataFn,
    inject: $73fd249b5e055961$var$mergeInject
};
function $73fd249b5e055961$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $h3IIu.extend)((0, $h3IIu.isFunction)(to) ? to.call(this, this) : to, (0, $h3IIu.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $73fd249b5e055961$var$mergeInject(to, from) {
    return $73fd249b5e055961$var$mergeObjectOptions($73fd249b5e055961$var$normalizeInject(to), $73fd249b5e055961$var$normalizeInject(from));
}
function $73fd249b5e055961$var$normalizeInject(raw) {
    if ((0, $h3IIu.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $73fd249b5e055961$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $73fd249b5e055961$var$mergeObjectOptions(to, from) {
    return to ? (0, $h3IIu.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $73fd249b5e055961$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $h3IIu.isArray)(to) && (0, $h3IIu.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $h3IIu.extend)(/* @__PURE__ */ Object.create(null), $73fd249b5e055961$var$normalizePropsOrEmits(to), $73fd249b5e055961$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $73fd249b5e055961$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $h3IIu.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $73fd249b5e055961$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $73fd249b5e055961$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $h3IIu.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $73fd249b5e055961$var$uid$1 = 0;
function $73fd249b5e055961$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $h3IIu.isFunction)(rootComponent)) rootComponent = (0, $h3IIu.extend)({}, rootComponent);
        if (rootProps != null && !(0, $h3IIu.isObject)(rootProps)) rootProps = null;
        const context = $73fd249b5e055961$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $73fd249b5e055961$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $73fd249b5e055961$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $h3IIu.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $h3IIu.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $73fd249b5e055961$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $73fd249b5e055961$var$devtoolsInitApp(app, $73fd249b5e055961$export$83d89fbfd8236492);
                    }
                    return $73fd249b5e055961$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $73fd249b5e055961$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $73fd249b5e055961$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $73fd249b5e055961$var$currentApp;
                $73fd249b5e055961$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $73fd249b5e055961$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $73fd249b5e055961$var$currentApp = null;
function $73fd249b5e055961$export$fb78bd113157f1a1(props, name, options = (0, $h3IIu.EMPTY_OBJ)) {
    const i = $73fd249b5e055961$export$f13e630aa3915748();
    const camelizedName = (0, $h3IIu.camelize)(name);
    const hyphenatedName = (0, $h3IIu.hyphenate)(name);
    const modifiers = $73fd249b5e055961$var$getModelModifiers(props, camelizedName);
    const res = (0, $lG4lo.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $h3IIu.EMPTY_OBJ);
        let prevEmittedValue;
        $73fd249b5e055961$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $h3IIu.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $h3IIu.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $h3IIu.EMPTY_OBJ) && (0, $h3IIu.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $h3IIu.hasChanged)(value, prevSetValue) && ((0, $h3IIu.hasChanged)(value, emittedValue) && !(0, $h3IIu.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $h3IIu.EMPTY_OBJ) && !(0, $h3IIu.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $h3IIu.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $73fd249b5e055961$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $h3IIu.camelize)(modelName)}Modifiers`] || props[`${(0, $h3IIu.hyphenate)(modelName)}Modifiers`];
};
function $73fd249b5e055961$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $h3IIu.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $73fd249b5e055961$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $h3IIu.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $h3IIu.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $h3IIu.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $h3IIu.toHandlerKey)((0, $h3IIu.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $h3IIu.toHandlerKey)((0, $h3IIu.hyphenate)(event))];
    if (handler) $73fd249b5e055961$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $73fd249b5e055961$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $73fd249b5e055961$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $73fd249b5e055961$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $73fd249b5e055961$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $h3IIu.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $73fd249b5e055961$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $h3IIu.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $h3IIu.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $h3IIu.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $h3IIu.extend)(normalized, raw);
    if ((0, $h3IIu.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $73fd249b5e055961$var$isEmitListener(options, key) {
    if (!options || !(0, $h3IIu.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $h3IIu.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $h3IIu.hasOwn)(options, (0, $h3IIu.hyphenate)(key)) || (0, $h3IIu.hasOwn)(options, key);
}
let $73fd249b5e055961$var$accessedAttrs = false;
function $73fd249b5e055961$var$markAttrsAccessed() {
    $73fd249b5e055961$var$accessedAttrs = true;
}
function $73fd249b5e055961$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $73fd249b5e055961$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $73fd249b5e055961$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $73fd249b5e055961$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $73fd249b5e055961$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $73fd249b5e055961$var$blockStack.length = 0;
        $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, 1);
        result = $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $h3IIu.isModelListener))) fallthroughAttrs = $73fd249b5e055961$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $73fd249b5e055961$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $73fd249b5e055961$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $73fd249b5e055961$var$isTeleport(root.type) ? $73fd249b5e055961$var$getInnerChild$1(root) || root : root;
        $73fd249b5e055961$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $73fd249b5e055961$var$setCurrentRenderingInstance(prev);
    return result;
}
const $73fd249b5e055961$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $73fd249b5e055961$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $73fd249b5e055961$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $73fd249b5e055961$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($73fd249b5e055961$export$3868d13f8734ae81(child)) {
            if (child.type !== $73fd249b5e055961$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $73fd249b5e055961$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $h3IIu.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $73fd249b5e055961$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $h3IIu.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $73fd249b5e055961$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $73fd249b5e055961$export$4d299b491347818a;
};
function $73fd249b5e055961$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $73fd249b5e055961$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($73fd249b5e055961$var$hasPropValueChanged(nextProps, prevProps, key) && !$73fd249b5e055961$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $73fd249b5e055961$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $73fd249b5e055961$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($73fd249b5e055961$var$hasPropValueChanged(nextProps, prevProps, key) && !$73fd249b5e055961$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $73fd249b5e055961$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $h3IIu.isObject)(nextProp) && (0, $h3IIu.isObject)(prevProp)) return !(0, $h3IIu.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $73fd249b5e055961$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $73fd249b5e055961$var$internalObjectProto = {};
const $73fd249b5e055961$var$createInternalObject = ()=>Object.create($73fd249b5e055961$var$internalObjectProto);
const $73fd249b5e055961$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $73fd249b5e055961$var$internalObjectProto;
function $73fd249b5e055961$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $73fd249b5e055961$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $73fd249b5e055961$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $lG4lo.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $73fd249b5e055961$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $73fd249b5e055961$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $lG4lo.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($73fd249b5e055961$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $h3IIu.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $h3IIu.camelize)(key);
                        props[camelizedKey] = $73fd249b5e055961$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($73fd249b5e055961$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $h3IIu.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $h3IIu.hyphenate)(key)) === key || !(0, $h3IIu.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $73fd249b5e055961$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $h3IIu.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $lG4lo.trigger)(instance.attrs, "set", "");
}
function $73fd249b5e055961$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $h3IIu.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $h3IIu.hasOwn)(options, camelKey = (0, $h3IIu.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$73fd249b5e055961$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $lG4lo.toRaw)(props);
        const castValues = rawCastValues || (0, $h3IIu.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $73fd249b5e055961$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $h3IIu.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $73fd249b5e055961$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $h3IIu.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $h3IIu.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $73fd249b5e055961$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $h3IIu.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $73fd249b5e055961$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $73fd249b5e055961$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $73fd249b5e055961$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $h3IIu.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $73fd249b5e055961$var$normalizePropsOptions(raw2, appContext, true);
            (0, $h3IIu.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $h3IIu.isObject)(comp)) cache.set(comp, (0, $h3IIu.EMPTY_ARR));
        return 0, $h3IIu.EMPTY_ARR;
    }
    if ((0, $h3IIu.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $h3IIu.camelize)(raw[i]);
        if ($73fd249b5e055961$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $h3IIu.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $h3IIu.camelize)(key);
        if ($73fd249b5e055961$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $h3IIu.isArray)(opt) || (0, $h3IIu.isFunction)(opt) ? {
                type: opt
            } : (0, $h3IIu.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $h3IIu.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $h3IIu.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $h3IIu.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $h3IIu.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $h3IIu.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $73fd249b5e055961$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $h3IIu.isReservedProp)(key)) return true;
    return false;
}
function $73fd249b5e055961$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $73fd249b5e055961$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $lG4lo.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $h3IIu.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $73fd249b5e055961$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $73fd249b5e055961$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $73fd249b5e055961$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $h3IIu.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $73fd249b5e055961$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $73fd249b5e055961$var$warn$1($73fd249b5e055961$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $73fd249b5e055961$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $73fd249b5e055961$var$isSimpleType = /* @__PURE__ */ (0, $h3IIu.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $73fd249b5e055961$var$assertType(value, type) {
    let valid;
    const expectedType = $73fd249b5e055961$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($73fd249b5e055961$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $h3IIu.isObject)(value);
    else if (expectedType === "Array") valid = (0, $h3IIu.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $73fd249b5e055961$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $h3IIu.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $h3IIu.toRawType)(value);
    const expectedValue = $73fd249b5e055961$var$styleValue(value, expectedType);
    const receivedValue = $73fd249b5e055961$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $73fd249b5e055961$var$isExplicable(expectedType) && $73fd249b5e055961$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($73fd249b5e055961$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $73fd249b5e055961$var$styleValue(value, type) {
    if ((0, $h3IIu.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $73fd249b5e055961$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $73fd249b5e055961$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $73fd249b5e055961$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $73fd249b5e055961$var$normalizeSlotValue = (value)=>(0, $h3IIu.isArray)(value) ? value.map($73fd249b5e055961$var$normalizeVNode) : [
        $73fd249b5e055961$var$normalizeVNode(value)
    ];
const $73fd249b5e055961$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $73fd249b5e055961$export$694b237e827a3d23((...args)=>{
        return $73fd249b5e055961$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $73fd249b5e055961$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($73fd249b5e055961$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $h3IIu.isFunction)(value)) slots[key] = $73fd249b5e055961$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $73fd249b5e055961$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $73fd249b5e055961$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $73fd249b5e055961$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $73fd249b5e055961$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$73fd249b5e055961$var$isInternalKey(key)) slots[key] = children[key];
};
const $73fd249b5e055961$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $73fd249b5e055961$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $73fd249b5e055961$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $h3IIu.def)(slots, "_", type, true);
        } else $73fd249b5e055961$var$normalizeObjectSlots(children, slots);
    } else if (children) $73fd249b5e055961$var$normalizeVNodeSlots(instance, children);
};
const $73fd249b5e055961$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $h3IIu.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $73fd249b5e055961$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $73fd249b5e055961$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $73fd249b5e055961$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$73fd249b5e055961$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $73fd249b5e055961$var$supported;
let $73fd249b5e055961$var$perf;
function $73fd249b5e055961$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $73fd249b5e055961$var$isSupported()) $73fd249b5e055961$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsPerfStart(instance, type, $73fd249b5e055961$var$isSupported() ? $73fd249b5e055961$var$perf.now() : Date.now());
}
function $73fd249b5e055961$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $73fd249b5e055961$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$73fd249b5e055961$var$formatComponentName(instance, instance.type)}> ${type}`;
        $73fd249b5e055961$var$perf.mark(endTag);
        $73fd249b5e055961$var$perf.measure(measureName, startTag, endTag);
        $73fd249b5e055961$var$perf.clearMeasures(measureName);
        $73fd249b5e055961$var$perf.clearMarks(startTag);
        $73fd249b5e055961$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsPerfEnd(instance, type, $73fd249b5e055961$var$isSupported() ? $73fd249b5e055961$var$perf.now() : Date.now());
}
function $73fd249b5e055961$var$isSupported() {
    if ($73fd249b5e055961$var$supported !== void 0) return $73fd249b5e055961$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $73fd249b5e055961$var$supported = true;
        $73fd249b5e055961$var$perf = window.performance;
    } else $73fd249b5e055961$var$supported = false;
    return $73fd249b5e055961$var$supported;
}
function $73fd249b5e055961$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $h3IIu.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $h3IIu.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $h3IIu.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $73fd249b5e055961$var$queuePostRenderEffect = $73fd249b5e055961$var$queueEffectWithSuspense;
function $73fd249b5e055961$export$53ae2f996c64e9a(options) {
    return $73fd249b5e055961$var$baseCreateRenderer(options);
}
function $73fd249b5e055961$export$200524cf0d997ff0(options) {
    return $73fd249b5e055961$var$baseCreateRenderer(options, $73fd249b5e055961$var$createHydrationFunctions);
}
function $73fd249b5e055961$var$baseCreateRenderer(options, createHydrationFns) {
    $73fd249b5e055961$var$initFeatureFlags();
    const target = (0, $h3IIu.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $h3IIu.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$73fd249b5e055961$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $73fd249b5e055961$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $73fd249b5e055961$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $73fd249b5e055961$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $73fd249b5e055961$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $73fd249b5e055961$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $73fd249b5e055961$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $73fd249b5e055961$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $h3IIu.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $h3IIu.def)(el, "__vnode", vnode, true);
            (0, $h3IIu.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $73fd249b5e055961$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $73fd249b5e055961$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $73fd249b5e055961$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $73fd249b5e055961$var$cloneIfMounted(children[i]) : $73fd249b5e055961$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $h3IIu.EMPTY_OBJ);
        const newProps = n2.props || (0, $h3IIu.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $73fd249b5e055961$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $73fd249b5e055961$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $73fd249b5e055961$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $73fd249b5e055961$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $73fd249b5e055961$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $73fd249b5e055961$var$queuePostRenderEffect(()=>{
            vnodeHook && $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $73fd249b5e055961$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $73fd249b5e055961$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$73fd249b5e055961$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $h3IIu.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $h3IIu.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $h3IIu.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $73fd249b5e055961$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $73fd249b5e055961$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($73fd249b5e055961$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $73fd249b5e055961$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($73fd249b5e055961$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $73fd249b5e055961$var$isAsyncWrapper(initialVNode);
                $73fd249b5e055961$var$toggleRecurse(instance, false);
                if (bm) (0, $h3IIu.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $73fd249b5e055961$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $73fd249b5e055961$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $73fd249b5e055961$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $73fd249b5e055961$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $73fd249b5e055961$var$queuePostRenderEffect(()=>$73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $73fd249b5e055961$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $73fd249b5e055961$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $73fd249b5e055961$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $73fd249b5e055961$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $73fd249b5e055961$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $h3IIu.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $73fd249b5e055961$var$toggleRecurse(instance, true);
                const nextTree = $73fd249b5e055961$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $73fd249b5e055961$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $73fd249b5e055961$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $73fd249b5e055961$var$queuePostRenderEffect(()=>$73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $lG4lo.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$73fd249b5e055961$var$queueJob(job);
        $73fd249b5e055961$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $73fd249b5e055961$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $73fd249b5e055961$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $lG4lo.pauseTracking)();
        $73fd249b5e055961$var$flushPreFlushCbs(instance);
        (0, $lG4lo.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $h3IIu.EMPTY_ARR);
        c2 = c2 || (0, $h3IIu.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $73fd249b5e055961$var$cloneIfMounted(c2[i]) : $73fd249b5e055961$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $73fd249b5e055961$var$cloneIfMounted(c2[i]) : $73fd249b5e055961$var$normalizeVNode(c2[i]);
            if ($73fd249b5e055961$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $73fd249b5e055961$var$cloneIfMounted(c2[e2]) : $73fd249b5e055961$var$normalizeVNode(c2[e2]);
            if ($73fd249b5e055961$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $73fd249b5e055961$var$cloneIfMounted(c2[i]) : $73fd249b5e055961$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $73fd249b5e055961$var$cloneIfMounted(c2[i]) : $73fd249b5e055961$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $73fd249b5e055961$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $73fd249b5e055961$var$getSequence(newIndexToOldIndexMap) : (0, $h3IIu.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $73fd249b5e055961$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $73fd249b5e055961$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $73fd249b5e055961$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$73fd249b5e055961$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $73fd249b5e055961$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$73fd249b5e055961$var$leaveCbKey];
                    if (el._isLeaving) el[$73fd249b5e055961$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $lG4lo.pauseTracking)();
            $73fd249b5e055961$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $lG4lo.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$73fd249b5e055961$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $73fd249b5e055961$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $73fd249b5e055961$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $73fd249b5e055961$var$queuePostRenderEffect(()=>{
            vnodeHook && $73fd249b5e055961$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $73fd249b5e055961$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $73fd249b5e055961$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $73fd249b5e055961$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $73fd249b5e055961$var$invalidateMount(m);
        $73fd249b5e055961$var$invalidateMount(a);
        if (bum) (0, $h3IIu.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $73fd249b5e055961$var$queuePostRenderEffect(um, parentSuspense);
        $73fd249b5e055961$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $73fd249b5e055961$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$73fd249b5e055961$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $73fd249b5e055961$var$flushPreFlushCbs(instance);
            $73fd249b5e055961$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $73fd249b5e055961$var$createAppAPI(render, hydrate)
    };
}
function $73fd249b5e055961$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $73fd249b5e055961$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $73fd249b5e055961$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $73fd249b5e055961$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $h3IIu.isArray)(ch1) && (0, $h3IIu.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $73fd249b5e055961$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $73fd249b5e055961$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $73fd249b5e055961$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $73fd249b5e055961$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $73fd249b5e055961$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $73fd249b5e055961$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $73fd249b5e055961$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $73fd249b5e055961$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $73fd249b5e055961$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $73fd249b5e055961$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $73fd249b5e055961$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $73fd249b5e055961$var$isSuspense = (type)=>type.__isSuspense;
let $73fd249b5e055961$var$suspenseId = 0;
const $73fd249b5e055961$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $73fd249b5e055961$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $73fd249b5e055961$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $73fd249b5e055961$var$hydrateSuspense,
    normalize: $73fd249b5e055961$var$normalizeSuspenseChildren
};
const $73fd249b5e055961$export$74bf444e3cd11ea5 = $73fd249b5e055961$var$SuspenseImpl;
function $73fd249b5e055961$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $h3IIu.isFunction)(eventListener)) eventListener();
}
function $73fd249b5e055961$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $73fd249b5e055961$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $73fd249b5e055961$var$triggerEvent(vnode, "onPending");
        $73fd249b5e055961$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $73fd249b5e055961$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $73fd249b5e055961$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($73fd249b5e055961$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $73fd249b5e055961$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $73fd249b5e055961$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $73fd249b5e055961$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $73fd249b5e055961$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $73fd249b5e055961$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $73fd249b5e055961$var$setActiveBranch(suspense, newBranch);
    } else {
        $73fd249b5e055961$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $73fd249b5e055961$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $73fd249b5e055961$var$hasWarned = false;
function $73fd249b5e055961$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $73fd249b5e055961$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $h3IIu.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $73fd249b5e055961$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $73fd249b5e055961$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $73fd249b5e055961$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $73fd249b5e055961$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $73fd249b5e055961$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $73fd249b5e055961$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $73fd249b5e055961$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $73fd249b5e055961$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $73fd249b5e055961$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $73fd249b5e055961$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $73fd249b5e055961$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $73fd249b5e055961$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $73fd249b5e055961$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $73fd249b5e055961$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $73fd249b5e055961$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $73fd249b5e055961$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $73fd249b5e055961$var$normalizeSuspenseSlot(children.fallback) : $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$4d299b491347818a);
}
function $73fd249b5e055961$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $h3IIu.isFunction)(s)) {
        const trackBlock = $73fd249b5e055961$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $73fd249b5e055961$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $73fd249b5e055961$var$currentBlock;
            $73fd249b5e055961$var$closeBlock();
        }
    }
    if ((0, $h3IIu.isArray)(s)) {
        const singleChild = $73fd249b5e055961$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $73fd249b5e055961$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $73fd249b5e055961$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $h3IIu.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $73fd249b5e055961$export$59536a0199721cab(fn);
}
function $73fd249b5e055961$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $73fd249b5e055961$var$updateHOCHostEl(parentComponent, el);
    }
}
function $73fd249b5e055961$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $73fd249b5e055961$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $73fd249b5e055961$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $73fd249b5e055961$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $73fd249b5e055961$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $73fd249b5e055961$var$blockStack = [];
let $73fd249b5e055961$var$currentBlock = null;
function $73fd249b5e055961$export$e7eaa45e502fe5cc(disableTracking = false) {
    $73fd249b5e055961$var$blockStack.push($73fd249b5e055961$var$currentBlock = disableTracking ? null : []);
}
function $73fd249b5e055961$var$closeBlock() {
    $73fd249b5e055961$var$blockStack.pop();
    $73fd249b5e055961$var$currentBlock = $73fd249b5e055961$var$blockStack[$73fd249b5e055961$var$blockStack.length - 1] || null;
}
let $73fd249b5e055961$var$isBlockTreeEnabled = 1;
function $73fd249b5e055961$export$c20bee82f26f1e27(value, inVOnce = false) {
    $73fd249b5e055961$var$isBlockTreeEnabled += value;
    if (value < 0 && $73fd249b5e055961$var$currentBlock && inVOnce) $73fd249b5e055961$var$currentBlock.hasOnce = true;
}
function $73fd249b5e055961$var$setupBlock(vnode) {
    vnode.dynamicChildren = $73fd249b5e055961$var$isBlockTreeEnabled > 0 ? $73fd249b5e055961$var$currentBlock || (0, $h3IIu.EMPTY_ARR) : null;
    $73fd249b5e055961$var$closeBlock();
    if ($73fd249b5e055961$var$isBlockTreeEnabled > 0 && $73fd249b5e055961$var$currentBlock) $73fd249b5e055961$var$currentBlock.push(vnode);
    return vnode;
}
function $73fd249b5e055961$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $73fd249b5e055961$var$setupBlock($73fd249b5e055961$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $73fd249b5e055961$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $73fd249b5e055961$var$setupBlock($73fd249b5e055961$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $73fd249b5e055961$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $73fd249b5e055961$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $73fd249b5e055961$var$vnodeArgsTransformer;
function $73fd249b5e055961$export$83beccd3afeeb809(transformer) {
    $73fd249b5e055961$var$vnodeArgsTransformer = transformer;
}
const $73fd249b5e055961$var$createVNodeWithArgsTransform = (...args)=>{
    return $73fd249b5e055961$var$_createVNode(...$73fd249b5e055961$var$vnodeArgsTransformer ? $73fd249b5e055961$var$vnodeArgsTransformer(args, $73fd249b5e055961$var$currentRenderingInstance) : args);
};
const $73fd249b5e055961$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $73fd249b5e055961$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $h3IIu.isString)(ref) || (0, $lG4lo.isRef)(ref) || (0, $h3IIu.isFunction)(ref) ? {
        i: $73fd249b5e055961$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $73fd249b5e055961$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $73fd249b5e055961$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $73fd249b5e055961$var$normalizeKey(props),
        ref: props && $73fd249b5e055961$var$normalizeRef(props),
        scopeId: $73fd249b5e055961$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $73fd249b5e055961$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $73fd249b5e055961$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $h3IIu.isString)(children) ? 8 : 16;
    if ($73fd249b5e055961$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $73fd249b5e055961$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $73fd249b5e055961$var$currentBlock.push(vnode);
    return vnode;
}
function $73fd249b5e055961$var$hasContentChildren(children) {
    if ((0, $h3IIu.isString)(children)) return children !== "";
    if ((0, $h3IIu.isArray)(children)) return children.length > 0;
    return false;
}
const $73fd249b5e055961$export$bf5c4cf060303d58 = $73fd249b5e055961$var$_createVNode;
function $73fd249b5e055961$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $73fd249b5e055961$var$NULL_DYNAMIC_COMPONENT) type = $73fd249b5e055961$export$4d299b491347818a;
    if ($73fd249b5e055961$export$3868d13f8734ae81(type)) {
        const cloned = $73fd249b5e055961$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $73fd249b5e055961$var$normalizeChildren(cloned, children);
        if ($73fd249b5e055961$var$isBlockTreeEnabled > 0 && !isBlockNode && $73fd249b5e055961$var$currentBlock) {
            if (cloned.shapeFlag & 6) $73fd249b5e055961$var$currentBlock[$73fd249b5e055961$var$currentBlock.indexOf(type)] = cloned;
            else $73fd249b5e055961$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($73fd249b5e055961$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $73fd249b5e055961$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $h3IIu.isString)(klass)) props.class = (0, $h3IIu.normalizeClass)(klass);
        if ((0, $h3IIu.isObject)(style)) {
            if ((0, $lG4lo.isProxy)(style) && !(0, $h3IIu.isArray)(style)) style = (0, $h3IIu.extend)({}, style);
            props.style = (0, $h3IIu.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $h3IIu.isString)(type) ? 1 : $73fd249b5e055961$var$isSuspense(type) ? 128 : $73fd249b5e055961$var$isTeleport(type) ? 64 : (0, $h3IIu.isObject)(type) ? 4 : (0, $h3IIu.isFunction)(type) ? 2 : 0;
    return $73fd249b5e055961$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $73fd249b5e055961$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $lG4lo.isProxy)(props) || $73fd249b5e055961$var$isInternalObject(props) ? (0, $h3IIu.extend)({}, props) : props;
}
function $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $73fd249b5e055961$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $73fd249b5e055961$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $h3IIu.isArray)(ref) ? ref.concat($73fd249b5e055961$var$normalizeRef(extraProps)) : [
            ref,
            $73fd249b5e055961$var$normalizeRef(extraProps)
        ] : $73fd249b5e055961$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $73fd249b5e055961$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $73fd249b5e055961$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $73fd249b5e055961$var$deepCloneVNode(vnode) {
    const cloned = $73fd249b5e055961$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $h3IIu.isArray)(vnode.children)) cloned.children = vnode.children.map($73fd249b5e055961$var$deepCloneVNode);
    return cloned;
}
function $73fd249b5e055961$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$5f1af8db9871e1d6, null, text, flag);
}
function $73fd249b5e055961$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $73fd249b5e055961$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($73fd249b5e055961$export$e7eaa45e502fe5cc(), $73fd249b5e055961$export$9f2dfe8048dfb22b($73fd249b5e055961$export$4d299b491347818a, null, text)) : $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$4d299b491347818a, null, text);
}
function $73fd249b5e055961$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$4d299b491347818a);
    else if ((0, $h3IIu.isArray)(child)) return $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($73fd249b5e055961$export$3868d13f8734ae81(child)) return $73fd249b5e055961$var$cloneIfMounted(child);
    else return $73fd249b5e055961$export$bf5c4cf060303d58($73fd249b5e055961$export$5f1af8db9871e1d6, null, String(child));
}
function $73fd249b5e055961$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $73fd249b5e055961$export$ee4f9e12c0a92a1a(child);
}
function $73fd249b5e055961$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $h3IIu.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $73fd249b5e055961$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$73fd249b5e055961$var$isInternalObject(children)) children._ctx = $73fd249b5e055961$var$currentRenderingInstance;
            else if (slotFlag === 3 && $73fd249b5e055961$var$currentRenderingInstance) {
                if ($73fd249b5e055961$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $h3IIu.isFunction)(children)) {
        if (shapeFlag & 65) {
            $73fd249b5e055961$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $73fd249b5e055961$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $73fd249b5e055961$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $73fd249b5e055961$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $h3IIu.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $h3IIu.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $h3IIu.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $h3IIu.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $h3IIu.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $73fd249b5e055961$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $73fd249b5e055961$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $73fd249b5e055961$var$emptyAppContext = $73fd249b5e055961$var$createAppContext();
let $73fd249b5e055961$var$uid = 0;
function $73fd249b5e055961$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $73fd249b5e055961$var$emptyAppContext;
    const instance = {
        uid: $73fd249b5e055961$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $lG4lo.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $73fd249b5e055961$var$normalizePropsOptions(type, appContext),
        emitsOptions: $73fd249b5e055961$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $h3IIu.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $h3IIu.EMPTY_OBJ),
        data: (0, $h3IIu.EMPTY_OBJ),
        props: (0, $h3IIu.EMPTY_OBJ),
        attrs: (0, $h3IIu.EMPTY_OBJ),
        slots: (0, $h3IIu.EMPTY_OBJ),
        refs: (0, $h3IIu.EMPTY_OBJ),
        setupState: (0, $h3IIu.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $73fd249b5e055961$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $73fd249b5e055961$var$currentInstance = null;
const $73fd249b5e055961$export$f13e630aa3915748 = ()=>$73fd249b5e055961$var$currentInstance || $73fd249b5e055961$var$currentRenderingInstance;
let $73fd249b5e055961$var$internalSetCurrentInstance;
let $73fd249b5e055961$var$setInSSRSetupState;
{
    const g = (0, $h3IIu.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $73fd249b5e055961$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$73fd249b5e055961$var$currentInstance = v1);
    $73fd249b5e055961$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$73fd249b5e055961$var$isInSSRComponentSetup = v1);
}const $73fd249b5e055961$var$setCurrentInstance = (instance)=>{
    const prev = $73fd249b5e055961$var$currentInstance;
    $73fd249b5e055961$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $73fd249b5e055961$var$internalSetCurrentInstance(prev);
    };
};
const $73fd249b5e055961$var$unsetCurrentInstance = ()=>{
    $73fd249b5e055961$var$currentInstance && $73fd249b5e055961$var$currentInstance.scope.off();
    $73fd249b5e055961$var$internalSetCurrentInstance(null);
};
const $73fd249b5e055961$var$isBuiltInTag = /* @__PURE__ */ (0, $h3IIu.makeMap)("slot,component");
function $73fd249b5e055961$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($73fd249b5e055961$var$isBuiltInTag(name) || isNativeTag(name)) $73fd249b5e055961$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $73fd249b5e055961$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $73fd249b5e055961$var$isInSSRComponentSetup = false;
function $73fd249b5e055961$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $73fd249b5e055961$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $73fd249b5e055961$var$isStatefulComponent(instance);
    $73fd249b5e055961$var$initProps(instance, props, isStateful, isSSR);
    $73fd249b5e055961$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $73fd249b5e055961$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $73fd249b5e055961$var$setInSSRSetupState(false);
    return setupResult;
}
function $73fd249b5e055961$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $73fd249b5e055961$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $lG4lo.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $73fd249b5e055961$var$createSetupContext(instance) : null;
        const reset = $73fd249b5e055961$var$setCurrentInstance(instance);
        const setupResult = $73fd249b5e055961$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $h3IIu.isPromise)(setupResult);
        (0, $lG4lo.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$73fd249b5e055961$var$isAsyncWrapper(instance)) $73fd249b5e055961$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($73fd249b5e055961$var$unsetCurrentInstance, $73fd249b5e055961$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $73fd249b5e055961$var$setInSSRSetupState(true);
                try {
                    $73fd249b5e055961$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $73fd249b5e055961$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $73fd249b5e055961$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $73fd249b5e055961$var$handleSetupResult(instance, setupResult, isSSR);
    } else $73fd249b5e055961$var$finishComponentSetup(instance, isSSR);
}
function $73fd249b5e055961$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $h3IIu.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $h3IIu.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $lG4lo.proxyRefs)(setupResult);
    }
    $73fd249b5e055961$var$finishComponentSetup(instance, isSSR);
}
let $73fd249b5e055961$var$compile;
let $73fd249b5e055961$var$installWithProxy;
function $73fd249b5e055961$export$667bb5a67822b941(_compile) {
    $73fd249b5e055961$var$compile = _compile;
    $73fd249b5e055961$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $73fd249b5e055961$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $73fd249b5e055961$export$c93a9c496c5211fa = ()=>!$73fd249b5e055961$var$compile;
function $73fd249b5e055961$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $73fd249b5e055961$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $73fd249b5e055961$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $h3IIu.extend)((0, $h3IIu.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $73fd249b5e055961$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $h3IIu.NOOP);
        if ($73fd249b5e055961$var$installWithProxy) $73fd249b5e055961$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $73fd249b5e055961$var$setCurrentInstance(instance);
        (0, $lG4lo.pauseTracking)();
        try {
            $73fd249b5e055961$var$applyOptions(instance);
        } finally{
            (0, $lG4lo.resetTracking)();
            reset();
        }
    }
}
const $73fd249b5e055961$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $lG4lo.track)(target, "get", "");
        return target[key];
    }
};
function $73fd249b5e055961$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $lG4lo.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $73fd249b5e055961$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $73fd249b5e055961$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $73fd249b5e055961$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $lG4lo.proxyRefs)((0, $lG4lo.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $73fd249b5e055961$var$publicPropertiesMap) return $73fd249b5e055961$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $73fd249b5e055961$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $73fd249b5e055961$var$classifyRE = /(?:^|[-_])\w/g;
const $73fd249b5e055961$var$classify = (str)=>str.replace($73fd249b5e055961$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $73fd249b5e055961$var$getComponentName(Component, includeInferred = true) {
    return (0, $h3IIu.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $73fd249b5e055961$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $73fd249b5e055961$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $73fd249b5e055961$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $73fd249b5e055961$var$isClassComponent(value) {
    return (0, $h3IIu.isFunction)(value) && "__vccOpts" in value;
}
const $73fd249b5e055961$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $lG4lo.computed)(getterOrOptions, debugOptions, $73fd249b5e055961$var$isInSSRComponentSetup);
    return c;
};
function $73fd249b5e055961$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $73fd249b5e055961$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $h3IIu.isObject)(propsOrChildren) && !(0, $h3IIu.isArray)(propsOrChildren)) {
                if ($73fd249b5e055961$export$3868d13f8734ae81(propsOrChildren)) return $73fd249b5e055961$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $73fd249b5e055961$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $73fd249b5e055961$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $73fd249b5e055961$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $73fd249b5e055961$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $73fd249b5e055961$export$c20bee82f26f1e27(1);
    }
}
function $73fd249b5e055961$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $lG4lo.toRaw)(instance.props)));
        if (instance.setupState !== (0, $h3IIu.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $h3IIu.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $lG4lo.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $h3IIu.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $h3IIu.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $lG4lo.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $h3IIu.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $h3IIu.isArray)(opts) && opts.includes(key) || (0, $h3IIu.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $lG4lo.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $73fd249b5e055961$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $73fd249b5e055961$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $73fd249b5e055961$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $h3IIu.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($73fd249b5e055961$var$isBlockTreeEnabled > 0 && $73fd249b5e055961$var$currentBlock) $73fd249b5e055961$var$currentBlock.push(cached);
    return true;
}
const $73fd249b5e055961$export$83d89fbfd8236492 = "3.5.42";
const $73fd249b5e055961$export$c106dd0671a0fc2d = (0, $h3IIu.NOOP);
const $73fd249b5e055961$export$795e0ad4a0e2ed30 = $73fd249b5e055961$var$ErrorTypeStrings$1;
const $73fd249b5e055961$export$6922d3b3a607469e = $73fd249b5e055961$var$devtools$1;
const $73fd249b5e055961$export$b0c258b32c26c785 = $73fd249b5e055961$var$setDevtoolsHook$1;
const $73fd249b5e055961$var$_ssrUtils = {
    createComponentInstance: $73fd249b5e055961$var$createComponentInstance,
    setupComponent: $73fd249b5e055961$var$setupComponent,
    renderComponentRoot: $73fd249b5e055961$var$renderComponentRoot,
    setCurrentRenderingInstance: $73fd249b5e055961$var$setCurrentRenderingInstance,
    isVNode: $73fd249b5e055961$export$3868d13f8734ae81,
    normalizeVNode: $73fd249b5e055961$var$normalizeVNode,
    getComponentPublicInstance: $73fd249b5e055961$var$getComponentPublicInstance,
    ensureValidVNode: $73fd249b5e055961$var$ensureValidVNode,
    pushWarningContext: $73fd249b5e055961$var$pushWarningContext,
    popWarningContext: $73fd249b5e055961$var$popWarningContext
};
const $73fd249b5e055961$export$a9679033567b336d = $73fd249b5e055961$var$_ssrUtils;
const $73fd249b5e055961$export$83cf26e06ea620e1 = null;
const $73fd249b5e055961$export$dc678eddf276286e = null;
const $73fd249b5e055961$export$22072a82865312f6 = null;

});
parcelRegister("lG4lo", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $fc80e3dc0372eda3$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $fc80e3dc0372eda3$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $fc80e3dc0372eda3$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $fc80e3dc0372eda3$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $fc80e3dc0372eda3$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $fc80e3dc0372eda3$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $fc80e3dc0372eda3$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $fc80e3dc0372eda3$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $fc80e3dc0372eda3$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $fc80e3dc0372eda3$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $fc80e3dc0372eda3$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $fc80e3dc0372eda3$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $fc80e3dc0372eda3$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $fc80e3dc0372eda3$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $fc80e3dc0372eda3$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $fc80e3dc0372eda3$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $fc80e3dc0372eda3$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $fc80e3dc0372eda3$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $fc80e3dc0372eda3$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $fc80e3dc0372eda3$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $fc80e3dc0372eda3$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $fc80e3dc0372eda3$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $fc80e3dc0372eda3$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $fc80e3dc0372eda3$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $fc80e3dc0372eda3$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $fc80e3dc0372eda3$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $h3IIu = parcelRequire("h3IIu");
function $fc80e3dc0372eda3$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $fc80e3dc0372eda3$var$activeEffectScope;
class $fc80e3dc0372eda3$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $fc80e3dc0372eda3$var$activeEffectScope) {
            if ($fc80e3dc0372eda3$var$activeEffectScope.active) {
                this.parent = $fc80e3dc0372eda3$var$activeEffectScope;
                this.index = ($fc80e3dc0372eda3$var$activeEffectScope.scopes || ($fc80e3dc0372eda3$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $fc80e3dc0372eda3$var$activeEffectScope;
            try {
                $fc80e3dc0372eda3$var$activeEffectScope = this;
                return fn();
            } finally{
                $fc80e3dc0372eda3$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $fc80e3dc0372eda3$var$activeEffectScope;
            $fc80e3dc0372eda3$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($fc80e3dc0372eda3$var$activeEffectScope === this) $fc80e3dc0372eda3$var$activeEffectScope = this.prevScope;
            else {
                let current = $fc80e3dc0372eda3$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $fc80e3dc0372eda3$export$7056603ea81600be(detached) {
    return new $fc80e3dc0372eda3$export$1168ed9dbc71ddbd(detached);
}
function $fc80e3dc0372eda3$export$c7be4b0125a10cba() {
    return $fc80e3dc0372eda3$var$activeEffectScope;
}
function $fc80e3dc0372eda3$export$a780418acd4762da(fn, failSilently = false) {
    if ($fc80e3dc0372eda3$var$activeEffectScope) $fc80e3dc0372eda3$var$activeEffectScope.cleanups.push(fn);
}
let $fc80e3dc0372eda3$var$activeSub;
const $fc80e3dc0372eda3$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $fc80e3dc0372eda3$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $fc80e3dc0372eda3$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($fc80e3dc0372eda3$var$activeEffectScope) {
            if ($fc80e3dc0372eda3$var$activeEffectScope.active) $fc80e3dc0372eda3$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($fc80e3dc0372eda3$var$pausedQueueEffects.has(this)) {
                $fc80e3dc0372eda3$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $fc80e3dc0372eda3$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $fc80e3dc0372eda3$var$cleanupEffect(this);
        $fc80e3dc0372eda3$var$prepareDeps(this);
        const prevEffect = $fc80e3dc0372eda3$var$activeSub;
        const prevShouldTrack = $fc80e3dc0372eda3$var$shouldTrack;
        $fc80e3dc0372eda3$var$activeSub = this;
        $fc80e3dc0372eda3$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $fc80e3dc0372eda3$var$cleanupDeps(this);
            $fc80e3dc0372eda3$var$activeSub = prevEffect;
            $fc80e3dc0372eda3$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$fc80e3dc0372eda3$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $fc80e3dc0372eda3$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $fc80e3dc0372eda3$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($fc80e3dc0372eda3$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $fc80e3dc0372eda3$var$isDirty(this);
    }
}
let $fc80e3dc0372eda3$var$batchDepth = 0;
let $fc80e3dc0372eda3$var$batchedSub;
let $fc80e3dc0372eda3$var$batchedComputed;
function $fc80e3dc0372eda3$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $fc80e3dc0372eda3$var$batchedComputed;
        $fc80e3dc0372eda3$var$batchedComputed = sub;
        return;
    }
    sub.next = $fc80e3dc0372eda3$var$batchedSub;
    $fc80e3dc0372eda3$var$batchedSub = sub;
}
function $fc80e3dc0372eda3$var$startBatch() {
    $fc80e3dc0372eda3$var$batchDepth++;
}
function $fc80e3dc0372eda3$var$endBatch() {
    if (--$fc80e3dc0372eda3$var$batchDepth > 0) return;
    if ($fc80e3dc0372eda3$var$batchedComputed) {
        let e = $fc80e3dc0372eda3$var$batchedComputed;
        $fc80e3dc0372eda3$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($fc80e3dc0372eda3$var$batchedSub){
        let e = $fc80e3dc0372eda3$var$batchedSub;
        $fc80e3dc0372eda3$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $fc80e3dc0372eda3$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $fc80e3dc0372eda3$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $fc80e3dc0372eda3$var$removeSub(link);
            $fc80e3dc0372eda3$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $fc80e3dc0372eda3$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($fc80e3dc0372eda3$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $fc80e3dc0372eda3$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $fc80e3dc0372eda3$var$globalVersion) return;
    computed.globalVersion = $fc80e3dc0372eda3$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$fc80e3dc0372eda3$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $fc80e3dc0372eda3$var$activeSub;
    const prevShouldTrack = $fc80e3dc0372eda3$var$shouldTrack;
    $fc80e3dc0372eda3$var$activeSub = computed;
    $fc80e3dc0372eda3$var$shouldTrack = true;
    try {
        $fc80e3dc0372eda3$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $h3IIu.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $fc80e3dc0372eda3$var$activeSub = prevSub;
        $fc80e3dc0372eda3$var$shouldTrack = prevShouldTrack;
        $fc80e3dc0372eda3$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $fc80e3dc0372eda3$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$fc80e3dc0372eda3$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $fc80e3dc0372eda3$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $fc80e3dc0372eda3$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $fc80e3dc0372eda3$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $fc80e3dc0372eda3$export$28352bb4dd362521(fn);
    if (options) (0, $h3IIu.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $fc80e3dc0372eda3$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $fc80e3dc0372eda3$var$shouldTrack = true;
const $fc80e3dc0372eda3$var$trackStack = [];
function $fc80e3dc0372eda3$export$938a971395fef855() {
    $fc80e3dc0372eda3$var$trackStack.push($fc80e3dc0372eda3$var$shouldTrack);
    $fc80e3dc0372eda3$var$shouldTrack = false;
}
function $fc80e3dc0372eda3$export$1f8ffc6fd33b1d16() {
    $fc80e3dc0372eda3$var$trackStack.push($fc80e3dc0372eda3$var$shouldTrack);
    $fc80e3dc0372eda3$var$shouldTrack = true;
}
function $fc80e3dc0372eda3$export$c39176b1babaa8b8() {
    const last = $fc80e3dc0372eda3$var$trackStack.pop();
    $fc80e3dc0372eda3$var$shouldTrack = last === void 0 ? true : last;
}
function $fc80e3dc0372eda3$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($fc80e3dc0372eda3$var$activeSub instanceof $fc80e3dc0372eda3$export$28352bb4dd362521) $fc80e3dc0372eda3$var$activeSub.cleanup = fn;
}
function $fc80e3dc0372eda3$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $fc80e3dc0372eda3$var$activeSub;
        $fc80e3dc0372eda3$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $fc80e3dc0372eda3$var$activeSub = prevSub;
        }
    }
}
let $fc80e3dc0372eda3$var$globalVersion = 0;
class $fc80e3dc0372eda3$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $fc80e3dc0372eda3$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$fc80e3dc0372eda3$var$activeSub || !$fc80e3dc0372eda3$var$shouldTrack || $fc80e3dc0372eda3$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $fc80e3dc0372eda3$var$activeSub) {
            link = this.activeLink = new $fc80e3dc0372eda3$var$Link($fc80e3dc0372eda3$var$activeSub, this);
            if (!$fc80e3dc0372eda3$var$activeSub.deps) $fc80e3dc0372eda3$var$activeSub.deps = $fc80e3dc0372eda3$var$activeSub.depsTail = link;
            else {
                link.prevDep = $fc80e3dc0372eda3$var$activeSub.depsTail;
                $fc80e3dc0372eda3$var$activeSub.depsTail.nextDep = link;
                $fc80e3dc0372eda3$var$activeSub.depsTail = link;
            }
            $fc80e3dc0372eda3$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $fc80e3dc0372eda3$var$activeSub.depsTail;
                link.nextDep = void 0;
                $fc80e3dc0372eda3$var$activeSub.depsTail.nextDep = link;
                $fc80e3dc0372eda3$var$activeSub.depsTail = link;
                if ($fc80e3dc0372eda3$var$activeSub.deps === link) $fc80e3dc0372eda3$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $fc80e3dc0372eda3$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $fc80e3dc0372eda3$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $fc80e3dc0372eda3$var$endBatch();
        }
    }
}
function $fc80e3dc0372eda3$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$fc80e3dc0372eda3$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $fc80e3dc0372eda3$var$targetMap = /* @__PURE__ */ new WeakMap();
const $fc80e3dc0372eda3$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $fc80e3dc0372eda3$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $fc80e3dc0372eda3$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $fc80e3dc0372eda3$export$6b2a7d5132615086(target, type, key) {
    if ($fc80e3dc0372eda3$var$shouldTrack && $fc80e3dc0372eda3$var$activeSub) {
        let depsMap = $fc80e3dc0372eda3$var$targetMap.get(target);
        if (!depsMap) $fc80e3dc0372eda3$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $fc80e3dc0372eda3$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $fc80e3dc0372eda3$var$targetMap.get(target);
    if (!depsMap) {
        $fc80e3dc0372eda3$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $fc80e3dc0372eda3$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $h3IIu.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $h3IIu.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $fc80e3dc0372eda3$export$4f926f0baab682cd || !(0, $h3IIu.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($fc80e3dc0372eda3$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($fc80e3dc0372eda3$export$3c41b1a4e06acc14));
                        if ((0, $h3IIu.isMap)(target)) run(depsMap.get($fc80e3dc0372eda3$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($fc80e3dc0372eda3$export$3c41b1a4e06acc14));
                        if ((0, $h3IIu.isMap)(target)) run(depsMap.get($fc80e3dc0372eda3$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $h3IIu.isMap)(target)) run(depsMap.get($fc80e3dc0372eda3$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $fc80e3dc0372eda3$var$endBatch();
}
function $fc80e3dc0372eda3$var$getDepFromReactive(object, key) {
    const depMap = $fc80e3dc0372eda3$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $fc80e3dc0372eda3$export$1544eab4943788e4(array) {
    const raw = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $fc80e3dc0372eda3$export$6b2a7d5132615086(raw, "iterate", $fc80e3dc0372eda3$export$4f926f0baab682cd);
    return $fc80e3dc0372eda3$export$7f3fe6025abfa26e(array) ? raw : raw.map($fc80e3dc0372eda3$export$45c769cf449a508c);
}
function $fc80e3dc0372eda3$export$5eb48af14254449e(arr) {
    $fc80e3dc0372eda3$export$6b2a7d5132615086(arr = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(arr), "iterate", $fc80e3dc0372eda3$export$4f926f0baab682cd);
    return arr;
}
function $fc80e3dc0372eda3$var$toWrapped(target, item) {
    if ($fc80e3dc0372eda3$export$92d09b48637741e7(target)) return $fc80e3dc0372eda3$export$352205f445242f02(target) ? $fc80e3dc0372eda3$export$4a78e7a2a4fb689f($fc80e3dc0372eda3$export$45c769cf449a508c(item)) : $fc80e3dc0372eda3$export$4a78e7a2a4fb689f(item);
    return $fc80e3dc0372eda3$export$45c769cf449a508c(item);
}
const $fc80e3dc0372eda3$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $fc80e3dc0372eda3$var$iterator(this, Symbol.iterator, (item)=>$fc80e3dc0372eda3$var$toWrapped(this, item));
    },
    concat (...args) {
        return $fc80e3dc0372eda3$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $h3IIu.isArray)(x) ? $fc80e3dc0372eda3$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $fc80e3dc0372eda3$var$iterator(this, "entries", (value)=>{
            value[1] = $fc80e3dc0372eda3$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$fc80e3dc0372eda3$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "find", fn, thisArg, (item)=>$fc80e3dc0372eda3$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "findLast", fn, thisArg, (item)=>$fc80e3dc0372eda3$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $fc80e3dc0372eda3$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $fc80e3dc0372eda3$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $fc80e3dc0372eda3$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $fc80e3dc0372eda3$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $fc80e3dc0372eda3$var$noTracking(this, "pop");
    },
    push (...args) {
        return $fc80e3dc0372eda3$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $fc80e3dc0372eda3$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $fc80e3dc0372eda3$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $fc80e3dc0372eda3$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $fc80e3dc0372eda3$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $fc80e3dc0372eda3$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $fc80e3dc0372eda3$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $fc80e3dc0372eda3$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $fc80e3dc0372eda3$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $fc80e3dc0372eda3$var$noTracking(this, "unshift", args);
    },
    values () {
        return $fc80e3dc0372eda3$var$iterator(this, "values", (item)=>$fc80e3dc0372eda3$var$toWrapped(this, item));
    }
};
function $fc80e3dc0372eda3$var$iterator(self, method, wrapValue) {
    const arr = $fc80e3dc0372eda3$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$fc80e3dc0372eda3$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $fc80e3dc0372eda3$var$arrayProto = Array.prototype;
function $fc80e3dc0372eda3$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $fc80e3dc0372eda3$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$fc80e3dc0372eda3$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $fc80e3dc0372eda3$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $fc80e3dc0372eda3$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $fc80e3dc0372eda3$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $fc80e3dc0372eda3$var$reduce(self, method, fn, args) {
    const arr = $fc80e3dc0372eda3$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$fc80e3dc0372eda3$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $fc80e3dc0372eda3$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $fc80e3dc0372eda3$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $fc80e3dc0372eda3$var$toWrapped(self, result) : result;
}
function $fc80e3dc0372eda3$var$searchProxy(self, method, args) {
    const arr = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(self);
    $fc80e3dc0372eda3$export$6b2a7d5132615086(arr, "iterate", $fc80e3dc0372eda3$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $fc80e3dc0372eda3$export$5f3ca29d057519b3(args[0])) {
        args[0] = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $fc80e3dc0372eda3$var$noTracking(self, method, args = []) {
    $fc80e3dc0372eda3$export$938a971395fef855();
    $fc80e3dc0372eda3$var$startBatch();
    const res = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $fc80e3dc0372eda3$var$endBatch();
    $fc80e3dc0372eda3$export$c39176b1babaa8b8();
    return res;
}
const $fc80e3dc0372eda3$var$isNonTrackableKeys = /* @__PURE__ */ (0, $h3IIu.makeMap)(`__proto__,__v_isRef,__isVue`);
const $fc80e3dc0372eda3$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $h3IIu.isSymbol)));
function $fc80e3dc0372eda3$var$hasOwnProperty(key) {
    if (!(0, $h3IIu.isSymbol)(key)) key = String(key);
    const obj = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(this);
    $fc80e3dc0372eda3$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $fc80e3dc0372eda3$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $fc80e3dc0372eda3$var$shallowReadonlyMap : $fc80e3dc0372eda3$var$readonlyMap : isShallow2 ? $fc80e3dc0372eda3$var$shallowReactiveMap : $fc80e3dc0372eda3$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $h3IIu.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $fc80e3dc0372eda3$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $fc80e3dc0372eda3$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $fc80e3dc0372eda3$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $h3IIu.isSymbol)(key) ? $fc80e3dc0372eda3$var$builtInSymbols.has(key) : $fc80e3dc0372eda3$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $fc80e3dc0372eda3$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($fc80e3dc0372eda3$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $h3IIu.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $h3IIu.isObject)(value) ? $fc80e3dc0372eda3$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $h3IIu.isObject)(res)) return isReadonly2 ? $fc80e3dc0372eda3$export$6ec456bd5b7b3c51(res) : $fc80e3dc0372eda3$export$90a44edba14e47be(res);
        return res;
    }
}
class $fc80e3dc0372eda3$var$MutableReactiveHandler extends $fc80e3dc0372eda3$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $h3IIu.isArray)(target) && (0, $h3IIu.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $fc80e3dc0372eda3$export$92d09b48637741e7(oldValue);
            if (!$fc80e3dc0372eda3$export$7f3fe6025abfa26e(value) && !$fc80e3dc0372eda3$export$92d09b48637741e7(value)) {
                oldValue = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(oldValue);
                value = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $fc80e3dc0372eda3$export$4f9f5282de18fc69(oldValue) && !$fc80e3dc0372eda3$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $h3IIu.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $fc80e3dc0372eda3$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $fc80e3dc0372eda3$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $h3IIu.hasChanged)(value, oldValue)) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $h3IIu.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $h3IIu.isSymbol)(key) || !$fc80e3dc0372eda3$var$builtInSymbols.has(key)) $fc80e3dc0372eda3$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $fc80e3dc0372eda3$export$6b2a7d5132615086(target, "iterate", (0, $h3IIu.isArray)(target) ? "length" : $fc80e3dc0372eda3$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $fc80e3dc0372eda3$var$ReadonlyReactiveHandler extends $fc80e3dc0372eda3$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $fc80e3dc0372eda3$var$mutableHandlers = /* @__PURE__ */ new $fc80e3dc0372eda3$var$MutableReactiveHandler();
const $fc80e3dc0372eda3$var$readonlyHandlers = /* @__PURE__ */ new $fc80e3dc0372eda3$var$ReadonlyReactiveHandler();
const $fc80e3dc0372eda3$var$shallowReactiveHandlers = /* @__PURE__ */ new $fc80e3dc0372eda3$var$MutableReactiveHandler(true);
const $fc80e3dc0372eda3$var$shallowReadonlyHandlers = /* @__PURE__ */ new $fc80e3dc0372eda3$var$ReadonlyReactiveHandler(true);
const $fc80e3dc0372eda3$var$toShallow = (value)=>value;
const $fc80e3dc0372eda3$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $fc80e3dc0372eda3$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $h3IIu.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $fc80e3dc0372eda3$var$toShallow : isReadonly2 ? $fc80e3dc0372eda3$export$4a78e7a2a4fb689f : $fc80e3dc0372eda3$export$45c769cf449a508c;
        !isReadonly2 && $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $fc80e3dc0372eda3$export$49093fa1cddcb78d : $fc80e3dc0372eda3$export$3c41b1a4e06acc14);
        return (0, $h3IIu.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $fc80e3dc0372eda3$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $fc80e3dc0372eda3$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(target);
            const rawKey = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $h3IIu.hasChanged)(key, rawKey)) $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "get", key);
                $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $fc80e3dc0372eda3$var$getProto(rawTarget);
            const wrap = shallow ? $fc80e3dc0372eda3$var$toShallow : readonly ? $fc80e3dc0372eda3$export$4a78e7a2a4fb689f : $fc80e3dc0372eda3$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $fc80e3dc0372eda3$export$6b2a7d5132615086($fc80e3dc0372eda3$export$ab18938b9fc5f28e(target), "iterate", $fc80e3dc0372eda3$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(target);
            const rawKey = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $h3IIu.hasChanged)(key, rawKey)) $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "has", key);
                $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $fc80e3dc0372eda3$var$toShallow : readonly ? $fc80e3dc0372eda3$export$4a78e7a2a4fb689f : $fc80e3dc0372eda3$export$45c769cf449a508c;
            !readonly && $fc80e3dc0372eda3$export$6b2a7d5132615086(rawTarget, "iterate", $fc80e3dc0372eda3$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $h3IIu.extend)(instrumentations, readonly ? {
        add: $fc80e3dc0372eda3$var$createReadonlyMethod("add"),
        set: $fc80e3dc0372eda3$var$createReadonlyMethod("set"),
        delete: $fc80e3dc0372eda3$var$createReadonlyMethod("delete"),
        clear: $fc80e3dc0372eda3$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(this);
            const proto = $fc80e3dc0372eda3$var$getProto(target);
            const rawValue = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$fc80e3dc0372eda3$export$7f3fe6025abfa26e(value) && !$fc80e3dc0372eda3$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $h3IIu.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $h3IIu.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$fc80e3dc0372eda3$export$7f3fe6025abfa26e(value) && !$fc80e3dc0372eda3$export$92d09b48637741e7(value)) value = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(value);
            const target = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $fc80e3dc0372eda3$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $h3IIu.hasChanged)(value, oldValue)) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $fc80e3dc0372eda3$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $fc80e3dc0372eda3$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $fc80e3dc0372eda3$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $fc80e3dc0372eda3$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $fc80e3dc0372eda3$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $h3IIu.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $fc80e3dc0372eda3$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $fc80e3dc0372eda3$var$createInstrumentationGetter(false, false)
};
const $fc80e3dc0372eda3$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $fc80e3dc0372eda3$var$createInstrumentationGetter(false, true)
};
const $fc80e3dc0372eda3$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $fc80e3dc0372eda3$var$createInstrumentationGetter(true, false)
};
const $fc80e3dc0372eda3$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $fc80e3dc0372eda3$var$createInstrumentationGetter(true, true)
};
function $fc80e3dc0372eda3$var$checkIdentityKeys(target, has, key) {
    const rawKey = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $h3IIu.toRawType)(target);
        $fc80e3dc0372eda3$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $fc80e3dc0372eda3$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $fc80e3dc0372eda3$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $fc80e3dc0372eda3$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $fc80e3dc0372eda3$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $fc80e3dc0372eda3$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $fc80e3dc0372eda3$export$92d09b48637741e7(target)) return target;
    return $fc80e3dc0372eda3$var$createReactiveObject(target, false, $fc80e3dc0372eda3$var$mutableHandlers, $fc80e3dc0372eda3$var$mutableCollectionHandlers, $fc80e3dc0372eda3$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$8d81cefd22d22260(target) {
    return $fc80e3dc0372eda3$var$createReactiveObject(target, false, $fc80e3dc0372eda3$var$shallowReactiveHandlers, $fc80e3dc0372eda3$var$shallowCollectionHandlers, $fc80e3dc0372eda3$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$6ec456bd5b7b3c51(target) {
    return $fc80e3dc0372eda3$var$createReactiveObject(target, true, $fc80e3dc0372eda3$var$readonlyHandlers, $fc80e3dc0372eda3$var$readonlyCollectionHandlers, $fc80e3dc0372eda3$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$7c4b5f2b50f09f6b(target) {
    return $fc80e3dc0372eda3$var$createReactiveObject(target, true, $fc80e3dc0372eda3$var$shallowReadonlyHandlers, $fc80e3dc0372eda3$var$shallowReadonlyCollectionHandlers, $fc80e3dc0372eda3$var$shallowReadonlyMap);
}
function $fc80e3dc0372eda3$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $h3IIu.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $fc80e3dc0372eda3$var$targetTypeMap((0, $h3IIu.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $fc80e3dc0372eda3$export$92d09b48637741e7(value)) return /* @__PURE__ */ $fc80e3dc0372eda3$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $fc80e3dc0372eda3$export$ab18938b9fc5f28e(raw) : observed;
}
function $fc80e3dc0372eda3$export$995ab8b13ad7a9d0(value) {
    if (!(0, $h3IIu.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $h3IIu.def)(value, "__v_skip", true);
    return value;
}
const $fc80e3dc0372eda3$export$45c769cf449a508c = (value)=>(0, $h3IIu.isObject)(value) ? /* @__PURE__ */ $fc80e3dc0372eda3$export$90a44edba14e47be(value) : value;
const $fc80e3dc0372eda3$export$4a78e7a2a4fb689f = (value)=>(0, $h3IIu.isObject)(value) ? /* @__PURE__ */ $fc80e3dc0372eda3$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$eff4d24c3ff7876e(value) {
    return $fc80e3dc0372eda3$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$9b7bc5fe3b17c8b3(value) {
    return $fc80e3dc0372eda3$var$createRef(value, true);
}
function $fc80e3dc0372eda3$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $fc80e3dc0372eda3$var$RefImpl(rawValue, shallow);
}
class $fc80e3dc0372eda3$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $fc80e3dc0372eda3$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $fc80e3dc0372eda3$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $fc80e3dc0372eda3$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $fc80e3dc0372eda3$export$7f3fe6025abfa26e(newValue) || $fc80e3dc0372eda3$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $fc80e3dc0372eda3$export$ab18938b9fc5f28e(newValue);
        if ((0, $h3IIu.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $fc80e3dc0372eda3$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $fc80e3dc0372eda3$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $fc80e3dc0372eda3$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $fc80e3dc0372eda3$export$30bdcc2218aa9458(source) {
    return (0, $h3IIu.isFunction)(source) ? source() : $fc80e3dc0372eda3$export$a239a76781616204(source);
}
const $fc80e3dc0372eda3$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $fc80e3dc0372eda3$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $fc80e3dc0372eda3$export$f353fd1b97db3fa0(objectWithRefs) {
    return $fc80e3dc0372eda3$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $fc80e3dc0372eda3$var$shallowUnwrapHandlers);
}
class $fc80e3dc0372eda3$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $fc80e3dc0372eda3$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $fc80e3dc0372eda3$export$a20c2dd6199824cb(factory) {
    return new $fc80e3dc0372eda3$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$2e9533675e5e70e0(object) {
    const ret = (0, $h3IIu.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $fc80e3dc0372eda3$var$propertyToRef(object, key);
    return ret;
}
class $fc80e3dc0372eda3$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $h3IIu.isSymbol)(key) ? key : String(key);
        this._raw = $fc80e3dc0372eda3$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $h3IIu.isArray)(_object) || (0, $h3IIu.isSymbol)(this._key) || !(0, $h3IIu.isIntegerKey)(this._key)) do shallow = !$fc80e3dc0372eda3$export$5f3ca29d057519b3(obj) || $fc80e3dc0372eda3$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $fc80e3dc0372eda3$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $fc80e3dc0372eda3$var$getDepFromReactive(this._raw, this._key);
    }
}
class $fc80e3dc0372eda3$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $fc80e3dc0372eda3$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $h3IIu.isFunction)(source)) return new $fc80e3dc0372eda3$var$GetterRefImpl(source);
    else if ((0, $h3IIu.isObject)(source) && arguments.length > 1) return $fc80e3dc0372eda3$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $fc80e3dc0372eda3$export$eff4d24c3ff7876e(source);
}
function $fc80e3dc0372eda3$var$propertyToRef(source, key, defaultValue) {
    return new $fc80e3dc0372eda3$var$ObjectRefImpl(source, key, defaultValue);
}
class $fc80e3dc0372eda3$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $fc80e3dc0372eda3$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $fc80e3dc0372eda3$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $fc80e3dc0372eda3$var$activeSub !== this) {
            $fc80e3dc0372eda3$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $fc80e3dc0372eda3$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $fc80e3dc0372eda3$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $h3IIu.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $fc80e3dc0372eda3$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $fc80e3dc0372eda3$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $fc80e3dc0372eda3$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $fc80e3dc0372eda3$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $fc80e3dc0372eda3$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $fc80e3dc0372eda3$var$INITIAL_WATCHER_VALUE = {};
const $fc80e3dc0372eda3$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $fc80e3dc0372eda3$var$activeWatcher = void 0;
function $fc80e3dc0372eda3$export$2532f7acfca7c82d() {
    return $fc80e3dc0372eda3$var$activeWatcher;
}
function $fc80e3dc0372eda3$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $fc80e3dc0372eda3$var$activeWatcher) {
    if (owner) {
        let cleanups = $fc80e3dc0372eda3$var$cleanupMap.get(owner);
        if (!cleanups) $fc80e3dc0372eda3$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $fc80e3dc0372eda3$export$3db5d71bdb2d5499(source, cb, options = (0, $h3IIu.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $fc80e3dc0372eda3$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($fc80e3dc0372eda3$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $fc80e3dc0372eda3$export$df3f009e3d155b20(source2, 1);
        return $fc80e3dc0372eda3$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($fc80e3dc0372eda3$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $fc80e3dc0372eda3$export$7f3fe6025abfa26e(source);
    } else if ($fc80e3dc0372eda3$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $h3IIu.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$fc80e3dc0372eda3$export$352205f445242f02(s) || $fc80e3dc0372eda3$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($fc80e3dc0372eda3$export$4f9f5282de18fc69(s)) return s.value;
                else if ($fc80e3dc0372eda3$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $h3IIu.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $h3IIu.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $fc80e3dc0372eda3$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $fc80e3dc0372eda3$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $fc80e3dc0372eda3$var$activeWatcher;
            $fc80e3dc0372eda3$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $fc80e3dc0372eda3$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $h3IIu.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$fc80e3dc0372eda3$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $fc80e3dc0372eda3$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $h3IIu.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($fc80e3dc0372eda3$var$INITIAL_WATCHER_VALUE) : $fc80e3dc0372eda3$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $h3IIu.hasChanged)(v, oldValue[i])) : (0, $h3IIu.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $fc80e3dc0372eda3$var$activeWatcher;
                $fc80e3dc0372eda3$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $fc80e3dc0372eda3$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $fc80e3dc0372eda3$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $fc80e3dc0372eda3$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $fc80e3dc0372eda3$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$fc80e3dc0372eda3$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $fc80e3dc0372eda3$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $fc80e3dc0372eda3$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $fc80e3dc0372eda3$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $h3IIu.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($fc80e3dc0372eda3$export$4f9f5282de18fc69(value)) $fc80e3dc0372eda3$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $h3IIu.isArray)(value)) for(let i = 0; i < value.length; i++)$fc80e3dc0372eda3$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $h3IIu.isSet)(value) || (0, $h3IIu.isMap)(value)) value.forEach((v)=>{
        $fc80e3dc0372eda3$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $h3IIu.isPlainObject)(value)) {
        for(const key in value)$fc80e3dc0372eda3$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $fc80e3dc0372eda3$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("h3IIu", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $c6b567494180c601$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $c6b567494180c601$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $c6b567494180c601$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $c6b567494180c601$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $c6b567494180c601$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $c6b567494180c601$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $c6b567494180c601$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $c6b567494180c601$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $c6b567494180c601$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $c6b567494180c601$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $c6b567494180c601$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $c6b567494180c601$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $c6b567494180c601$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $c6b567494180c601$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $c6b567494180c601$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $c6b567494180c601$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $c6b567494180c601$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $c6b567494180c601$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $c6b567494180c601$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $c6b567494180c601$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $c6b567494180c601$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $c6b567494180c601$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $c6b567494180c601$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $c6b567494180c601$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $c6b567494180c601$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $c6b567494180c601$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $c6b567494180c601$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $c6b567494180c601$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $c6b567494180c601$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $c6b567494180c601$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $c6b567494180c601$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $c6b567494180c601$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $c6b567494180c601$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $c6b567494180c601$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $c6b567494180c601$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $c6b567494180c601$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $c6b567494180c601$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $c6b567494180c601$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $c6b567494180c601$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $c6b567494180c601$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $c6b567494180c601$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $c6b567494180c601$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $c6b567494180c601$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $c6b567494180c601$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $c6b567494180c601$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $c6b567494180c601$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $c6b567494180c601$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $c6b567494180c601$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $c6b567494180c601$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $c6b567494180c601$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $c6b567494180c601$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $c6b567494180c601$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $c6b567494180c601$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $c6b567494180c601$export$cf583d23ab39677c = {};
const $c6b567494180c601$export$6bd8558f433f1cc1 = [];
const $c6b567494180c601$export$5702a91a6f42969f = ()=>{};
const $c6b567494180c601$export$c01351c0af048e39 = ()=>false;
const $c6b567494180c601$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $c6b567494180c601$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $c6b567494180c601$export$8b58be045bf06082 = Object.assign;
const $c6b567494180c601$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $c6b567494180c601$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $c6b567494180c601$export$b5a638e9b3fff9f3 = (val, key)=>$c6b567494180c601$var$hasOwnProperty.call(val, key);
const $c6b567494180c601$export$43bee75e5e14138e = Array.isArray;
const $c6b567494180c601$export$5c90113a285f2241 = (val)=>$c6b567494180c601$export$1dccc787cc36538b(val) === "[object Map]";
const $c6b567494180c601$export$6750766a7c7ec627 = (val)=>$c6b567494180c601$export$1dccc787cc36538b(val) === "[object Set]";
const $c6b567494180c601$export$871608497c498473 = (val)=>$c6b567494180c601$export$1dccc787cc36538b(val) === "[object Date]";
const $c6b567494180c601$export$49841c62b9eff15 = (val)=>$c6b567494180c601$export$1dccc787cc36538b(val) === "[object RegExp]";
const $c6b567494180c601$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $c6b567494180c601$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $c6b567494180c601$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $c6b567494180c601$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $c6b567494180c601$export$4369c812aac99591 = (val)=>{
    return ($c6b567494180c601$export$a6cdc56e425d0d0a(val) || $c6b567494180c601$export$f6e2535fb5126e54(val)) && $c6b567494180c601$export$f6e2535fb5126e54(val.then) && $c6b567494180c601$export$f6e2535fb5126e54(val.catch);
};
const $c6b567494180c601$export$830c053460e5ddf6 = Object.prototype.toString;
const $c6b567494180c601$export$1dccc787cc36538b = (value)=>$c6b567494180c601$export$830c053460e5ddf6.call(value);
const $c6b567494180c601$export$5ad0a3c360b8fbb5 = (value)=>{
    return $c6b567494180c601$export$1dccc787cc36538b(value).slice(8, -1);
};
const $c6b567494180c601$export$53b83ca8eaab0383 = (val)=>$c6b567494180c601$export$1dccc787cc36538b(val) === "[object Object]";
const $c6b567494180c601$export$e2a2b93446ec9fe = (key)=>$c6b567494180c601$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $c6b567494180c601$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $c6b567494180c601$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $c6b567494180c601$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $c6b567494180c601$var$camelizeRE = /-\w/g;
const $c6b567494180c601$export$161d051f5dd25de7 = $c6b567494180c601$var$cacheStringFunction((str)=>{
    return str.replace($c6b567494180c601$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $c6b567494180c601$var$hyphenateRE = /\B([A-Z])/g;
const $c6b567494180c601$export$6e6a0a3676c4b8bb = $c6b567494180c601$var$cacheStringFunction((str)=>str.replace($c6b567494180c601$var$hyphenateRE, "-$1").toLowerCase());
const $c6b567494180c601$export$9a00dee1beb8f576 = $c6b567494180c601$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $c6b567494180c601$export$8c022799eeaaefcd = $c6b567494180c601$var$cacheStringFunction((str)=>{
    const s = str ? `on${$c6b567494180c601$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $c6b567494180c601$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $c6b567494180c601$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $c6b567494180c601$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $c6b567494180c601$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $c6b567494180c601$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $c6b567494180c601$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $c6b567494180c601$var$_globalThis;
const $c6b567494180c601$export$ff5f2eeb11fc7e14 = ()=>{
    return $c6b567494180c601$var$_globalThis || ($c6b567494180c601$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $c6b567494180c601$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $c6b567494180c601$export$53d5e12f9a1d3cde(name) {
    return $c6b567494180c601$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $c6b567494180c601$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $c6b567494180c601$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $c6b567494180c601$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $c6b567494180c601$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $c6b567494180c601$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $c6b567494180c601$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $c6b567494180c601$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $c6b567494180c601$export$f73b8c13b7f97ebf = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$GLOBALS_ALLOWED);
const $c6b567494180c601$export$d6571a1911e4f27e = $c6b567494180c601$export$f73b8c13b7f97ebf;
const $c6b567494180c601$var$range = 2;
function $c6b567494180c601$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $c6b567494180c601$var$range; j <= i + $c6b567494180c601$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $c6b567494180c601$export$8756898546458274(value) {
    if ($c6b567494180c601$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $c6b567494180c601$export$844ec244b1367d54(item) ? $c6b567494180c601$export$76a205ce979d066a(item) : $c6b567494180c601$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($c6b567494180c601$export$844ec244b1367d54(value) || $c6b567494180c601$export$a6cdc56e425d0d0a(value)) return value;
}
const $c6b567494180c601$var$listDelimiterRE = /;(?![^(]*\))/g;
const $c6b567494180c601$var$propertyDelimiterRE = /:([^]+)/;
const $c6b567494180c601$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $c6b567494180c601$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($c6b567494180c601$var$styleCommentRE, "").split($c6b567494180c601$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($c6b567494180c601$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $c6b567494180c601$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($c6b567494180c601$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($c6b567494180c601$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $c6b567494180c601$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $c6b567494180c601$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($c6b567494180c601$export$844ec244b1367d54(value)) res = value;
    else if ($c6b567494180c601$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $c6b567494180c601$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($c6b567494180c601$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $c6b567494180c601$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$c6b567494180c601$export$844ec244b1367d54(klass)) props.class = $c6b567494180c601$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $c6b567494180c601$export$8756898546458274(style);
    return props;
}
const $c6b567494180c601$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $c6b567494180c601$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $c6b567494180c601$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $c6b567494180c601$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $c6b567494180c601$export$1ccf854a0984f890 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$HTML_TAGS);
const $c6b567494180c601$export$6328ce7565ea1049 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$SVG_TAGS);
const $c6b567494180c601$export$4a46ca4c5be17b20 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$MATH_TAGS);
const $c6b567494180c601$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$VOID_TAGS);
const $c6b567494180c601$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $c6b567494180c601$export$d186f5eb2e810715 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$specialBooleanAttrs);
const $c6b567494180c601$export$f763ba3b84e9cd8c = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8($c6b567494180c601$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $c6b567494180c601$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $c6b567494180c601$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $c6b567494180c601$var$attrValidationCache = {};
function $c6b567494180c601$export$d55ef77660f30d12(name) {
    if ($c6b567494180c601$var$attrValidationCache.hasOwnProperty(name)) return $c6b567494180c601$var$attrValidationCache[name];
    const isUnsafe = $c6b567494180c601$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $c6b567494180c601$var$attrValidationCache[name] = !isUnsafe;
}
const $c6b567494180c601$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $c6b567494180c601$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $c6b567494180c601$export$80da416f43933831 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $c6b567494180c601$export$fc0748a8e0014066 = /* @__PURE__ */ $c6b567494180c601$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $c6b567494180c601$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $c6b567494180c601$var$escapeRE = /["'&<>]/;
function $c6b567494180c601$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $c6b567494180c601$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $c6b567494180c601$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $c6b567494180c601$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($c6b567494180c601$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $c6b567494180c601$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $c6b567494180c601$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($c6b567494180c601$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $c6b567494180c601$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $c6b567494180c601$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $c6b567494180c601$var$looseCompareCollections(a, b) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $c6b567494180c601$export$ae8015769846262c(item, candidates[i])) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $c6b567494180c601$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $c6b567494180c601$export$871608497c498473(a);
    let bValidType = $c6b567494180c601$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $c6b567494180c601$export$a244864fd9645c7f(a);
    bValidType = $c6b567494180c601$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $c6b567494180c601$export$43bee75e5e14138e(a);
    bValidType = $c6b567494180c601$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $c6b567494180c601$var$looseCompareArrays(a, b) : false;
    aValidType = $c6b567494180c601$export$a6cdc56e425d0d0a(a);
    bValidType = $c6b567494180c601$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        aValidType = $c6b567494180c601$export$5c90113a285f2241(a);
        bValidType = $c6b567494180c601$export$5c90113a285f2241(b);
        if (aValidType || bValidType) return aValidType && bValidType ? $c6b567494180c601$var$looseCompareCollections(a, b) : false;
        aValidType = $c6b567494180c601$export$6750766a7c7ec627(a);
        bValidType = $c6b567494180c601$export$6750766a7c7ec627(b);
        if (aValidType || bValidType) return aValidType && bValidType ? $c6b567494180c601$var$looseCompareCollections(a, b) : false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$c6b567494180c601$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $c6b567494180c601$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$c6b567494180c601$export$ae8015769846262c(item, val));
}
const $c6b567494180c601$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $c6b567494180c601$export$b5b1545233b45293 = (val)=>{
    return $c6b567494180c601$export$844ec244b1367d54(val) ? val : val == null ? "" : $c6b567494180c601$export$43bee75e5e14138e(val) || $c6b567494180c601$export$a6cdc56e425d0d0a(val) && (val.toString === $c6b567494180c601$export$830c053460e5ddf6 || !$c6b567494180c601$export$f6e2535fb5126e54(val.toString)) ? $c6b567494180c601$var$isRef(val) ? $c6b567494180c601$export$b5b1545233b45293(val.value) : JSON.stringify(val, $c6b567494180c601$var$replacer, 2) : String(val);
};
const $c6b567494180c601$var$replacer = (_key, val)=>{
    if ($c6b567494180c601$var$isRef(val)) return $c6b567494180c601$var$replacer(_key, val.value);
    else if ($c6b567494180c601$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$c6b567494180c601$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($c6b567494180c601$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$c6b567494180c601$var$stringifySymbol(v))
    };
    else if ($c6b567494180c601$export$a244864fd9645c7f(val)) return $c6b567494180c601$var$stringifySymbol(val);
    else if ($c6b567494180c601$export$a6cdc56e425d0d0a(val) && !$c6b567494180c601$export$43bee75e5e14138e(val) && !$c6b567494180c601$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $c6b567494180c601$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $c6b567494180c601$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $c6b567494180c601$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("jE6au", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("9Xpaa")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("9Xpaa")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("9Xpaa")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("h3IIu")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("9Xpaa")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("9Xpaa")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("9Xpaa")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("9Xpaa")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("9Xpaa")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("9Xpaa")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("9Xpaa")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("9Xpaa")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("9Xpaa")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("9Xpaa")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("9Xpaa")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("9Xpaa")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("9Xpaa")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("9Xpaa")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("9Xpaa")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("lG4lo")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("9Xpaa")).nextTick);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("h3IIu")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("9Xpaa")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("9Xpaa")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("9Xpaa")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("9Xpaa")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("9Xpaa")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("9Xpaa")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("9Xpaa")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("lG4lo")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("lG4lo")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("9Xpaa")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("9Xpaa")).resolveComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("9Xpaa")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("9Xpaa")).setTransitionHooks);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("lG4lo")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("9Xpaa")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("lG4lo")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("9Xpaa")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("9Xpaa")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("9Xpaa")).watch);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("9Xpaa")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("h3IIu")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $e4d689a3bcf69601$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelText", () => $e4d689a3bcf69601$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelSelect", () => $e4d689a3bcf69601$export$87d227567b51ca39);
/**
* @vue/runtime-dom v3.5.42
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $9Xpaa = parcelRequire("9Xpaa");
var $h3IIu = parcelRequire("h3IIu");
var $lG4lo = parcelRequire("lG4lo");parcelRequire("h3IIu");
var $lG4lo = parcelRequire("lG4lo");

var $h3IIu = parcelRequire("h3IIu");
let $e4d689a3bcf69601$var$policy = void 0;
const $e4d689a3bcf69601$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($e4d689a3bcf69601$var$tt) try {
    $e4d689a3bcf69601$var$policy = /* @__PURE__ */ $e4d689a3bcf69601$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $e4d689a3bcf69601$var$unsafeToTrustedHTML = $e4d689a3bcf69601$var$policy ? (val)=>$e4d689a3bcf69601$var$policy.createHTML(val) : (val)=>val;
const $e4d689a3bcf69601$var$svgNS = "http://www.w3.org/2000/svg";
const $e4d689a3bcf69601$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $e4d689a3bcf69601$var$doc = typeof document !== "undefined" ? document : null;
const $e4d689a3bcf69601$var$templateContainer = $e4d689a3bcf69601$var$doc && /* @__PURE__ */ $e4d689a3bcf69601$var$doc.createElement("template");
const $e4d689a3bcf69601$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $e4d689a3bcf69601$var$doc.createElementNS($e4d689a3bcf69601$var$svgNS, tag) : namespace === "mathml" ? $e4d689a3bcf69601$var$doc.createElementNS($e4d689a3bcf69601$var$mathmlNS, tag) : is ? $e4d689a3bcf69601$var$doc.createElement(tag, {
            is: is
        }) : $e4d689a3bcf69601$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$e4d689a3bcf69601$var$doc.createTextNode(text),
    createComment: (text)=>$e4d689a3bcf69601$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$e4d689a3bcf69601$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $e4d689a3bcf69601$var$templateContainer.innerHTML = $e4d689a3bcf69601$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $e4d689a3bcf69601$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $e4d689a3bcf69601$var$TRANSITION = "transition";
const $e4d689a3bcf69601$var$ANIMATION = "animation";
const $e4d689a3bcf69601$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $e4d689a3bcf69601$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $e4d689a3bcf69601$var$TransitionPropsValidators = /* @__PURE__ */ (0, $h3IIu.extend)({}, (0, $9Xpaa.BaseTransitionPropsValidators), $e4d689a3bcf69601$var$DOMTransitionPropsValidators);
const $e4d689a3bcf69601$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $e4d689a3bcf69601$var$TransitionPropsValidators;
    return t;
};
const $e4d689a3bcf69601$export$be58926105124dd4 = /* @__PURE__ */ $e4d689a3bcf69601$var$decorate$1((props, { slots: slots })=>(0, $9Xpaa.h)((0, $9Xpaa.BaseTransition), $e4d689a3bcf69601$var$resolveTransitionProps(props), slots));
const $e4d689a3bcf69601$var$callHook = (hook, args = [])=>{
    if ((0, $h3IIu.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $e4d689a3bcf69601$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $h3IIu.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $e4d689a3bcf69601$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $e4d689a3bcf69601$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $e4d689a3bcf69601$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $e4d689a3bcf69601$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $e4d689a3bcf69601$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $e4d689a3bcf69601$var$removeTransitionClass(el, leaveFromClass);
        $e4d689a3bcf69601$var$removeTransitionClass(el, leaveToClass);
        $e4d689a3bcf69601$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $e4d689a3bcf69601$var$callHook(hook, [
                el,
                resolve
            ]);
            $e4d689a3bcf69601$var$nextFrame(()=>{
                $e4d689a3bcf69601$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $e4d689a3bcf69601$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$e4d689a3bcf69601$var$hasExplicitCallback(hook)) $e4d689a3bcf69601$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $h3IIu.extend)(baseProps, {
        onBeforeEnter (el) {
            $e4d689a3bcf69601$var$callHook(onBeforeEnter, [
                el
            ]);
            $e4d689a3bcf69601$var$addTransitionClass(el, enterFromClass);
            $e4d689a3bcf69601$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $e4d689a3bcf69601$var$callHook(onBeforeAppear, [
                el
            ]);
            $e4d689a3bcf69601$var$addTransitionClass(el, appearFromClass);
            $e4d689a3bcf69601$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $e4d689a3bcf69601$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $e4d689a3bcf69601$var$forceReflow(el);
                $e4d689a3bcf69601$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $e4d689a3bcf69601$var$addTransitionClass(el, leaveActiveClass);
                $e4d689a3bcf69601$var$forceReflow(el);
            }
            $e4d689a3bcf69601$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $e4d689a3bcf69601$var$removeTransitionClass(el, leaveFromClass);
                $e4d689a3bcf69601$var$addTransitionClass(el, leaveToClass);
                if (!$e4d689a3bcf69601$var$hasExplicitCallback(onLeave)) $e4d689a3bcf69601$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $e4d689a3bcf69601$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $e4d689a3bcf69601$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $e4d689a3bcf69601$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $e4d689a3bcf69601$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $e4d689a3bcf69601$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $h3IIu.isObject)(duration)) return [
        $e4d689a3bcf69601$var$NumberOf(duration.enter),
        $e4d689a3bcf69601$var$NumberOf(duration.leave)
    ];
    else {
        const n = $e4d689a3bcf69601$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $e4d689a3bcf69601$var$NumberOf(val) {
    const res = (0, $h3IIu.toNumber)(val);
    return res;
}
function $e4d689a3bcf69601$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$e4d689a3bcf69601$var$vtcKey] || (el[$e4d689a3bcf69601$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $e4d689a3bcf69601$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$e4d689a3bcf69601$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$e4d689a3bcf69601$var$vtcKey] = void 0;
    }
}
function $e4d689a3bcf69601$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $e4d689a3bcf69601$var$endId = 0;
function $e4d689a3bcf69601$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$e4d689a3bcf69601$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $e4d689a3bcf69601$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $e4d689a3bcf69601$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$e4d689a3bcf69601$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$e4d689a3bcf69601$var$TRANSITION}Duration`);
    const transitionTimeout = $e4d689a3bcf69601$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$e4d689a3bcf69601$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$e4d689a3bcf69601$var$ANIMATION}Duration`);
    const animationTimeout = $e4d689a3bcf69601$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $e4d689a3bcf69601$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $e4d689a3bcf69601$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $e4d689a3bcf69601$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $e4d689a3bcf69601$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $e4d689a3bcf69601$var$TRANSITION : $e4d689a3bcf69601$var$ANIMATION : null;
        propCount = type ? type === $e4d689a3bcf69601$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $e4d689a3bcf69601$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$e4d689a3bcf69601$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $e4d689a3bcf69601$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$e4d689a3bcf69601$var$toMs(d) + $e4d689a3bcf69601$var$toMs(delays[i])));
}
function $e4d689a3bcf69601$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $e4d689a3bcf69601$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $e4d689a3bcf69601$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$e4d689a3bcf69601$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $e4d689a3bcf69601$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $e4d689a3bcf69601$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $e4d689a3bcf69601$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$e4d689a3bcf69601$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $e4d689a3bcf69601$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $e4d689a3bcf69601$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $e4d689a3bcf69601$var$setDisplay(el, false);
            });
        } else $e4d689a3bcf69601$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $e4d689a3bcf69601$var$setDisplay(el, value);
    }
};
function $e4d689a3bcf69601$var$setDisplay(el, value) {
    el.style.display = value ? el[$e4d689a3bcf69601$var$vShowOriginalDisplay] : "none";
    el[$e4d689a3bcf69601$var$vShowHidden] = !value;
}
function $e4d689a3bcf69601$var$initVShowForSSR() {
    $e4d689a3bcf69601$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $e4d689a3bcf69601$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $e4d689a3bcf69601$export$ef28b76f07940108(getter) {
    const instance = (0, $9Xpaa.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$e4d689a3bcf69601$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $e4d689a3bcf69601$var$setVarsOnNode(instance.ce, vars);
        else $e4d689a3bcf69601$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $9Xpaa.onBeforeUpdate)(()=>{
        (0, $9Xpaa.queuePostFlushCb)(setVars);
    });
    (0, $9Xpaa.onMounted)(()=>{
        (0, $9Xpaa.watch)(setVars, (0, $h3IIu.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $9Xpaa.onUnmounted)(()=>ob.disconnect());
    });
}
function $e4d689a3bcf69601$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $e4d689a3bcf69601$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $e4d689a3bcf69601$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $9Xpaa.Fragment)) vnode.children.forEach((c)=>$e4d689a3bcf69601$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $9Xpaa.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $e4d689a3bcf69601$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $e4d689a3bcf69601$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $h3IIu.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$e4d689a3bcf69601$var$CSS_VAR_TEXT] = cssText;
    }
}
const $e4d689a3bcf69601$var$displayRE = /(?:^|;)\s*display\s*:/;
function $e4d689a3bcf69601$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $h3IIu.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $h3IIu.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $e4d689a3bcf69601$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $e4d689a3bcf69601$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$e4d689a3bcf69601$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $h3IIu.isString)(prev) && prev ? prev[key] : void 0, value)) $e4d689a3bcf69601$var$setStyle(style, key, value);
            } else $e4d689a3bcf69601$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$e4d689a3bcf69601$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $e4d689a3bcf69601$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($e4d689a3bcf69601$var$vShowOriginalDisplay in el) {
        el[$e4d689a3bcf69601$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$e4d689a3bcf69601$var$vShowHidden]) style.display = "none";
    }
}
const $e4d689a3bcf69601$var$semicolonRE = /[^\\];\s*$/;
const $e4d689a3bcf69601$var$importantRE = /\s*!important$/;
function $e4d689a3bcf69601$var$setStyle(style, name, val) {
    if ((0, $h3IIu.isArray)(val)) val.forEach((v)=>$e4d689a3bcf69601$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) {
            if ($e4d689a3bcf69601$var$importantRE.test(val)) style.setProperty(name, val.replace($e4d689a3bcf69601$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $e4d689a3bcf69601$var$autoPrefix(style, name);
            if ($e4d689a3bcf69601$var$importantRE.test(val)) style.setProperty((0, $h3IIu.hyphenate)(prefixed), val.replace($e4d689a3bcf69601$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $e4d689a3bcf69601$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $e4d689a3bcf69601$var$prefixCache = {};
function $e4d689a3bcf69601$var$autoPrefix(style, rawName) {
    const cached = $e4d689a3bcf69601$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $h3IIu.camelize)(rawName);
    if (name !== "filter" && name in style) return $e4d689a3bcf69601$var$prefixCache[rawName] = name;
    name = (0, $h3IIu.capitalize)(name);
    for(let i = 0; i < $e4d689a3bcf69601$var$prefixes.length; i++){
        const prefixed = $e4d689a3bcf69601$var$prefixes[i] + name;
        if (prefixed in style) return $e4d689a3bcf69601$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $e4d689a3bcf69601$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $h3IIu.isString)(next) && prev === next;
}
const $e4d689a3bcf69601$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $e4d689a3bcf69601$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $h3IIu.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($e4d689a3bcf69601$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($e4d689a3bcf69601$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $h3IIu.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $h3IIu.isSymbol)(value) ? String(value) : value);
}
function $e4d689a3bcf69601$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $e4d689a3bcf69601$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $h3IIu.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $e4d689a3bcf69601$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $e4d689a3bcf69601$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $e4d689a3bcf69601$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $e4d689a3bcf69601$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$e4d689a3bcf69601$var$veiKey] || (el[$e4d689a3bcf69601$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $e4d689a3bcf69601$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $e4d689a3bcf69601$var$createInvoker(nextValue, instance);
            $e4d689a3bcf69601$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $e4d689a3bcf69601$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $e4d689a3bcf69601$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $e4d689a3bcf69601$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $e4d689a3bcf69601$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($e4d689a3bcf69601$var$optionsModifierRE)) && !$e4d689a3bcf69601$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $h3IIu.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $e4d689a3bcf69601$var$cachedNow = 0;
const $e4d689a3bcf69601$var$p = /* @__PURE__ */ Promise.resolve();
const $e4d689a3bcf69601$var$getNow = ()=>$e4d689a3bcf69601$var$cachedNow || ($e4d689a3bcf69601$var$p.then(()=>$e4d689a3bcf69601$var$cachedNow = 0), $e4d689a3bcf69601$var$cachedNow = Date.now());
function $e4d689a3bcf69601$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $h3IIu.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $9Xpaa.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $9Xpaa.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $e4d689a3bcf69601$var$getNow();
    return invoker;
}
function $e4d689a3bcf69601$var$sanitizeEventValue(value, propName) {
    if ((0, $h3IIu.isFunction)(value) || (0, $h3IIu.isArray)(value)) return value;
    (0, $9Xpaa.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $h3IIu.NOOP;
}
const $e4d689a3bcf69601$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $e4d689a3bcf69601$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $e4d689a3bcf69601$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $e4d689a3bcf69601$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $h3IIu.isOn)(key)) {
        if (!(0, $h3IIu.isModelListener)(key)) $e4d689a3bcf69601$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $e4d689a3bcf69601$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $e4d689a3bcf69601$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $e4d689a3bcf69601$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($e4d689a3bcf69601$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $h3IIu.isString)(nextValue)))) $e4d689a3bcf69601$var$patchDOMProp(el, (0, $h3IIu.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $e4d689a3bcf69601$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $e4d689a3bcf69601$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $e4d689a3bcf69601$var$isNativeOn(key) && (0, $h3IIu.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($e4d689a3bcf69601$var$isNativeOn(key) && (0, $h3IIu.isString)(value)) return false;
    return key in el;
}
function $e4d689a3bcf69601$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $h3IIu.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $h3IIu.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $h3IIu.camelize)(prop) === camelKey);
}
const $e4d689a3bcf69601$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $e4d689a3bcf69601$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $9Xpaa.defineComponent)(options, extraOptions);
    if ((0, $h3IIu.isPlainObject)(Comp)) Comp = (0, $h3IIu.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $e4d689a3bcf69601$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $e4d689a3bcf69601$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $e4d689a3bcf69601$export$a00e2346eabbdbef(options, extraOptions, $e4d689a3bcf69601$export$35800275c0037383);
};
const $e4d689a3bcf69601$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $e4d689a3bcf69601$export$b337c1a55163dbe3 extends $e4d689a3bcf69601$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $e4d689a3bcf69601$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $e4d689a3bcf69601$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $h3IIu.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $e4d689a3bcf69601$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $9Xpaa.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $h3IIu.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $h3IIu.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $h3IIu.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $h3IIu.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $lG4lo.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $h3IIu.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $h3IIu.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $e4d689a3bcf69601$var$REMOVAL;
        const camelKey = (0, $h3IIu.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $h3IIu.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $e4d689a3bcf69601$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $h3IIu.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $h3IIu.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $h3IIu.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $e4d689a3bcf69601$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $9Xpaa.createVNode)(this._def, (0, $h3IIu.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $h3IIu.isPlainObject)(args[0]) ? (0, $h3IIu.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $h3IIu.hyphenate)(event) !== event) dispatch((0, $h3IIu.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $e4d689a3bcf69601$export$da5acfe93a94e37d(caller) {
    const instance = (0, $9Xpaa.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $9Xpaa.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $9Xpaa.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $e4d689a3bcf69601$export$64d45095031fa749() {
    const el = $e4d689a3bcf69601$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $e4d689a3bcf69601$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $9Xpaa.getCurrentInstance)();
        if (!instance) return 0, $h3IIu.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $h3IIu.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $h3IIu.EMPTY_OBJ;
        return mod;
    }
}
const $e4d689a3bcf69601$var$positionMap = /* @__PURE__ */ new WeakMap();
const $e4d689a3bcf69601$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $e4d689a3bcf69601$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $e4d689a3bcf69601$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $e4d689a3bcf69601$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $e4d689a3bcf69601$var$TransitionGroupImpl = /* @__PURE__ */ $e4d689a3bcf69601$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $h3IIu.extend)({}, $e4d689a3bcf69601$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $9Xpaa.getCurrentInstance)();
        const state = (0, $9Xpaa.useTransitionState)();
        let prevChildren;
        let children;
        (0, $9Xpaa.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$e4d689a3bcf69601$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($e4d689a3bcf69601$var$callPendingCbs);
            prevChildren.forEach($e4d689a3bcf69601$var$recordPosition);
            const movedChildren = prevChildren.filter($e4d689a3bcf69601$var$applyTranslation);
            $e4d689a3bcf69601$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $e4d689a3bcf69601$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$e4d689a3bcf69601$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$e4d689a3bcf69601$var$moveCbKey] = null;
                        $e4d689a3bcf69601$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $lG4lo.toRaw)(props);
            const cssTransitionProps = $e4d689a3bcf69601$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $9Xpaa.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$e4d689a3bcf69601$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $9Xpaa.setTransitionHooks)(child, (0, $9Xpaa.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $e4d689a3bcf69601$var$positionMap.set(child, $e4d689a3bcf69601$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $9Xpaa.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $9Xpaa.setTransitionHooks)(child, (0, $9Xpaa.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $9Xpaa.createVNode)(tag, null, children);
        };
    }
});
const $e4d689a3bcf69601$export$19ffa8f511f7bc2e = $e4d689a3bcf69601$var$TransitionGroupImpl;
function $e4d689a3bcf69601$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$e4d689a3bcf69601$var$moveCbKey]) el[$e4d689a3bcf69601$var$moveCbKey]();
    if (el[$e4d689a3bcf69601$var$enterCbKey]) el[$e4d689a3bcf69601$var$enterCbKey]();
}
function $e4d689a3bcf69601$var$recordPosition(c) {
    $e4d689a3bcf69601$var$newPositionMap.set(c, $e4d689a3bcf69601$var$getPosition(c.el));
}
function $e4d689a3bcf69601$var$applyTranslation(c) {
    const oldPos = $e4d689a3bcf69601$var$positionMap.get(c);
    const newPos = $e4d689a3bcf69601$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $e4d689a3bcf69601$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $e4d689a3bcf69601$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$e4d689a3bcf69601$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $e4d689a3bcf69601$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $e4d689a3bcf69601$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $h3IIu.isArray)(fn) ? (value)=>(0, $h3IIu.invokeArrayFns)(fn, value) : fn;
};
function $e4d689a3bcf69601$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $e4d689a3bcf69601$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $e4d689a3bcf69601$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $e4d689a3bcf69601$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $e4d689a3bcf69601$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $h3IIu.looseToNumber)(value);
    return value;
}
const $e4d689a3bcf69601$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$e4d689a3bcf69601$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$e4d689a3bcf69601$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $e4d689a3bcf69601$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$e4d689a3bcf69601$var$assignKey]($e4d689a3bcf69601$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $e4d689a3bcf69601$var$addEventListener(el, "change", ()=>{
            el.value = $e4d689a3bcf69601$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $e4d689a3bcf69601$var$addEventListener(el, "compositionstart", $e4d689a3bcf69601$var$onCompositionStart);
            $e4d689a3bcf69601$var$addEventListener(el, "compositionend", $e4d689a3bcf69601$var$onCompositionEnd);
            $e4d689a3bcf69601$var$addEventListener(el, "change", $e4d689a3bcf69601$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$e4d689a3bcf69601$var$initialValueKey];
        delete el[$e4d689a3bcf69601$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$e4d689a3bcf69601$var$assignKey]($e4d689a3bcf69601$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $h3IIu.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $e4d689a3bcf69601$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        $e4d689a3bcf69601$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $e4d689a3bcf69601$var$getValue(el);
            const checked = el.checked;
            const assign = el[$e4d689a3bcf69601$var$assignKey];
            if ((0, $h3IIu.isArray)(modelValue)) {
                const index = (0, $h3IIu.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $h3IIu.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($e4d689a3bcf69601$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $e4d689a3bcf69601$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        $e4d689a3bcf69601$var$setChecked(el, binding, vnode);
    }
};
function $e4d689a3bcf69601$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $h3IIu.isArray)(value)) checked = (0, $h3IIu.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $h3IIu.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $h3IIu.looseEqual)(value, $e4d689a3bcf69601$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $e4d689a3bcf69601$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $h3IIu.looseEqual)(value, vnode.props.value);
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        $e4d689a3bcf69601$var$addEventListener(el, "change", ()=>{
            el[$e4d689a3bcf69601$var$assignKey]($e4d689a3bcf69601$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $h3IIu.looseEqual)(value, vnode.props.value);
    }
};
const $e4d689a3bcf69601$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $e4d689a3bcf69601$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $h3IIu.looseToNumber)($e4d689a3bcf69601$var$getValue(o)) : $e4d689a3bcf69601$var$getValue(o));
            const multiple = el.multiple;
            const assignedValue = multiple ? (0, $h3IIu.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
            const pending = el._pendingValue = [
                multiple,
                multiple ? (0, $h3IIu.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
            ];
            try {
                el[$e4d689a3bcf69601$var$assignKey](assignedValue);
            } finally{
                (0, $9Xpaa.nextTick)(()=>{
                    if (el._pendingValue === pending) el._pendingValue = void 0;
                });
            }
        });
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $e4d689a3bcf69601$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$e4d689a3bcf69601$var$assignKey] = $e4d689a3bcf69601$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        const pending = el._pendingValue;
        el._pendingValue = void 0;
        if (!pending || pending[0] !== el.multiple || !$e4d689a3bcf69601$var$isSameSelectValue(value, pending[1], pending[0])) $e4d689a3bcf69601$var$setSelected(el, value);
    }
};
function $e4d689a3bcf69601$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $h3IIu.looseEqual)(value, assignedValue);
    if ((0, $h3IIu.isArray)(value)) return (0, $h3IIu.looseEqual)(value, assignedValue);
    if ((0, $h3IIu.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue){
            if (!value.has(item)) return false;
        }
        return true;
    }
    return false;
}
function $e4d689a3bcf69601$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $h3IIu.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $h3IIu.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $e4d689a3bcf69601$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $h3IIu.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $h3IIu.looseEqual)($e4d689a3bcf69601$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $e4d689a3bcf69601$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $e4d689a3bcf69601$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $e4d689a3bcf69601$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $e4d689a3bcf69601$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $e4d689a3bcf69601$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $e4d689a3bcf69601$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $e4d689a3bcf69601$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $e4d689a3bcf69601$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $e4d689a3bcf69601$export$87d227567b51ca39;
        case "TEXTAREA":
            return $e4d689a3bcf69601$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $e4d689a3bcf69601$export$8847c2e532b35714;
                case "radio":
                    return $e4d689a3bcf69601$export$b4356c59b38b7aa9;
                default:
                    return $e4d689a3bcf69601$export$f1f88689f5728478;
            }
    }
}
function $e4d689a3bcf69601$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $e4d689a3bcf69601$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $e4d689a3bcf69601$var$initVModelForSSR() {
    $e4d689a3bcf69601$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $e4d689a3bcf69601$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $h3IIu.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $e4d689a3bcf69601$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $h3IIu.isArray)(value)) {
            if (vnode.props && (0, $h3IIu.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $h3IIu.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $e4d689a3bcf69601$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $e4d689a3bcf69601$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $e4d689a3bcf69601$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $e4d689a3bcf69601$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$e4d689a3bcf69601$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $e4d689a3bcf69601$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $e4d689a3bcf69601$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $e4d689a3bcf69601$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $e4d689a3bcf69601$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $h3IIu.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $e4d689a3bcf69601$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $e4d689a3bcf69601$var$rendererOptions = /* @__PURE__ */ (0, $h3IIu.extend)({
    patchProp: $e4d689a3bcf69601$export$cd4aa0842d13df8b
}, $e4d689a3bcf69601$export$de4fb7f5030605d3);
let $e4d689a3bcf69601$var$renderer;
let $e4d689a3bcf69601$var$enabledHydration = false;
function $e4d689a3bcf69601$var$ensureRenderer() {
    return $e4d689a3bcf69601$var$renderer || ($e4d689a3bcf69601$var$renderer = (0, $9Xpaa.createRenderer)($e4d689a3bcf69601$var$rendererOptions));
}
function $e4d689a3bcf69601$var$ensureHydrationRenderer() {
    $e4d689a3bcf69601$var$renderer = $e4d689a3bcf69601$var$enabledHydration ? $e4d689a3bcf69601$var$renderer : (0, $9Xpaa.createHydrationRenderer)($e4d689a3bcf69601$var$rendererOptions);
    $e4d689a3bcf69601$var$enabledHydration = true;
    return $e4d689a3bcf69601$var$renderer;
}
const $e4d689a3bcf69601$export$b3890eb0ae9dca99 = (...args)=>{
    $e4d689a3bcf69601$var$ensureRenderer().render(...args);
};
const $e4d689a3bcf69601$export$fa8d919ba61d84db = (...args)=>{
    $e4d689a3bcf69601$var$ensureHydrationRenderer().hydrate(...args);
};
const $e4d689a3bcf69601$export$4e373c34abfa8c68 = (...args)=>{
    const app = $e4d689a3bcf69601$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $e4d689a3bcf69601$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $h3IIu.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $e4d689a3bcf69601$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $e4d689a3bcf69601$export$35800275c0037383 = (...args)=>{
    const app = $e4d689a3bcf69601$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $e4d689a3bcf69601$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $e4d689a3bcf69601$var$resolveRootNamespace(container));
    };
    return app;
};
function $e4d689a3bcf69601$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $e4d689a3bcf69601$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $h3IIu.isHTMLTag)(tag) || (0, $h3IIu.isSVGTag)(tag) || (0, $h3IIu.isMathMLTag)(tag),
        writable: false
    });
}
function $e4d689a3bcf69601$var$injectCompilerOptionsCheck(app) {
    if ((0, $9Xpaa.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $9Xpaa.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $9Xpaa.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $9Xpaa.warn)(msg);
            }
        });
    }
}
function $e4d689a3bcf69601$var$normalizeContainer(container) {
    if ((0, $h3IIu.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $e4d689a3bcf69601$var$ssrDirectiveInitialized = false;
const $e4d689a3bcf69601$export$800b28255aa678d9 = ()=>{
    if (!$e4d689a3bcf69601$var$ssrDirectiveInitialized) {
        $e4d689a3bcf69601$var$ssrDirectiveInitialized = true;
        $e4d689a3bcf69601$var$initVModelForSSR();
        $e4d689a3bcf69601$var$initVShowForSSR();
    }
};

});


parcelRegister("4b4cS", function(module, exports) {

$parcel$export(module.exports, "DualShock4", () => (parcelRequire("dU9dn")).DualShock4);

var $dU9dn = parcelRequire("dU9dn");

var $jSPWQ = parcelRequire("jSPWQ");

var $kPTNl = parcelRequire("kPTNl");

var $lYAPA = parcelRequire("lYAPA");

var $aYIaT = parcelRequire("aYIaT");

});
parcelRegister("dU9dn", function(module, exports) {

$parcel$export(module.exports, "DualShock4", () => $41d1ff5698eea87e$export$45c71639568778b2);

var $ajkXJ = parcelRequire("ajkXJ");

var $has1r = parcelRequire("has1r");

var $jSPWQ = parcelRequire("jSPWQ");

var $a27ji = parcelRequire("a27ji");

var $etdYl = parcelRequire("etdYl");

var $34ia2 = parcelRequire("34ia2");

var $cFNGV = parcelRequire("cFNGV");

var $4TzKh = parcelRequire("4TzKh");

var $eNhXT = parcelRequire("eNhXT");

var $62Nu6 = parcelRequire("62Nu6");
const $41d1ff5698eea87e$var$accessoryEvents = [
    [
        'headphonesConnected',
        'headphonesconnect',
        'headphonesdisconnect'
    ],
    [
        'microphoneConnected',
        'microphoneconnect',
        'microphonedisconnect'
    ],
    [
        'externalDeviceConnected',
        'externaldeviceconnect',
        'externaldevicedisconnect'
    ]
];
class $41d1ff5698eea87e$export$45c71639568778b2 extends EventTarget {
    addEventListener(type, callback, options) {
        super.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        super.removeEventListener(type, callback, options);
    }
    firmwareInfoRequest = 0;
    inputReportSequence = 0;
    accessoryStateKnown = false;
    cloneCheck;
    /** Internal WebHID device */ get device() {
        return this.connection.device;
    }
    set device(device) {
        if (device === this.device) return;
        this.cancelCloneCheck();
        this.connection.device = device;
        this.clearAccessoryConnections();
        if (device?.opened) this.audio.attach();
        else this.audio.reset();
        if (device) this.output.attach(device, this.connection.session?.signal);
        else this.output.clear(new DOMException('Controller disconnected.', 'AbortError'));
    }
    /** Raw contents of the last HID Report sent by the controller. */ lastReport;
    /** Raw contents of the last HID Report sent to the controller. */ lastSentReport;
    /** Firmware metadata reported by the connected controller, or `null` when unavailable. */ firmwareInfo = null;
    /**
   * Sony certificate and random-challenge signature check over USB or Bluetooth.
   * `false` means both signatures verified, `true` means a signature failed.
   * `null` means unknown (pending, unsupported, I/O failure or timeout).
   * Background completion emits `clonecheck` after this field is updated.
   * Copied authentic controller keys cannot be distinguished by this check.
   */ isClone = null;
    /**
   * Whether background authentication is running for the current controller.
   * False before starting, after completion (including an unknown result),
   * and immediately after cancellation. Already false in `clonecheck` listeners.
   */ get isCloneChecking() {
        return Boolean(this.cloneCheck && !this.cloneCheck.abort.signal.aborted);
    }
    /** Current controller state */ state = (0, $34ia2.createDefaultState)();
    /** Allows lightbar control */ lightbar = new (0, $cFNGV.default)(()=>this.requestOutputUpdate());
    /** Allows rumble control */ rumble = new (0, $4TzKh.default)(()=>this.requestOutputUpdate());
    /** Hardware audio levels and optional browser headphone playback/microphone capture. */ audio = new (0, $jSPWQ.DualShock4Audio)(()=>({
            device: this.device,
            transport: this.state.interface,
            disconnecting: this.connection.isDisconnecting
        }), ()=>this.requestOutputUpdate());
    output = new (0, $eNhXT.OutputController)(()=>({
            transport: this.state.interface,
            rumble: this.rumble,
            lightbar: this.lightbar,
            audio: {
                headphonesLeft: this.audio.headphones.volumeLeft,
                headphonesRight: this.audio.headphones.volumeRight,
                speaker: this.audio.speaker.volume,
                microphone: this.audio.microphone.volume
            }
        }), (raw)=>{
        this.lastSentReport = raw;
    });
    connection = new (0, $a27ji.ConnectionController)({
        opened: (session)=>this.handleConnectionOpened(session),
        initialize: ()=>this.readFirmwareInfo(),
        input: (report)=>this.processControllerReport(report),
        connected: (device)=>this.emit('connect', {
                device: device
            }),
        cleared: (device, reason, announced)=>this.handleConnectionCleared(device, reason, announced),
        prepareClose: ()=>this.prepareConnectionClose()
    });
    constructor(){
        super();
        if (!navigator.hid || !navigator.hid.requestDevice) throw new Error('WebHID not supported by browser or not available.');
    }
    /**
   * Requests access to a controller and opens its WebHID session.
   *
   * This function must be called in the context of user interaction
   * (i.e in a click event handler), otherwise it might not work.
   * Firmware reading is bounded by one second; authentication runs in the
   * background and does not delay connection or the `connect` event.
   *
   * @returns `true` when the controller is connected, or `false` when device selection is cancelled.
   */ connect() {
        return this.connection.connect();
    }
    /**
   * Reads DualShock 4 feature report 0xA3, updates {@link firmwareInfo}, and
   * starts background authentication without waiting for its result.
   *
   * Both USB and Bluetooth controllers use this report. The firmware request
   * times out after one second. A separate authentication exchange using
   * 0xF0/0xF2/0xF1 verifies the Sony certificate and challenge signature, with
   * a total 30-second deadline. Concurrent checks share one exchange. While
   * pending, {@link isCloneChecking} is `true` and {@link isClone} is `null`; completion updates it and emits
   * `clonecheck`. Subscribe before connecting or refreshing to observe results.
   * Unsupported, timed out, or malformed firmware reports return `null`;
   * authentication failures do not prevent compatible controllers connecting.
   */ async readFirmwareInfo() {
        const device = this.device;
        if (!device || !device.opened) throw new Error('Controller not connected. You must call .connect() first!');
        if (this.connection.isDisconnecting) throw new DOMException('Controller disconnecting.', 'InvalidStateError');
        const request = ++this.firmwareInfoRequest;
        const session = this.connection.session;
        const firmwareInfo = await (0, $ajkXJ.readControllerFirmware)(device, session?.signal);
        if (request === this.firmwareInfoRequest && this.connection.session === session && !session?.signal.aborted && device.opened && !this.connection.isDisconnecting) {
            this.firmwareInfo = firmwareInfo;
            this.startCloneCheck(device, session);
        }
        return firmwareInfo;
    }
    startCloneCheck(device, session) {
        if (this.cloneCheck?.device === device && this.cloneCheck.session === session) return;
        this.cancelCloneCheck();
        const check = {
            device: device,
            session: session,
            abort: new AbortController()
        };
        this.cloneCheck = check;
        const cancel = ()=>check.abort.abort(session?.signal.reason);
        session?.signal.addEventListener('abort', cancel, {
            once: true
        });
        if (session?.signal.aborted) cancel();
        const complete = (isClone)=>{
            session?.signal.removeEventListener('abort', cancel);
            if (this.cloneCheck !== check) return;
            this.cloneCheck = undefined;
            if (this.connection.session !== session || this.device !== device || check.abort.signal.aborted || !device.opened || this.connection.isDisconnecting) return;
            this.isClone = isClone;
            this.emit('clonecheck', {
                device: device,
                isClone: isClone
            });
        };
        (0, $has1r.authenticateController)(device, check.abort.signal).then(complete, ()=>complete(null));
    }
    cancelCloneCheck() {
        const check = this.cloneCheck;
        this.cloneCheck = undefined;
        check?.abort.abort(new DOMException('Controller authentication cancelled.', 'AbortError'));
        this.isClone = null;
    }
    /**
   * Stops rumble and closes the current WebHID session without revoking device
   * permission. Pending output that is waiting for transport detection rejects
   * with an `AbortError`.
   *
   * If the browser fails to close a device that remains open, the active session
   * is restored and the error is rethrown so disconnection can be retried.
   */ disconnect() {
        return this.connection.disconnect();
    }
    emit(type, detail) {
        return this.dispatchEvent(new CustomEvent(type, {
            detail: detail
        }));
    }
    handleConnectionOpened(session) {
        this.cancelCloneCheck();
        this.clearAccessoryConnections();
        this.audio.attach();
        this.state.interface = (0, $34ia2.DualShock4Interface).Disconnected;
        this.output.attach(session.device, session.signal);
        this.firmwareInfo = null;
        this.isClone = null;
    }
    handleConnectionCleared(device, reason, announced) {
        this.cancelCloneCheck();
        this.audio.reset();
        this.firmwareInfoRequest++;
        this.output.clear(new DOMException('Controller disconnected.', 'AbortError'));
        this.rumble.reset();
        this.lastReport = undefined;
        this.lastSentReport = undefined;
        this.firmwareInfo = null;
        this.isClone = null;
        this.state = (0, $34ia2.createDefaultState)();
        this.accessoryStateKnown = false;
        if (announced) this.emit('disconnect', {
            device: device,
            reason: reason
        });
    }
    prepareConnectionClose() {
        this.cancelCloneCheck();
        this.audio.reset();
        const previousInterface = this.state.interface;
        this.rumble.setRumbleIntensity(0, 0).catch(()=>{});
        this.output.cancelPending(new DOMException('Controller disconnected.', 'AbortError'));
        this.state.interface = (0, $34ia2.DualShock4Interface).Disconnected;
        return {
            pending: this.output.drain(),
            restore: ()=>{
                this.state.interface = previousInterface;
                this.audio.attach();
            }
        };
    }
    clearAccessoryConnections() {
        this.accessoryStateKnown = false;
        for (const [key] of $41d1ff5698eea87e$var$accessoryEvents)this.state[key] = false;
    }
    /** Routes validated input into state updates and transport initialization. */ processControllerReport(report) {
        if (report.device !== this.device) return;
        const data = (0, $62Nu6.normalizeInputReport)(report.reportId, report.data, report.device.collections);
        this.lastReport = report.data.buffer.slice(report.data.byteOffset, report.data.byteOffset + report.data.byteLength);
        if (report.reportId === (0, $etdYl.bluetoothInputReportId) && !(0, $62Nu6.isValidBluetoothInputReport)(data)) return;
        // Interface is unknown
        if (this.state.interface === (0, $34ia2.DualShock4Interface).Disconnected) {
            const transport = (0, $62Nu6.detectInputInterface)(report.reportId, data);
            if (!transport) return;
            this.initializeTransport(transport);
        }
        const stateData = (0, $62Nu6.getInputStateData)(report.reportId, data, this.state.interface);
        if (!stateData) return;
        const session = this.connection.session;
        const sequence = ++this.inputReportSequence;
        const previous = $41d1ff5698eea87e$var$accessoryEvents.map(([key])=>this.state[key]);
        this.state.timestamp = report.timeStamp;
        (0, $62Nu6.updateControllerState)(this.state, stateData);
        if ((0, $62Nu6.isMinimalBluetoothReport)(report.reportId, data)) return;
        const initial = !this.accessoryStateKnown;
        this.accessoryStateKnown = true;
        const current = $41d1ff5698eea87e$var$accessoryEvents.map(([key])=>this.state[key]);
        for (const [index, [, connected, disconnected]] of $41d1ff5698eea87e$var$accessoryEvents.entries()){
            if (initial ? !current[index] : previous[index] === current[index]) continue;
            // A listener may replace/disconnect the session or process a newer report.
            if (this.connection.session !== session || this.device !== report.device || session?.signal.aborted || this.connection.isDisconnecting || !report.device.opened || this.inputReportSequence !== sequence) return;
            this.emit(current[index] ? connected : disconnected, {
                device: report.device,
                initial: initial
            });
        }
    }
    initializeTransport(transport) {
        this.state.interface = transport;
        if (transport === (0, $34ia2.DualShock4Interface).USB && !this.output.hasPendingOutput) // Player 1 color, unless an early output update already supplies a color.
        this.lightbar.setColorRGB(0, 0, 64).catch((error)=>console.error(error));
        this.output.markReady();
        if (transport === (0, $34ia2.DualShock4Interface).Bluetooth) this.device?.receiveFeatureReport(0x02).catch((error)=>console.error(error));
    }
    /**
   * Sends the local rumble, lightbar and configured hardware volumes to the controller.
   *
   * This function is called automatically in most cases. Output requested before
   * the first supported input report is combined and sent once the interface is known.
   */ async sendLocalState() {
        if (!this.device) throw new Error('Controller not connected. You must call .connect() first!');
        if (this.connection.isDisconnecting) throw new DOMException('Controller disconnecting.', 'InvalidStateError');
        return this.output.send();
    }
    requestOutputUpdate() {
        if (!this.device) throw new Error('Controller not connected. You must call .connect() first!');
        return this.sendLocalState();
    }
}

});
parcelRegister("ajkXJ", function(module, exports) {

$parcel$export(module.exports, "readControllerFirmware", () => $9e3485c151d4c1bb$export$a7d68bf95837434b);
/**
 * @module
 * @internal
 */ 
var $3gwD3 = parcelRequire("3gwD3");

var $k7RdL = parcelRequire("k7RdL");

var $i0qIe = parcelRequire("i0qIe");
const $9e3485c151d4c1bb$var$featureReportTimeoutMs = 1000;
async function $9e3485c151d4c1bb$export$a7d68bf95837434b(device, signal) {
    try {
        const report = await (0, $3gwD3.receiveFeatureReport)(device, (0, $k7RdL.firmwareFeatureReportId), {
            timeoutMs: $9e3485c151d4c1bb$var$featureReportTimeoutMs,
            signal: signal
        });
        return (0, $i0qIe.parseFirmwareInfo)(report);
    } catch  {
        return null;
    }
}

});
parcelRegister("3gwD3", function(module, exports) {

$parcel$export(module.exports, "receiveFeatureReport", () => $fbfb859a205d9f1b$export$9c80eff0c880bbcb);
/**
 * @module
 * @internal
 */ /** Reads one feature report and releases timeout/abort resources on every exit. */ function $fbfb859a205d9f1b$export$9c80eff0c880bbcb(device, reportId, { timeoutMs: timeoutMs, signal: signal }) {
    return new Promise((resolve, reject)=>{
        signal?.throwIfAborted();
        let settled = false;
        const complete = (action)=>{
            if (settled) return;
            settled = true;
            clearTimeout(timeout);
            signal?.removeEventListener('abort', abort);
            action();
        };
        const fail = (error)=>complete(()=>reject(error));
        const abort = ()=>fail(signal?.reason);
        const timeout = setTimeout(()=>{
            fail(new DOMException('Feature report request timed out.', 'TimeoutError'));
        }, timeoutMs);
        signal?.addEventListener('abort', abort, {
            once: true
        });
        try {
            device.receiveFeatureReport(reportId).then((report)=>complete(()=>resolve(report)), fail);
        } catch (error) {
            fail(error);
        }
    });
}

});

parcelRegister("k7RdL", function(module, exports) {

$parcel$export(module.exports, "firmwareFeatureReportId", () => $1ee5a4f5cfc490d6$export$525e39cf299d88a9);
/**
 * @module
 * @internal
 */ const $1ee5a4f5cfc490d6$export$525e39cf299d88a9 = 0xA3;

});

parcelRegister("i0qIe", function(module, exports) {

$parcel$export(module.exports, "parseFirmwareInfo", () => $4430d417f2660aa8$export$1cd0037139b8a068);

var $k7RdL = parcelRequire("k7RdL");
const $4430d417f2660aa8$var$firmwarePayloadLength = 48;
const $4430d417f2660aa8$var$firmwareFullReportLength = $4430d417f2660aa8$var$firmwarePayloadLength + 1;
const $4430d417f2660aa8$var$buildDateOffset = 0;
const $4430d417f2660aa8$var$buildTimeOffset = 16;
const $4430d417f2660aa8$var$buildStringLength = 16;
const $4430d417f2660aa8$var$hardwareVersionOffset = 34;
const $4430d417f2660aa8$var$firmwareVersionOffset = 40;
function $4430d417f2660aa8$var$readBuildString(data, offset) {
    let value = '';
    for(let index = 0; index < $4430d417f2660aa8$var$buildStringLength; index++){
        const byte = data.getUint8(offset + index);
        if (byte === 0) break;
        if (byte < 0x20 || byte > 0x7E) return null;
        value += String.fromCharCode(byte);
    }
    value = value.trim();
    return value || null;
}
function $4430d417f2660aa8$var$toHexVersion(version) {
    return `0x${version.toString(16).toUpperCase().padStart(4, '0')}`;
}
function $4430d417f2660aa8$var$boardModelFromHardwareVersion(version) {
    const revision = version >> 8;
    if (revision === 0x31) return 'JDM-001';
    if (revision === 0x43) return 'JDM-011';
    if (revision === 0x54) return 'JDM-030';
    if (revision >= 0x64 && revision <= 0x74) return 'JDM-040';
    if (revision >= 0x81 && revision <= 0x83 || revision === 0x93) return 'JDM-020';
    if (revision === 0x90 || revision === 0xA0 || revision === 0xA4) return 'JDM-050';
    if (revision === 0xB0 || revision === 0xB4) return 'JDM-055';
    return null;
}
function $4430d417f2660aa8$export$1cd0037139b8a068(data) {
    let payloadOffset;
    if (data.byteLength === $4430d417f2660aa8$var$firmwarePayloadLength) payloadOffset = 0;
    else if (data.byteLength === $4430d417f2660aa8$var$firmwareFullReportLength && data.getUint8(0) === (0, $k7RdL.firmwareFeatureReportId)) payloadOffset = 1;
    else return null;
    const buildDate = $4430d417f2660aa8$var$readBuildString(data, payloadOffset + $4430d417f2660aa8$var$buildDateOffset);
    const buildTime = $4430d417f2660aa8$var$readBuildString(data, payloadOffset + $4430d417f2660aa8$var$buildTimeOffset);
    if (!buildDate || !buildTime) return null;
    const hardwareVersion = data.getUint16(payloadOffset + $4430d417f2660aa8$var$hardwareVersionOffset, true);
    const firmwareVersion = data.getUint16(payloadOffset + $4430d417f2660aa8$var$firmwareVersionOffset, true);
    return {
        buildDate: buildDate,
        buildTime: buildTime,
        hardwareVersion: hardwareVersion,
        hardwareVersionHex: $4430d417f2660aa8$var$toHexVersion(hardwareVersion),
        boardModel: $4430d417f2660aa8$var$boardModelFromHardwareVersion(hardwareVersion),
        firmwareVersion: firmwareVersion,
        firmwareVersionHex: $4430d417f2660aa8$var$toHexVersion(firmwareVersion)
    };
}

});


parcelRegister("has1r", function(module, exports) {

$parcel$export(module.exports, "authenticateController", () => $96aa593100097071$export$4d685b24319c26c1);
/**
 * @module
 * @internal
 */ 
var $8T54A = parcelRequire("8T54A");

var $7IuVh = parcelRequire("7IuVh");

var $1P1rY = parcelRequire("1P1rY");
// The captured PS4 Bluetooth authentication exchange takes about 30 seconds.
// https://www.psdevwiki.com/ps4/DS4-BT#HID_features_reports
const $96aa593100097071$var$authenticationTimeoutMs = 30000;
const $96aa593100097071$var$readinessPollMs = 100;
const $96aa593100097071$var$active = new WeakMap();
const $96aa593100097071$var$sequences = new WeakMap();
function $96aa593100097071$var$pause(signal) {
    return new Promise((resolve, reject)=>{
        signal.throwIfAborted();
        const abort = ()=>{
            clearTimeout(timer);
            reject(signal.reason);
        };
        const timer = setTimeout(()=>{
            signal.removeEventListener('abort', abort);
            resolve();
        }, $96aa593100097071$var$readinessPollMs);
        signal.addEventListener('abort', abort, {
            once: true
        });
    });
}
function $96aa593100097071$export$4d685b24319c26c1(device, signal) {
    const transport = (0, $1P1rY.authenticationTransport)(device);
    if (signal?.aborted || !transport.supported || !globalThis.crypto?.subtle) return Promise.resolve(null);
    const previous = $96aa593100097071$var$active.get(device);
    if (previous) return previous.signal === signal && !previous.finished ? previous.result : Promise.resolve(null);
    const task = {
        signal: signal,
        result: Promise.resolve(null),
        finished: false,
        pending: 0
    };
    $96aa593100097071$var$active.set(device, task);
    const release = ()=>{
        if (task.finished && task.pending === 0 && $96aa593100097071$var$active.get(device) === task) $96aa593100097071$var$active.delete(device);
    };
    const abort = new AbortController();
    const cancel = ()=>abort.abort(signal?.reason);
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    const timer = setTimeout(()=>abort.abort(new DOMException('Authentication timed out.', 'TimeoutError')), $96aa593100097071$var$authenticationTimeoutMs);
    // A native WebHID operation cannot be cancelled. Keep the device reserved
    // until it settles, even if our deadline/cancellation has already returned.
    const io = async (operation)=>{
        abort.signal.throwIfAborted();
        const pending = operation();
        task.pending++;
        pending.then(()=>{
            task.pending--;
            release();
        }, ()=>{
            task.pending--;
            release();
        });
        return (0, $8T54A.abortable)(pending, abort.signal);
    };
    const run = async ()=>{
        const sequence = ($96aa593100097071$var$sequences.get(device) ?? 0) % 255 + 1;
        $96aa593100097071$var$sequences.set(device, sequence);
        const challenge = crypto.getRandomValues(new Uint8Array(256));
        for(let page = 0; page < 5; page++)await io(()=>device.sendFeatureReport((0, $1P1rY.challengeReportId), (0, $1P1rY.challengePage)(challenge, sequence, page, transport.bluetooth)));
        while(true){
            const report = (0, $1P1rY.authenticationReport)(await io(()=>device.receiveFeatureReport((0, $1P1rY.statusReportId))), (0, $1P1rY.statusReportId), transport.bluetooth);
            if (report[1] !== sequence) throw new Error('Unexpected authentication sequence.');
            if (report[2] === 0) break;
            if (report[2] !== 0x10 && report[2] !== 0x01) throw new Error('Invalid authentication status.');
            await $96aa593100097071$var$pause(abort.signal);
        }
        const response = new Uint8Array(1040);
        for(let page = 0; page < 19; page++){
            const report = (0, $1P1rY.authenticationReport)(await io(()=>device.receiveFeatureReport((0, $1P1rY.responseReportId))), (0, $1P1rY.responseReportId), transport.bluetooth);
            if (report[1] !== sequence || report[2] !== page || report[3] !== 0) throw new Error('Unexpected authentication response page.');
            response.set(report.subarray(4, 4 + Math.min((0, $1P1rY.pageLength), response.length - page * (0, $1P1rY.pageLength))), page * (0, $1P1rY.pageLength));
        }
        abort.signal.throwIfAborted();
        return !await (0, $8T54A.abortable)((0, $7IuVh.verifyAuthenticationResponse)(challenge, response), abort.signal);
    };
    task.result = run().catch(()=>null).finally(()=>{
        task.finished = true;
        clearTimeout(timer);
        signal?.removeEventListener('abort', cancel);
        release();
    });
    return task.result;
}

});
parcelRegister("8T54A", function(module, exports) {

$parcel$export(module.exports, "abortable", () => $850d6461c897d640$export$930d1888c9e0cd90);
/** Rejects on cancellation without cancelling the underlying browser operation. */ function $850d6461c897d640$export$930d1888c9e0cd90(operation, signal) {
    return new Promise((resolve, reject)=>{
        const abort = ()=>{
            signal.removeEventListener('abort', abort);
            reject(signal.reason);
        };
        signal.addEventListener('abort', abort, {
            once: true
        });
        if (signal.aborted) abort();
        operation.then(resolve, reject).finally(()=>signal.removeEventListener('abort', abort));
    });
}

});

parcelRegister("7IuVh", function(module, exports) {

$parcel$export(module.exports, "verifyAuthenticationResponse", () => $b4ad7cb0a5f953a9$export$29778d0c87e48204);
/**
 * @module
 * @internal
 */ // Sony's Jedi CA public key. Only this pinned authority may certify a controller.
// Source: https://github.com/chrepl/ds4/blob/master/jedi_crypto-mod.py
// SPKI SHA-256: e5e095e643b5688b400c757b4c44efacc2936148e5cebd6c6d410f54f1487f49
const $b4ad7cb0a5f953a9$var$sonyAuthority = {
    kty: 'RSA',
    e: 'AQAB',
    n: 'jtf55KpcxdIxlvDeeX3-rPY-3nvJZxbxPPUq3vjaz6jiM9xlVxc0fUyMgm6rkDYW_5-4-XM2F_vUTsgQeK1uJLBiYZ9aF-4vVXK0J8A0qUk2PobTshM1H4kEpJn4YkAfTmCsITHNS7n939WQyOIrffltAVpBxUnz6g3t_DLOwy1yxTSTSu890StY2zV90E2akxGjgz_4VXoLhbRUzSHauQ1xSuot7ELm9O8gRTz22_OVTnOodpHPoD9HWUVci5bx0Lad091iYulDjcwmls_mS5MMbn1OAVH20bFdGkvi5g8LNhGMYPJT_bziJ6ikyc3yJghYWEq41xxinNQh7GZgWQ'
};
const $b4ad7cb0a5f953a9$var$rsaAlgorithm = {
    name: 'RSA-PSS',
    hash: 'SHA-256'
};
const $b4ad7cb0a5f953a9$var$signatureAlgorithm = {
    name: 'RSA-PSS',
    saltLength: 32
};
function $b4ad7cb0a5f953a9$var$unsignedBase64Url(bytes) {
    let start = 0;
    while(start < bytes.length - 1 && bytes[start] === 0)start++;
    return btoa(String.fromCharCode(...bytes.subarray(start))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $b4ad7cb0a5f953a9$export$29778d0c87e48204(challenge, response) {
    const authority = await crypto.subtle.importKey('jwk', $b4ad7cb0a5f953a9$var$sonyAuthority, $b4ad7cb0a5f953a9$var$rsaAlgorithm, false, [
        'verify'
    ]);
    const identity = response.slice(256, 784);
    if (!await crypto.subtle.verify($b4ad7cb0a5f953a9$var$signatureAlgorithm, authority, response.slice(784, 1040), identity)) return false;
    try {
        const controller = await crypto.subtle.importKey('jwk', {
            kty: 'RSA',
            n: $b4ad7cb0a5f953a9$var$unsignedBase64Url(response.subarray(272, 528)),
            e: $b4ad7cb0a5f953a9$var$unsignedBase64Url(response.subarray(528, 784))
        }, $b4ad7cb0a5f953a9$var$rsaAlgorithm, false, [
            'verify'
        ]);
        return await crypto.subtle.verify($b4ad7cb0a5f953a9$var$signatureAlgorithm, controller, response.slice(0, 256), challenge);
    } catch (error) {
        // Invalid certified RSA parameters are a failed proof; platform failures
        // propagate so the caller can keep authenticity unknown.
        if (error instanceof DOMException && error.name === 'DataError') return false;
        throw error;
    }
}

});

parcelRegister("1P1rY", function(module, exports) {

$parcel$export(module.exports, "challengeReportId", () => $eac1268f8e06548d$export$276d01b4761ba974);
$parcel$export(module.exports, "responseReportId", () => $eac1268f8e06548d$export$c95c67e4a0f41f83);
$parcel$export(module.exports, "statusReportId", () => $eac1268f8e06548d$export$4a913f910ce9cc91);
$parcel$export(module.exports, "pageLength", () => $eac1268f8e06548d$export$dc93d5428945bf1a);
$parcel$export(module.exports, "authenticationTransport", () => $eac1268f8e06548d$export$519531f60d422a0a);
$parcel$export(module.exports, "challengePage", () => $eac1268f8e06548d$export$67803be24e06c265);
$parcel$export(module.exports, "authenticationReport", () => $eac1268f8e06548d$export$1447e5fd65b809c1);
/**
 * @module
 * @internal
 */ 
var $etdYl = parcelRequire("etdYl");

var $4bh06 = parcelRequire("4bh06");
const $eac1268f8e06548d$export$276d01b4761ba974 = 0xF0;
const $eac1268f8e06548d$export$c95c67e4a0f41f83 = 0xF1;
const $eac1268f8e06548d$export$4a913f910ce9cc91 = 0xF2;
const $eac1268f8e06548d$export$dc93d5428945bf1a = 56;
function $eac1268f8e06548d$var$collections(items) {
    return items.flatMap((item)=>[
            item,
            ...$eac1268f8e06548d$var$collections(item.children ?? [])
        ]);
}
function $eac1268f8e06548d$export$519531f60d422a0a(device) {
    const all = $eac1268f8e06548d$var$collections(device.collections);
    return {
        supported: [
            $eac1268f8e06548d$export$276d01b4761ba974,
            $eac1268f8e06548d$export$c95c67e4a0f41f83,
            $eac1268f8e06548d$export$4a913f910ce9cc91
        ].every((id)=>all.some((item)=>item.featureReports?.some((report)=>report.reportId === id))),
        bluetooth: all.some((item)=>item.inputReports?.some((report)=>report.reportId === (0, $etdYl.bluetoothInputReportId)))
    };
}
function $eac1268f8e06548d$var$checksum(report, bluetooth, sending) {
    // Bluetooth HIDP SET_REPORT / DATA headers participate in the feature CRC.
    // https://www.psdevwiki.com/ps4/DS4-BT#HID_features_reports
    return (0, $4bh06.crc32)(bluetooth ? Uint8Array.from([
        sending ? 0x53 : 0xA3,
        ...report
    ]) : report);
}
function $eac1268f8e06548d$export$67803be24e06c265(challenge, sequence, page, bluetooth) {
    const report = new Uint8Array(64);
    report[0] = $eac1268f8e06548d$export$276d01b4761ba974;
    report[1] = sequence;
    report[2] = page;
    report.set(challenge.subarray(page * $eac1268f8e06548d$export$dc93d5428945bf1a, (page + 1) * $eac1268f8e06548d$export$dc93d5428945bf1a), 4);
    new DataView(report.buffer).setUint32(60, $eac1268f8e06548d$var$checksum(report.subarray(0, 60), bluetooth, true), true);
    // WebHID supplies the report ID separately, unlike hidapi.
    return report.subarray(1);
}
function $eac1268f8e06548d$export$1447e5fd65b809c1(data, reportId, bluetooth) {
    const length = reportId === $eac1268f8e06548d$export$4a913f910ce9cc91 ? 16 : 64;
    let report;
    if (data.byteLength === length - 1) report = Uint8Array.from([
        reportId,
        ...new Uint8Array(data.buffer, data.byteOffset, data.byteLength)
    ]);
    else if (data.getUint8(0) === reportId && (data.byteLength === length || reportId === $eac1268f8e06548d$export$4a913f910ce9cc91 && data.byteLength === 64 && new Uint8Array(data.buffer, data.byteOffset + length, 64 - length).every((byte)=>byte === 0))) report = new Uint8Array(data.buffer, data.byteOffset, length).slice();
    else throw new Error('Invalid authentication report length or ID.');
    const expected = new DataView(report.buffer).getUint32(length - 4, true);
    if ($eac1268f8e06548d$var$checksum(report.subarray(0, -4), bluetooth, false) !== expected) throw new Error('Invalid authentication CRC.');
    return report;
}

});
parcelRegister("etdYl", function(module, exports) {

$parcel$export(module.exports, "bluetoothInputReportId", () => $79d691426a95a538$export$de545b7351c68fb7);
/**
 * @module
 * @internal
 */ const $79d691426a95a538$export$de545b7351c68fb7 = 0x11;

});

parcelRegister("4bh06", function(module, exports) {

$parcel$export(module.exports, "crc32", () => $2dcdb9dd03bfe20d$export$1cd93882633e45f5);
/** Calculates an unsigned CRC-32 checksum for binary data. */ function $2dcdb9dd03bfe20d$export$1cd93882633e45f5(data) {
    let crc = 0xFFFFFFFF;
    for (const byte of data){
        crc ^= byte;
        for(let bit = 0; bit < 8; bit++)crc = crc >>> 1 ^ 0xEDB88320 & -(crc & 1);
    }
    return (crc ^ 0xFFFFFFFF) >>> 0;
}

});



parcelRegister("jSPWQ", function(module, exports) {

$parcel$export(module.exports, "DualShock4Audio", () => $7a757a4163b635f4$export$7fea5a0c2417b93);

var $lYAPA = parcelRequire("lYAPA");

var $aYIaT = parcelRequire("aYIaT");

var $kPTNl = parcelRequire("kPTNl");
class $7a757a4163b635f4$export$7fea5a0c2417b93 {
    /** Hardware volume of the built-in mono speaker. */ speaker;
    /** Stereo headphones connected to the controller's 3.5 mm jack. */ headphones;
    /** Microphone of a headset connected to the controller's 3.5 mm jack. */ microphone;
    /** @internal */ constructor(getController, requestOutputUpdate){
        this.speaker = new (0, $kPTNl.DualShock4Speaker)(requestOutputUpdate);
        this.headphones = new (0, $lYAPA.DualShock4Headphones)(getController, requestOutputUpdate);
        this.microphone = new (0, $aYIaT.DualShock4Microphone)(getController, requestOutputUpdate);
    }
    /** Observe audio endpoints for a new HID session without requesting permissions. @internal */ attach() {
        this.speaker.reset();
        this.headphones.attach();
        this.microphone.attach();
    }
    /** Release all controller audio resources. */ reset() {
        this.speaker.reset();
        this.headphones.reset();
        this.microphone.reset();
    }
}

});
parcelRegister("lYAPA", function(module, exports) {

$parcel$export(module.exports, "DualShock4Headphones", () => $ce221e84bce82ba9$export$fba25490e2f49ea0);

var $8T54A = parcelRequire("8T54A");

var $5T3WD = parcelRequire("5T3WD");

var $dSvR3 = parcelRequire("dSvR3");
class $ce221e84bce82ba9$export$fba25490e2f49ea0 extends EventTarget {
    getController;
    requestVolumeUpdate;
    context;
    source;
    selectedId;
    failure;
    operation;
    playback;
    mediaDevices;
    deviceChangeVersion;
    leftVolume;
    rightVolume;
    volumeRequests;
    /** @internal */ constructor(getController, requestVolumeUpdate){
        super(), this.getController = getController, this.requestVolumeUpdate = requestVolumeUpdate, this.selectedId = null, this.operation = new AbortController(), this.playback = new AbortController(), this.deviceChangeVersion = 0, this.leftVolume = null, this.rightVolume = null, this.volumeRequests = new AbortController(), this.onDeviceChange = ()=>{
            const version = ++this.deviceChangeVersion;
            const signal = this.operation.signal;
            const devices = this.mediaDevices;
            if (!devices) return;
            devices.enumerateDevices().then((outputs)=>{
                if (signal.aborted || version !== this.deviceChangeVersion) return;
                if (this.selectedId && !outputs.some((device)=>(0, $dSvR3.isConcreteOutput)(device) && device.deviceId === this.selectedId)) {
                    this.clearRoute();
                    this.failure = 'output-unavailable';
                }
                this.changed();
            }).catch(()=>{
                if (signal.aborted || version !== this.deviceChangeVersion) return;
                this.clearRoute();
                this.failure = 'enumeration-failed';
                this.changed();
            });
        };
    }
    /** Last requested left-channel HID volume (0-255), or null before configuration/after reset.
   * This is a local cache, not a hardware readback or acknowledgement.
   */ get volumeLeft() {
        return this.leftVolume;
    }
    set volumeLeft(value) {
        this.setChannelVolume('left', value).catch((error)=>console.error(error));
    }
    /** Last requested right-channel HID volume (0-255), or null before configuration/after reset. */ get volumeRight() {
        return this.rightVolume;
    }
    set volumeRight(value) {
        this.setChannelVolume('right', value).catch((error)=>console.error(error));
    }
    /** Set raw headphone HID volume bytes, independently of browser routing/playback.
   * Right defaults to left. Finite values are clamped to 0-255 and rounded.
   * Resolves when the HID report is sent; rejects on output failure or reset.
   */ async setVolume(left, right = left) {
        const volumeLeft = (0, $5T3WD.normalizeHardwareVolume)(left);
        const volumeRight = (0, $5T3WD.normalizeHardwareVolume)(right);
        const update = this.requireVolumeControl();
        this.leftVolume = volumeLeft;
        this.rightVolume = volumeRight;
        const signal = this.volumeRequests.signal;
        return (0, $8T54A.abortable)(update(), signal);
    }
    async setChannelVolume(channel, value) {
        const volume = (0, $5T3WD.normalizeHardwareVolume)(value);
        const update = this.requireVolumeControl();
        if (channel === 'left') this.leftVolume = volume;
        else this.rightVolume = volume;
        const signal = this.volumeRequests.signal;
        return (0, $8T54A.abortable)(update(), signal);
    }
    requireVolumeControl() {
        if (!this.requestVolumeUpdate) throw new DOMException('Hardware volume control requires a controller output callback.', 'NotSupportedError');
        return this.requestVolumeUpdate;
    }
    /** Explicitly selected output, or null before successful routing/after invalidation. */ get outputDeviceId() {
        return this.selectedId;
    }
    /** Passive check: never requests permission, creates an AudioContext, or plays sound.
   * A hidden/incomplete device list yields null, not a false hardware diagnosis.
   * True establishes routing, not inserted headphones or audible sound.
   */ async checkSupport() {
        const controller = this.getController();
        const info = (0, $dSvR3.connectionInfo)(controller);
        const result = (supported, reason, outputs = [])=>({
                ...info,
                supported: supported,
                reason: reason,
                outputs: outputs
            });
        if (!controller.device?.opened || controller.disconnecting) return result(false, 'controller-disconnected');
        const problem = (0, $dSvR3.audioApiProblem)();
        if (problem) return result(false, problem);
        const signal = this.operation.signal;
        let devices;
        try {
            devices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
        } catch (error) {
            if (signal.aborted) return this.checkSupport();
            return result(null, (0, $dSvR3.audioErrorReason)(error) === 'permission-denied' ? 'permission-denied' : 'enumeration-failed');
        }
        if (signal.aborted) return this.checkSupport();
        const outputs = devices.filter((device)=>(0, $dSvR3.isControllerOutput)(device) || (0, $dSvR3.isConcreteOutput)(device) && device.deviceId === this.selectedId);
        if (this.selectedId) {
            if (outputs.some((device)=>device.deviceId === this.selectedId) && this.context?.state !== 'closed') return {
                ...result(true, 'ready', outputs),
                requiresAdapter: false
            };
            this.clearRoute();
            this.failure = 'output-unavailable';
            this.changed();
        }
        if (this.failure) return result(null, this.failure, outputs);
        if (info.requiresAdapter && info.connection === 'usb') return result(false, 'v1-usb-audio-unavailable', outputs);
        if (info.requiresAdapter && info.connection === 'bluetooth') return result(false, 'bluetooth-audio-unavailable', outputs);
        return result(null, outputs.length ? 'selection-required' : 'permission-or-device-unavailable', outputs);
    }
    /** Call from a click. Uses the native output picker when available. Otherwise requests microphone
   * permission to expose audio devices and immediately stops every capture track.
   * Returns concrete outputs for user selection; it does not start playback or select a route.
   */ async requestOutput() {
        this.requireController();
        this.requireApi();
        const signal = this.operation.signal;
        const devices = navigator.mediaDevices;
        try {
            let outputs;
            if (typeof devices.selectAudioOutput === 'function') outputs = [
                await (0, $8T54A.abortable)(devices.selectAudioOutput(), signal)
            ].filter((0, $dSvR3.isConcreteOutput));
            else {
                if (typeof devices.getUserMedia !== 'function') throw new DOMException('Audio output permission is unavailable.', 'NotSupportedError');
                // Cleanup is attached to the browser promise itself, including when a disconnect aborts our wait.
                await (0, $8T54A.abortable)(devices.getUserMedia({
                    audio: true
                }).then((stream)=>{
                    stream.getTracks().forEach((track)=>track.stop());
                }), signal);
                outputs = (await (0, $8T54A.abortable)(devices.enumerateDevices(), signal)).filter((0, $dSvR3.isConcreteOutput));
            }
            signal.throwIfAborted();
            this.failure = outputs.length ? undefined : 'output-unavailable';
            this.changed();
            return outputs;
        } catch (error) {
            if (!signal.aborted) {
                this.failure = (0, $dSvR3.audioErrorReason)(error);
                this.changed();
            }
            throw error;
        }
    }
    /** Explicitly associate a concrete output with this controller. The caller/user establishes identity.
   * Verifies routing without playing sound. Default/communications aliases are rejected.
   * A failed change stops the old route and leaves playback disabled.
   */ async setOutput(deviceId) {
        this.requireController();
        this.requireApi();
        this.clearRoute();
        this.observeDevices();
        this.failure = undefined;
        const signal = this.operation.signal;
        let context;
        try {
            if (!deviceId || [
                'default',
                'communications'
            ].includes(deviceId)) throw new DOMException('Select a concrete audio output, not a system default alias.', 'NotSupportedError');
            const devices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
            signal.throwIfAborted();
            if (!devices.some((device)=>(0, $dSvR3.isConcreteOutput)(device) && device.deviceId === deviceId)) throw new DOMException('The selected audio output is unavailable or permission has not been granted.', 'NotFoundError');
            context = new AudioContext();
            // No source is connected before routing succeeds, so nothing can play through the default output.
            await (0, $8T54A.abortable)(context.setSinkId(deviceId), signal);
            signal.throwIfAborted();
            const currentDevices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
            signal.throwIfAborted();
            if (!currentDevices.some((device)=>(0, $dSvR3.isConcreteOutput)(device) && device.deviceId === deviceId)) throw new DOMException('The selected audio output was disconnected during routing.', 'NotFoundError');
            this.context = context;
            this.selectedId = deviceId;
            this.changed();
        } catch (error) {
            if (context) context.close().catch(()=>{});
            if (!signal.aborted) {
                this.failure = (0, $dSvR3.audioErrorReason)(error);
                this.changed();
            }
            throw error;
        }
    }
    /** Route a live MediaStream to the selected headphone output, without buffering or decoding a file.
   * Supply one audio track (mono or stereo). Call from a user action for autoplay permission.
   * Resolves when connected, not when the stream ends. Replaces the previous stream.
   * The caller owns the stream and its tracks; stop/reset/disconnect never stop them.
   */ async play(stream) {
        this.requireController();
        const context = this.requireOutput();
        this.stop();
        const signal = this.playback.signal;
        try {
            this.requireAudioTrack(stream);
            // Resume immediately while user activation is still available.
            await (0, $8T54A.abortable)(context.resume(), signal);
            signal.throwIfAborted();
            this.requireAudioTrack(stream);
            const source = context.createMediaStreamSource(stream);
            this.source = source;
            source.connect(context.destination);
        } catch (error) {
            if (!signal.aborted) this.stop();
            throw error;
        }
    }
    /** Disconnect playback and cancel pending resume work, preserving the output and caller-owned tracks. */ stop() {
        this.playback.abort(new DOMException('Audio playback cancelled.', 'AbortError'));
        this.playback = new AbortController();
        if (this.source) {
            this.source.disconnect();
            this.source = undefined;
        }
    }
    /** Release playback, routing, pending volume promises and device listeners. A new selection is required. */ reset() {
        this.volumeRequests.abort(new DOMException('Audio volume update cancelled by reset.', 'AbortError'));
        this.volumeRequests = new AbortController();
        this.leftVolume = null;
        this.rightVolume = null;
        this.clearRoute();
        this.failure = undefined;
        this.deviceChangeVersion++;
        this.mediaDevices?.removeEventListener('devicechange', this.onDeviceChange);
        this.mediaDevices = undefined;
        this.changed();
    }
    /** Start observing a newly opened controller session without requesting audio permission. @internal */ attach() {
        this.reset();
        this.observeDevices();
    }
    observeDevices() {
        if (this.mediaDevices) return;
        this.mediaDevices = typeof navigator === 'undefined' ? undefined : navigator.mediaDevices;
        this.mediaDevices?.addEventListener('devicechange', this.onDeviceChange);
    }
    clearRoute() {
        this.stop();
        this.operation.abort(new DOMException('Audio output selection cancelled.', 'AbortError'));
        this.operation = new AbortController();
        this.selectedId = null;
        const context = this.context;
        this.context = undefined;
        if (context && context.state !== 'closed') context.close().catch(()=>{});
    }
    onDeviceChange;
    changed() {
        this.dispatchEvent(new Event('change'));
    }
    requireController() {
        const { device: device, disconnecting: disconnecting } = this.getController();
        if (!device?.opened || disconnecting) throw new DOMException('Connect the controller before using audio.', 'InvalidStateError');
    }
    requireApi() {
        const problem = (0, $dSvR3.audioApiProblem)();
        if (problem) throw new DOMException(`Audio unavailable: ${problem}.`, 'NotSupportedError');
    }
    requireOutput() {
        if (!this.context || !this.selectedId || this.context.state === 'closed') throw new DOMException('Select an audio output before playing sound.', 'InvalidStateError');
        return this.context;
    }
    requireAudioTrack(stream) {
        const tracks = stream.getAudioTracks();
        if (tracks.length !== 1 || tracks[0].readyState !== 'live') throw new DOMException('Provide a MediaStream with one live audio track (mono or stereo).', 'NotSupportedError');
    }
}

});
parcelRegister("5T3WD", function(module, exports) {

$parcel$export(module.exports, "normalizeHardwareVolume", () => $bbdd92919ef7f8f4$export$ec527a279e44b944);
/** Normalize a raw HID volume byte; hardware loudness is not a linear percentage. @internal */ function $bbdd92919ef7f8f4$export$ec527a279e44b944(value) {
    if (!Number.isFinite(value)) throw new RangeError('Hardware volume must be a finite number.');
    return Math.round(Math.min(255, Math.max(0, value)));
}

});

parcelRegister("dSvR3", function(module, exports) {

$parcel$export(module.exports, "connectionInfo", () => $5073aa243f23bbbe$export$fb208ec70f134be);
$parcel$export(module.exports, "audioApiProblem", () => $5073aa243f23bbbe$export$ae9708e2a105c2b5);
$parcel$export(module.exports, "isConcreteOutput", () => $5073aa243f23bbbe$export$51e72a6d3314d2c2);
$parcel$export(module.exports, "isControllerOutput", () => $5073aa243f23bbbe$export$a4f54ec73a29f8b7);
$parcel$export(module.exports, "audioErrorReason", () => $5073aa243f23bbbe$export$39b2ab81ffd6c691);
parcelRequire("cAB4M");
var $hYC5D = parcelRequire("hYC5D");
var $dZ9cb = parcelRequire("dZ9cb");

var $aCBP0 = parcelRequire("aCBP0");
function $5073aa243f23bbbe$export$fb208ec70f134be({ device: device, transport: transport }) {
    if (!device?.opened) return {
        connection: 'unknown',
        requiresAdapter: null
    };
    const sony = device.vendorId === (0, $dZ9cb.SONY_VENDOR_ID);
    if (sony && device.productId === (0, $hYC5D.DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID)) return {
        connection: 'sony-adapter',
        requiresAdapter: false
    };
    const connection = transport === 'usb' ? 'usb' : transport === 'bt' ? 'bluetooth' : 'unknown';
    let requiresAdapter = null;
    if (sony && device.productId === (0, $hYC5D.DUALSHOCK4_V2_PRODUCT_ID) && connection !== 'unknown') requiresAdapter = connection === 'bluetooth';
    if (sony && device.productId === (0, $hYC5D.DUALSHOCK4_V1_PRODUCT_ID) && connection !== 'unknown') requiresAdapter = true;
    return {
        connection: connection,
        requiresAdapter: requiresAdapter
    };
}
function $5073aa243f23bbbe$export$ae9708e2a105c2b5() {
    if (typeof isSecureContext === 'undefined' || !isSecureContext) return 'insecure-context';
    if (typeof navigator === 'undefined' || !navigator.mediaDevices?.enumerateDevices || typeof AudioContext === 'undefined' || typeof AudioContext.prototype.setSinkId !== 'function') return 'api-unavailable';
    return null;
}
function $5073aa243f23bbbe$export$51e72a6d3314d2c2(device) {
    return device.kind === 'audiooutput' && !!device.deviceId && ![
        'default',
        'communications'
    ].includes(device.deviceId);
}
function $5073aa243f23bbbe$export$a4f54ec73a29f8b7(device) {
    return $5073aa243f23bbbe$export$51e72a6d3314d2c2(device) && (0, $aCBP0.isControllerAudioLabel)(device.label);
}
function $5073aa243f23bbbe$export$39b2ab81ffd6c691(error) {
    if (error instanceof DOMException) {
        if (error.name === 'NotAllowedError') return 'permission-denied';
        if (error.name === 'NotFoundError') return 'output-unavailable';
    }
    return 'routing-failed';
}

});
parcelRegister("cAB4M", function(module, exports) {
$parcel$export(module.exports, "ARMOR3_LEVEL_UP_VENDOR_ID", () => (parcelRequire("dZ9cb")).ARMOR3_LEVEL_UP_VENDOR_ID);
$parcel$export(module.exports, "GAMESTOP_VENDOR_ID", () => (parcelRequire("dZ9cb")).GAMESTOP_VENDOR_ID);
$parcel$export(module.exports, "HORI_VENDOR_ID", () => (parcelRequire("dZ9cb")).HORI_VENDOR_ID);
$parcel$export(module.exports, "MULTILASER_STEELPLAY_VENDOR_ID", () => (parcelRequire("dZ9cb")).MULTILASER_STEELPLAY_VENDOR_ID);
$parcel$export(module.exports, "NACON_VENDOR_ID", () => (parcelRequire("dZ9cb")).NACON_VENDOR_ID);
$parcel$export(module.exports, "RAZER_VENDOR_ID", () => (parcelRequire("dZ9cb")).RAZER_VENDOR_ID);
$parcel$export(module.exports, "SCUF_VENDOR_ID", () => (parcelRequire("dZ9cb")).SCUF_VENDOR_ID);
$parcel$export(module.exports, "SONY_VENDOR_ID", () => (parcelRequire("dZ9cb")).SONY_VENDOR_ID);
$parcel$export(module.exports, "ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID", () => (parcelRequire("3jDeu")).ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_V1_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_V1_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_V2_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_V2_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID);
$parcel$export(module.exports, "GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID", () => (parcelRequire("1t9cw")).GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID);
$parcel$export(module.exports, "HORI_FIGHTING_COMMANDER_PRODUCT_ID", () => (parcelRequire("fK1dH")).HORI_FIGHTING_COMMANDER_PRODUCT_ID);
$parcel$export(module.exports, "HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID", () => (parcelRequire("fK1dH")).HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID);
$parcel$export(module.exports, "MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID", () => (parcelRequire("euZJe")).MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_PRO_2_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_PRO_2_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_PRO_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_PRO_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_PS4_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_PS4_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID);
$parcel$export(module.exports, "SCUF_VANTAGE_PRODUCT_ID", () => (parcelRequire("kCAvn")).SCUF_VANTAGE_PRODUCT_ID);
$parcel$export(module.exports, "STEELPLAY_METALTECH_P4_PRODUCT_ID", () => (parcelRequire("euZJe")).STEELPLAY_METALTECH_P4_PRODUCT_ID);
$parcel$export(module.exports, "STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID", () => (parcelRequire("hYC5D")).STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID);
/**
 * Shared vendor and product identifiers for supported controllers and accessories.
 * @module
 * @internal
 */ parcelRequire("dZ9cb");
parcelRequire("kJFFG");

});
parcelRegister("dZ9cb", function(module, exports) {

$parcel$export(module.exports, "SONY_VENDOR_ID", () => $3220df79e8fa1a99$export$d7612230815d6008);
$parcel$export(module.exports, "RAZER_VENDOR_ID", () => $3220df79e8fa1a99$export$4cb872f0be8ca9f9);
$parcel$export(module.exports, "NACON_VENDOR_ID", () => $3220df79e8fa1a99$export$b2757cfa1558d6ba);
$parcel$export(module.exports, "HORI_VENDOR_ID", () => $3220df79e8fa1a99$export$c675beb6b9c351df);
$parcel$export(module.exports, "ARMOR3_LEVEL_UP_VENDOR_ID", () => $3220df79e8fa1a99$export$b404bba99b3b1f7b);
$parcel$export(module.exports, "SCUF_VENDOR_ID", () => $3220df79e8fa1a99$export$88ecd4b71f315ca);
$parcel$export(module.exports, "GAMESTOP_VENDOR_ID", () => $3220df79e8fa1a99$export$db700db2f729475d);
$parcel$export(module.exports, "MULTILASER_STEELPLAY_VENDOR_ID", () => $3220df79e8fa1a99$export$b13bde4e472b7bfb);
/**
 * Shared USB/HID vendor identifiers for supported controllers and accessories.
 * @module
 * @internal
 */ /**
 * Sony vendor identifier (VID) reported by HID devices.
 * Use together with a product ID to identify a controller model or adapter;
 * the vendor ID alone does not distinguish devices or establish audio support.
 */ const $3220df79e8fa1a99$export$d7612230815d6008 = 0x054C;
const $3220df79e8fa1a99$export$4cb872f0be8ca9f9 = 0x1532;
const $3220df79e8fa1a99$export$b2757cfa1558d6ba = 0x146B;
const $3220df79e8fa1a99$export$c675beb6b9c351df = 0x0F0D;
const $3220df79e8fa1a99$export$b404bba99b3b1f7b = 0x7545;
const $3220df79e8fa1a99$export$88ecd4b71f315ca = 0x2E95;
const $3220df79e8fa1a99$export$db700db2f729475d = 0x11C0;
const $3220df79e8fa1a99$export$b13bde4e472b7bfb = 0x0C12;

});

parcelRegister("kJFFG", function(module, exports) {

$parcel$export(module.exports, "ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID", () => (parcelRequire("3jDeu")).ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID);
$parcel$export(module.exports, "GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID", () => (parcelRequire("1t9cw")).GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID);
$parcel$export(module.exports, "HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID", () => (parcelRequire("fK1dH")).HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID);
$parcel$export(module.exports, "HORI_FIGHTING_COMMANDER_PRODUCT_ID", () => (parcelRequire("fK1dH")).HORI_FIGHTING_COMMANDER_PRODUCT_ID);
$parcel$export(module.exports, "MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID", () => (parcelRequire("euZJe")).MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID);
$parcel$export(module.exports, "STEELPLAY_METALTECH_P4_PRODUCT_ID", () => (parcelRequire("euZJe")).STEELPLAY_METALTECH_P4_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_PRO_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_PRO_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_PRO_2_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_PRO_2_PRODUCT_ID);
$parcel$export(module.exports, "NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID", () => (parcelRequire("iYMHu")).NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_V1_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_V1_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_V2_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_V2_PRODUCT_ID);
$parcel$export(module.exports, "DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID", () => (parcelRequire("hYC5D")).DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID);
$parcel$export(module.exports, "STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID", () => (parcelRequire("hYC5D")).STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_PS4_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_PS4_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID", () => (parcelRequire("kRHVN")).RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID);
$parcel$export(module.exports, "SCUF_VANTAGE_PRODUCT_ID", () => (parcelRequire("kCAvn")).SCUF_VANTAGE_PRODUCT_ID);
/**
 * Product identifiers grouped by vendor ID.
 * @module
 * @internal
 */ 
var $3jDeu = parcelRequire("3jDeu");

var $1t9cw = parcelRequire("1t9cw");

var $fK1dH = parcelRequire("fK1dH");

var $euZJe = parcelRequire("euZJe");

var $iYMHu = parcelRequire("iYMHu");

var $hYC5D = parcelRequire("hYC5D");

var $kRHVN = parcelRequire("kRHVN");

var $kCAvn = parcelRequire("kCAvn");

});
parcelRegister("3jDeu", function(module, exports) {

$parcel$export(module.exports, "ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID", () => $92cc1f1da5c795ed$export$603e3ab20ca6df76);
/**
 * USB/HID product identifiers paired with ARMOR3_LEVEL_UP_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) shared by the Armor3 / Level Up Cobra entries.
 * Pair with ARMOR3_LEVEL_UP_VENDOR_ID; both retail names share this identity.
 */ const $92cc1f1da5c795ed$export$603e3ab20ca6df76 = 0x0104;

});

parcelRegister("1t9cw", function(module, exports) {

$parcel$export(module.exports, "GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID", () => $36f8a722b772e961$export$d0dacbcc93088f15);
/**
 * USB/HID product identifiers paired with GAMESTOP_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the GameStop PS4 Fun Controller.
 * Pair with GAMESTOP_VENDOR_ID in the supported-controller filter.
 */ const $36f8a722b772e961$export$d0dacbcc93088f15 = 0x4001;

});

parcelRegister("fK1dH", function(module, exports) {

$parcel$export(module.exports, "HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID", () => $3655f25b03d98717$export$404aee3ce72d744f);
$parcel$export(module.exports, "HORI_FIGHTING_COMMANDER_PRODUCT_ID", () => $3655f25b03d98717$export$12a3eed1725685a5);
/**
 * USB/HID product identifiers paired with HORI_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the HORI Mini Wired Gamepad for PS4.
 * Pair with HORI_VENDOR_ID to distinguish it from Fighting Commander.
 */ const $3655f25b03d98717$export$404aee3ce72d744f = 0x00EE;
const $3655f25b03d98717$export$12a3eed1725685a5 = 0x0084;

});

parcelRegister("euZJe", function(module, exports) {

$parcel$export(module.exports, "MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID", () => $b0cf904369a6197d$export$5ed8367a84a154ba);
$parcel$export(module.exports, "STEELPLAY_METALTECH_P4_PRODUCT_ID", () => $b0cf904369a6197d$export$4b2649bed7278d25);
/**
 * USB/HID product identifiers paired with MULTILASER_STEELPLAY_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the Multilaser Warrior Joypad (JS083).
 * Pair with MULTILASER_STEELPLAY_VENDOR_ID, also used by the Steelplay entry.
 */ const $b0cf904369a6197d$export$5ed8367a84a154ba = 0x57AB;
const $b0cf904369a6197d$export$4b2649bed7278d25 = 0x0E16;

});

parcelRegister("iYMHu", function(module, exports) {

$parcel$export(module.exports, "NACON_REVOLUTION_PRO_PRODUCT_ID", () => $87cf3255d6944024$export$3d90a6929b2ca62d);
$parcel$export(module.exports, "NACON_REVOLUTION_PRO_2_PRODUCT_ID", () => $87cf3255d6944024$export$f82490cc95ce616c);
$parcel$export(module.exports, "NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID", () => $87cf3255d6944024$export$8e039cac5d143b0e);
/**
 * USB/HID product identifiers paired with NACON_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the Nacon Revolution Pro Controller.
 * Pair with NACON_VENDOR_ID to distinguish it from later Revolution models.
 */ const $87cf3255d6944024$export$3d90a6929b2ca62d = 0x0D01;
const $87cf3255d6944024$export$f82490cc95ce616c = 0x0D02;
const $87cf3255d6944024$export$8e039cac5d143b0e = 0x0D08;

});

parcelRegister("hYC5D", function(module, exports) {

$parcel$export(module.exports, "DUALSHOCK4_V1_PRODUCT_ID", () => $c38158ad111030f8$export$1285657e953863fb);
$parcel$export(module.exports, "DUALSHOCK4_V2_PRODUCT_ID", () => $c38158ad111030f8$export$d22ae3b2de97ce75);
$parcel$export(module.exports, "DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID", () => $c38158ad111030f8$export$96770a8d3fa34131);
$parcel$export(module.exports, "STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID", () => $c38158ad111030f8$export$9bad8db1e265b345);
/**
 * USB/HID product identifiers paired with SONY_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the first-generation DualShock 4 (CUH-ZCT1).
 * Paired with SONY_VENDOR_ID in controller filters and model-specific
 * headphone support checks, including the v1 adapter recommendation.
 */ const $c38158ad111030f8$export$1285657e953863fb = 0x05C4;
const $c38158ad111030f8$export$d22ae3b2de97ce75 = 0x09CC;
const $c38158ad111030f8$export$96770a8d3fa34131 = 0x0BA0;
const $c38158ad111030f8$export$9bad8db1e265b345 = 0x05C5;

});

parcelRegister("kRHVN", function(module, exports) {

$parcel$export(module.exports, "RAZER_RAIJU_PS4_PRODUCT_ID", () => $cdcfaabffa6e8e3f$export$5b51c04b881c5baf);
$parcel$export(module.exports, "RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID", () => $cdcfaabffa6e8e3f$export$8954a30fb850ea2c);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID", () => $cdcfaabffa6e8e3f$export$b7700019d1563c40);
$parcel$export(module.exports, "RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID", () => $cdcfaabffa6e8e3f$export$1dc3b73a2e31772b);
/**
 * USB/HID product identifiers paired with RAZER_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the Razer Raiju PS4 controller.
 * Pair with RAZER_VENDOR_ID; other Raiju editions have separate product IDs.
 */ const $cdcfaabffa6e8e3f$export$5b51c04b881c5baf = 0x1000;
const $cdcfaabffa6e8e3f$export$8954a30fb850ea2c = 0x1007;
const $cdcfaabffa6e8e3f$export$b7700019d1563c40 = 0x1004;
const $cdcfaabffa6e8e3f$export$1dc3b73a2e31772b = 0x1009;

});

parcelRegister("kCAvn", function(module, exports) {

$parcel$export(module.exports, "SCUF_VANTAGE_PRODUCT_ID", () => $aa81231d4d7f377a$export$903ef0322c2acb56);
/**
 * USB/HID product identifiers paired with SCUF_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */ /**
 * Product identifier (PID) of the SCUF Vantage controller.
 * Pair with SCUF_VENDOR_ID in the supported-controller filter.
 */ const $aa81231d4d7f377a$export$903ef0322c2acb56 = 0x7725;

});



parcelRegister("aCBP0", function(module, exports) {

$parcel$export(module.exports, "isControllerAudioLabel", () => $2843287e1959c4e2$export$732e3c5bf772020f);
/** Shared discovery hints for headset inputs and outputs; labels do not prove HID identity. @internal */ function $2843287e1959c4e2$export$732e3c5bf772020f(label) {
    const name = label.toLowerCase();
    return name.includes('wireless controller') || name.includes("dualshock\xae4 usb wireless adaptor") || name.includes('dualshock 4 usb wireless adaptor');
}

});



parcelRegister("aYIaT", function(module, exports) {

$parcel$export(module.exports, "DualShock4Microphone", () => $d901e9f8d96bb4bb$export$50d46e9f2d24377c);

var $8T54A = parcelRequire("8T54A");

var $5T3WD = parcelRequire("5T3WD");

var $dSvR3 = parcelRequire("dSvR3");

var $lBJQ5 = parcelRequire("lBJQ5");
class $d901e9f8d96bb4bb$export$50d46e9f2d24377c extends EventTarget {
    getController;
    requestVolumeUpdate;
    selectedId;
    captureStream;
    captureTracks;
    failure;
    operation;
    mediaDevices;
    deviceChangeVersion;
    requestedVolume;
    volumeRequests;
    /** @internal */ constructor(getController, requestVolumeUpdate){
        super(), this.getController = getController, this.requestVolumeUpdate = requestVolumeUpdate, this.selectedId = null, this.captureStream = null, this.captureTracks = [], this.operation = new AbortController(), this.deviceChangeVersion = 0, this.requestedVolume = null, this.volumeRequests = new AbortController(), this.onTrackEnded = ()=>{
            this.invalidate('input-unavailable');
        }, this.onDeviceChange = ()=>{
            const version = ++this.deviceChangeVersion;
            const signal = this.operation.signal;
            const devices = this.mediaDevices;
            if (!devices) return;
            devices.enumerateDevices().then((inputs)=>{
                if (signal.aborted || version !== this.deviceChangeVersion) return;
                if (this.selectedId && !inputs.some((device)=>(0, $lBJQ5.isConcreteInput)(device) && device.deviceId === this.selectedId)) this.invalidate('input-unavailable');
                else this.changed();
            }).catch(()=>{
                if (signal.aborted || version !== this.deviceChangeVersion) return;
                this.invalidate('enumeration-failed');
            });
        };
    }
    /** Last requested microphone HID gain byte (0-255), or null before configuration/after reset.
   * This is a local cache, not hardware readback or browser capture volume.
   */ get volume() {
        return this.requestedVolume;
    }
    set volume(value) {
        this.setVolume(value).catch((error)=>console.error(error));
    }
    /** Set raw headset microphone gain independently of browser capture/permissions.
   * Finite values are clamped to 0-255 and rounded.
   * Resolves when the HID report is sent; rejects on output failure or reset.
   */ async setVolume(value) {
        const volume = (0, $5T3WD.normalizeHardwareVolume)(value);
        if (!this.requestVolumeUpdate) throw new DOMException('Hardware volume control requires a controller output callback.', 'NotSupportedError');
        this.requestedVolume = volume;
        const signal = this.volumeRequests.signal;
        return (0, $8T54A.abortable)(this.requestVolumeUpdate(), signal);
    }
    /** Explicitly selected concrete input, or null before selection/after invalidation. */ get inputDeviceId() {
        return this.selectedId;
    }
    /** Current capture, owned by this endpoint. Null when stopped. No recording or playback is automatic. */ get stream() {
        return this.captureStream;
    }
    /** Passive check: never requests permission or starts capture. A label match is not verification. */ async checkSupport() {
        const controller = this.getController();
        const info = (0, $dSvR3.connectionInfo)(controller);
        const result = (supported, reason, inputs = [])=>({
                ...info,
                supported: supported,
                reason: reason,
                inputs: inputs
            });
        if (!controller.device?.opened || controller.disconnecting) return result(false, 'controller-disconnected');
        const problem = (0, $lBJQ5.microphoneApiProblem)();
        if (problem) return result(false, problem);
        const signal = this.operation.signal;
        let devices;
        try {
            devices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
        } catch (error) {
            if (signal.aborted) return this.checkSupport();
            return result(null, (0, $lBJQ5.microphoneErrorReason)(error) === 'permission-denied' ? 'permission-denied' : 'enumeration-failed');
        }
        if (signal.aborted) return this.checkSupport();
        const inputs = devices.filter((device)=>(0, $lBJQ5.isControllerInput)(device) || (0, $lBJQ5.isConcreteInput)(device) && device.deviceId === this.selectedId);
        if (this.selectedId && !inputs.some((device)=>device.deviceId === this.selectedId)) this.invalidate('input-unavailable');
        if (this.captureStream && !this.captureTracks.some((track)=>track.kind === 'audio' && track.readyState === 'live')) this.invalidate('input-unavailable');
        if (this.captureStream) return {
            ...result(true, 'ready', inputs),
            requiresAdapter: false
        };
        if (this.failure) return result(null, this.failure, inputs);
        if (this.selectedId) return result(null, 'capture-required', inputs);
        if (info.requiresAdapter && info.connection === 'usb') return result(false, 'v1-usb-audio-unavailable', inputs);
        if (info.requiresAdapter && info.connection === 'bluetooth') return result(false, 'bluetooth-audio-unavailable', inputs);
        return result(null, inputs.length ? 'selection-required' : 'permission-or-device-unavailable', inputs);
    }
    /** Call from an access button. Briefly requests the browser's default microphone to reveal inputs,
   * immediately stops all temporary tracks, and returns concrete inputs for manual selection.
   * Cancels previous pending work/capture, preserving the selected input. Does not retain a stream.
   */ async requestInput() {
        this.requireAvailable();
        this.cancelCapture();
        this.observeDevices();
        this.failure = undefined;
        const signal = this.operation.signal;
        try {
            // Cleanup belongs to the browser promise so late permission responses are also released.
            await (0, $8T54A.abortable)(navigator.mediaDevices.getUserMedia({
                audio: true
            }).then((stream)=>{
                stream.getTracks().forEach((track)=>track.stop());
            }), signal);
            const inputs = (await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal)).filter((0, $lBJQ5.isConcreteInput));
            signal.throwIfAborted();
            this.failure = inputs.length ? undefined : 'input-unavailable';
            this.changed();
            return inputs;
        } catch (error) {
            this.reportFailure(error, signal);
            throw error;
        }
    }
    /** Select a concrete input without capture or a permission prompt. The caller establishes identity.
   * Stops any current capture. Invalid selection clears the old input; system aliases are rejected.
   */ async setInput(deviceId) {
        this.requireAvailable();
        this.cancelCapture();
        this.observeDevices();
        this.selectedId = null;
        this.failure = undefined;
        const signal = this.operation.signal;
        try {
            if (!deviceId || [
                'default',
                'communications'
            ].includes(deviceId)) throw new DOMException('Select a concrete audio input, not a system default alias.', 'NotSupportedError');
            const devices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
            signal.throwIfAborted();
            if (!devices.some((device)=>(0, $lBJQ5.isConcreteInput)(device) && device.deviceId === deviceId)) throw new DOMException('The selected microphone is unavailable or permission has not been granted.', 'NotFoundError');
            this.selectedId = deviceId;
            this.changed();
        } catch (error) {
            this.reportFailure(error, signal);
            throw error;
        }
    }
    /** Call from a start button. Capture the selected input using an exact deviceId constraint.
   * Returns one live audio track for WebRTC, Web Audio or MediaRecorder. Replaces previous capture.
   * The endpoint owns the returned tracks: stop/reset/disconnect stops them, even if used elsewhere.
   */ async start() {
        this.requireAvailable();
        if (!this.selectedId) throw new DOMException('Select a microphone before starting capture.', 'InvalidStateError');
        this.cancelCapture();
        this.observeDevices();
        this.failure = undefined;
        const signal = this.operation.signal;
        const deviceId = this.selectedId;
        let acquired;
        try {
            const stream = await (0, $8T54A.abortable)(navigator.mediaDevices.getUserMedia({
                audio: {
                    deviceId: {
                        exact: deviceId
                    }
                }
            }).then((stream)=>{
                if (signal.aborted) stream.getTracks().forEach((track)=>track.stop());
                else acquired = stream;
                return stream;
            }), signal);
            signal.throwIfAborted();
            const tracks = stream.getAudioTracks();
            if (tracks.length !== 1 || tracks[0].readyState !== 'live' || tracks[0].getSettings().deviceId !== deviceId) throw new DOMException('The browser did not return a live track from the selected microphone.', 'NotReadableError');
            const devices = await (0, $8T54A.abortable)(navigator.mediaDevices.enumerateDevices(), signal);
            signal.throwIfAborted();
            if (!devices.some((device)=>(0, $lBJQ5.isConcreteInput)(device) && device.deviceId === deviceId)) throw new DOMException('The selected microphone was disconnected during capture setup.', 'NotFoundError');
            if (tracks[0].readyState !== 'live') throw new DOMException('The microphone track ended during capture setup.', 'NotReadableError');
            this.captureStream = stream;
            this.captureTracks = stream.getTracks();
            tracks[0].addEventListener('ended', this.onTrackEnded);
            this.changed();
            signal.throwIfAborted();
            return stream;
        } catch (error) {
            acquired?.getTracks().forEach((track)=>track.stop());
            this.reportFailure(error, signal);
            throw error;
        }
    }
    /** Stop owned tracks and cancel pending permission/capture/selection, preserving the selected input. */ stop() {
        this.cancelCapture();
        this.failure = undefined;
        this.changed();
    }
    /** Stop capture, clear input/gain cache, cancel pending work and release device listeners. */ reset() {
        this.volumeRequests.abort(new DOMException('Audio volume update cancelled by reset.', 'AbortError'));
        this.volumeRequests = new AbortController();
        this.requestedVolume = null;
        this.cancelCapture();
        this.selectedId = null;
        this.failure = undefined;
        this.deviceChangeVersion++;
        this.mediaDevices?.removeEventListener('devicechange', this.onDeviceChange);
        this.mediaDevices = undefined;
        this.changed();
    }
    /** Observe a new HID session without requesting permission. @internal */ attach() {
        this.reset();
        this.observeDevices();
    }
    cancelCapture() {
        this.operation.abort(new DOMException('Microphone operation cancelled.', 'AbortError'));
        this.operation = new AbortController();
        this.captureStream = null;
        for (const track of this.captureTracks){
            track.removeEventListener('ended', this.onTrackEnded);
            track.stop();
        }
        this.captureTracks = [];
    }
    invalidate(reason) {
        this.cancelCapture();
        this.selectedId = null;
        this.failure = reason;
        this.changed();
    }
    onTrackEnded;
    observeDevices() {
        if (this.mediaDevices) return;
        this.mediaDevices = typeof navigator === 'undefined' ? undefined : navigator.mediaDevices;
        this.mediaDevices?.addEventListener('devicechange', this.onDeviceChange);
    }
    onDeviceChange;
    reportFailure(error, signal) {
        if (!signal.aborted) {
            this.failure = (0, $lBJQ5.microphoneErrorReason)(error);
            this.changed();
        }
    }
    changed() {
        this.dispatchEvent(new Event('change'));
    }
    requireAvailable() {
        const { device: device, disconnecting: disconnecting } = this.getController();
        if (!device?.opened || disconnecting) throw new DOMException('Connect the controller before using the microphone.', 'InvalidStateError');
        const problem = (0, $lBJQ5.microphoneApiProblem)();
        if (problem) throw new DOMException(`Microphone unavailable: ${problem}.`, 'NotSupportedError');
    }
}

});
parcelRegister("lBJQ5", function(module, exports) {

$parcel$export(module.exports, "microphoneApiProblem", () => $6e9f2d18061cfb81$export$1fc2c15649788044);
$parcel$export(module.exports, "isConcreteInput", () => $6e9f2d18061cfb81$export$2c550d05fa807dc5);
$parcel$export(module.exports, "isControllerInput", () => $6e9f2d18061cfb81$export$2885e0c1d8f40c15);
$parcel$export(module.exports, "microphoneErrorReason", () => $6e9f2d18061cfb81$export$1795cb8544b7cf8);

var $aCBP0 = parcelRequire("aCBP0");
function $6e9f2d18061cfb81$export$1fc2c15649788044() {
    if (typeof isSecureContext === 'undefined' || !isSecureContext) return 'insecure-context';
    if (typeof navigator === 'undefined' || typeof navigator.mediaDevices?.enumerateDevices !== 'function' || typeof navigator.mediaDevices?.getUserMedia !== 'function') return 'api-unavailable';
    return null;
}
function $6e9f2d18061cfb81$export$2c550d05fa807dc5(device) {
    return device.kind === 'audioinput' && !!device.deviceId && ![
        'default',
        'communications'
    ].includes(device.deviceId);
}
function $6e9f2d18061cfb81$export$2885e0c1d8f40c15(device) {
    return $6e9f2d18061cfb81$export$2c550d05fa807dc5(device) && (0, $aCBP0.isControllerAudioLabel)(device.label);
}
function $6e9f2d18061cfb81$export$1795cb8544b7cf8(error) {
    if (error instanceof DOMException) {
        if (error.name === 'NotAllowedError' || error.name === 'SecurityError') return 'permission-denied';
        if (error.name === 'NotFoundError' || error.name === 'OverconstrainedError') return 'input-unavailable';
    }
    return 'capture-failed';
}

});


parcelRegister("kPTNl", function(module, exports) {

$parcel$export(module.exports, "DualShock4Speaker", () => $74394761616b6093$export$a48645f69aa4b7cc);

var $8T54A = parcelRequire("8T54A");

var $5T3WD = parcelRequire("5T3WD");
class $74394761616b6093$export$a48645f69aa4b7cc {
    requestUpdate;
    requestedVolume;
    volumeRequests;
    /** @internal */ constructor(requestUpdate){
        this.requestUpdate = requestUpdate;
        this.requestedVolume = null;
        this.volumeRequests = new AbortController();
    }
    /** Last requested raw HID volume (0-255), or null before configuration/after reset.
   * This is a local cache, not a hardware readback or acknowledgement.
   */ get volume() {
        return this.requestedVolume;
    }
    set volume(value) {
        this.setVolume(value).catch((error)=>console.error(error));
    }
    /** Set a raw HID volume byte. Finite values are clamped to 0-255 and rounded.
   * Resolves when the HID report is sent; rejects on output failure or reset.
   */ async setVolume(value) {
        const volume = (0, $5T3WD.normalizeHardwareVolume)(value);
        if (!this.requestUpdate) throw new DOMException('Hardware volume control requires a controller output callback.', 'NotSupportedError');
        this.requestedVolume = volume;
        const signal = this.volumeRequests.signal;
        return (0, $8T54A.abortable)(this.requestUpdate(), signal);
    }
    /** Cancel pending volume promises and forget the cache without restoring hardware. @internal */ reset() {
        this.volumeRequests.abort(new DOMException('Audio volume update cancelled by reset.', 'AbortError'));
        this.volumeRequests = new AbortController();
        this.requestedVolume = null;
    }
}

});


parcelRegister("a27ji", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", () => $822cf9fc0527f064$export$303deccbe6e8c782);
/**
 * @module
 * @internal
 */ 
var $8T54A = parcelRequire("8T54A");

var $5zhN4 = parcelRequire("5zhN4");
class $822cf9fc0527f064$export$303deccbe6e8c782 {
    hooks;
    currentSession;
    initialization;
    disconnection;
    constructor(hooks){
        this.hooks = hooks;
    }
    get session() {
        return this.currentSession;
    }
    get device() {
        return this.currentSession?.device;
    }
    // Retain the writable public device property for existing callers.
    set device(device) {
        if (this.device === device) return;
        this.releaseSession();
        this.currentSession = device ? this.createSession(device) : undefined;
    }
    get isDisconnecting() {
        return this.currentSession?.phase === 'disconnecting';
    }
    async connect() {
        if (this.disconnection) await this.disconnection;
        if (!this.initialization && this.device?.opened) return true;
        const initialization = this.initialization ??= this.initializeDevice();
        try {
            return await initialization;
        } finally{
            if (this.initialization === initialization) this.initialization = undefined;
        }
    }
    async disconnect() {
        const disconnection = this.disconnection ??= this.disconnectDevice();
        try {
            await disconnection;
        } finally{
            if (this.disconnection === disconnection) this.disconnection = undefined;
        }
    }
    createSession(device) {
        const abort = new AbortController();
        return {
            device: device,
            abort: abort,
            signal: abort.signal,
            phase: 'initializing',
            announced: false
        };
    }
    releaseSession() {
        const session = this.currentSession;
        if (!session) return;
        session.device.oninputreport = null;
        session.removeDisconnectListener?.();
        session.abort.abort(new DOMException('Controller disconnected.', 'AbortError'));
        this.currentSession = undefined;
    }
    bindInput(session) {
        session.device.oninputreport = (report)=>{
            if (this.currentSession === session) this.hooks.input(report);
        };
    }
    clearSession(session, reason = 'manual') {
        if (this.currentSession !== session) return;
        this.releaseSession();
        this.hooks.cleared(session.device, reason, session.announced);
    }
    async initializeDevice() {
        const devices = await navigator.hid.requestDevice({
            filters: (0, $5zhN4.controllerFilters)
        });
        const device = devices[0];
        if (!device) return false;
        const session = this.createSession(device);
        const hid = navigator.hid;
        const onDisconnect = (event)=>{
            if (event.device !== device) return;
            if (this.currentSession === session) this.clearSession(session, 'device-lost');
            else session.abort.abort(new DOMException('Controller disconnected during initialization.', 'AbortError'));
        };
        hid.addEventListener('disconnect', onDisconnect);
        session.removeDisconnectListener = ()=>hid.removeEventListener('disconnect', onDisconnect);
        try {
            await (0, $8T54A.abortable)(device.open(), session.abort.signal);
            session.abort.signal.throwIfAborted();
        } catch (error) {
            session.removeDisconnectListener();
            throw error;
        }
        this.releaseSession();
        this.currentSession = session;
        this.hooks.opened(session);
        this.bindInput(session);
        await this.hooks.initialize();
        session.abort.signal.throwIfAborted();
        if (!device.opened) {
            this.clearSession(session, 'device-lost');
            throw new DOMException('Controller disconnected during initialization.', 'AbortError');
        }
        session.phase = 'connected';
        session.announced = true;
        this.hooks.connected(device);
        return true;
    }
    async disconnectDevice() {
        if (this.initialization) await this.initialization.catch(()=>{});
        const session = this.currentSession;
        if (!session) return;
        const { device: device } = session;
        const closing = this.hooks.prepareClose();
        session.phase = 'disconnecting';
        device.oninputreport = null;
        try {
            if (closing.pending) await closing.pending;
            if (this.currentSession !== session) return;
            if (device.opened) await (0, $8T54A.abortable)(device.close(), session.abort.signal);
            this.clearSession(session);
        } catch (error) {
            if (session.abort.signal.aborted) return;
            if (this.currentSession === session) {
                if (device.opened) {
                    closing.restore();
                    this.bindInput(session);
                } else this.clearSession(session);
            }
            throw error;
        } finally{
            if (this.currentSession === session) session.phase = 'connected';
        }
    }
}

});
parcelRegister("5zhN4", function(module, exports) {

$parcel$export(module.exports, "controllerFilters", () => $71252a6a2179407e$export$298d6bfa903af2b4);
/**
 * @module
 * @internal
 */ parcelRequire("cAB4M");
var $3jDeu = parcelRequire("3jDeu");
var $dZ9cb = parcelRequire("dZ9cb");
var $hYC5D = parcelRequire("hYC5D");
var $1t9cw = parcelRequire("1t9cw");
var $fK1dH = parcelRequire("fK1dH");
var $euZJe = parcelRequire("euZJe");
var $iYMHu = parcelRequire("iYMHu");
var $kRHVN = parcelRequire("kRHVN");
var $kCAvn = parcelRequire("kCAvn");
const $71252a6a2179407e$export$298d6bfa903af2b4 = [
    // Official Sony controllers and adapter
    {
        vendorId: (0, $dZ9cb.SONY_VENDOR_ID),
        productId: (0, $hYC5D.DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.SONY_VENDOR_ID),
        productId: (0, $hYC5D.DUALSHOCK4_V1_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.SONY_VENDOR_ID),
        productId: (0, $hYC5D.DUALSHOCK4_V2_PRODUCT_ID)
    },
    // Third-party accessory using Sony's vendor ID
    {
        vendorId: (0, $dZ9cb.SONY_VENDOR_ID),
        productId: (0, $hYC5D.STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID)
    },
    // Razer Raiju
    {
        vendorId: (0, $dZ9cb.RAZER_VENDOR_ID),
        productId: (0, $kRHVN.RAZER_RAIJU_PS4_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.RAZER_VENDOR_ID),
        productId: (0, $kRHVN.RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.RAZER_VENDOR_ID),
        productId: (0, $kRHVN.RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.RAZER_VENDOR_ID),
        productId: (0, $kRHVN.RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID)
    },
    // Nacon Revolution
    {
        vendorId: (0, $dZ9cb.NACON_VENDOR_ID),
        productId: (0, $iYMHu.NACON_REVOLUTION_PRO_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.NACON_VENDOR_ID),
        productId: (0, $iYMHu.NACON_REVOLUTION_PRO_2_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.NACON_VENDOR_ID),
        productId: (0, $iYMHu.NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID)
    },
    // Other third party controllers
    {
        vendorId: (0, $dZ9cb.HORI_VENDOR_ID),
        productId: (0, $fK1dH.HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.ARMOR3_LEVEL_UP_VENDOR_ID),
        productId: (0, $3jDeu.ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.SCUF_VENDOR_ID),
        productId: (0, $kCAvn.SCUF_VANTAGE_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.GAMESTOP_VENDOR_ID),
        productId: (0, $1t9cw.GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.MULTILASER_STEELPLAY_VENDOR_ID),
        productId: (0, $euZJe.MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.MULTILASER_STEELPLAY_VENDOR_ID),
        productId: (0, $euZJe.STEELPLAY_METALTECH_P4_PRODUCT_ID)
    },
    {
        vendorId: (0, $dZ9cb.HORI_VENDOR_ID),
        productId: (0, $fK1dH.HORI_FIGHTING_COMMANDER_PRODUCT_ID)
    } // HORI — Fighting Commander
];

});


parcelRegister("34ia2", function(module, exports) {

$parcel$export(module.exports, "DualShock4Interface", () => $ed1931fc66478750$export$979dd907f5dfba3d);
$parcel$export(module.exports, "createDefaultState", () => $ed1931fc66478750$export$e5182fb58612e577);
/**
 * Controller State
 * 
 * Stores information about the current controller state, and its components.
 */ var $ed1931fc66478750$export$979dd907f5dfba3d = /*#__PURE__*/ function(DualShock4Interface) {
    DualShock4Interface["Disconnected"] = "none";
    /** The controller is connected over USB */ DualShock4Interface["USB"] = "usb";
    /** The controller is connected over BT */ DualShock4Interface["Bluetooth"] = "bt";
    return DualShock4Interface;
}({});
function $ed1931fc66478750$export$e5182fb58612e577() {
    return {
        interface: "none",
        batteryCapacity: null,
        batteryStatus: 'unknown',
        cableConnected: false,
        externalDeviceConnected: false,
        headphonesConnected: false,
        microphoneConnected: false,
        axes: {
            leftStickX: 0,
            leftStickY: 0,
            rightStickX: 0,
            rightStickY: 0,
            l2: 0,
            r2: 0,
            accelX: 0,
            accelY: 0,
            accelZ: 0,
            gyroX: 0,
            gyroY: 0,
            gyroZ: 0
        },
        buttons: {
            triangle: false,
            circle: false,
            cross: false,
            square: false,
            dPadUp: false,
            dPadRight: false,
            dPadDown: false,
            dPadLeft: false,
            l1: false,
            l2: false,
            l3: false,
            r1: false,
            r2: false,
            r3: false,
            options: false,
            share: false,
            playStation: false,
            touchPadClick: false
        },
        touchpad: {
            touches: [],
            frames: [],
            frameCounter: null
        },
        sensorTimestamp: null,
        reportCounter: null,
        timestamp: -1
    };
}

});

parcelRegister("cFNGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $39728e6fb1b2a12f$export$2e2bcd8739ae039);

var $bRZL8 = parcelRequire("bRZL8");

var $fw06t = parcelRequire("fw06t");
class $39728e6fb1b2a12f$export$2e2bcd8739ae039 {
    requestUpdate;
    /** @ignore */ constructor(requestUpdate){
        this.requestUpdate = requestUpdate;
        this.redIntensity = 0;
        this.greenIntensity = 0;
        this.blueIntensity = 0;
        this.blinkOnDuration = null;
        this.blinkOffDuration = null;
    }
    /** @ignore */ redIntensity;
    /** @ignore */ greenIntensity;
    /** @ignore */ blueIntensity;
    blinkOnDuration;
    blinkOffDuration;
    /** Last requested bright interval in milliseconds, or null before blink configuration. */ get blinkOn() {
        return this.blinkOnDuration;
    }
    /** Last requested dark interval in milliseconds, or null before blink configuration. */ get blinkOff() {
        return this.blinkOffDuration;
    }
    /** Configure controller-driven blinking without JavaScript timers.
   * Finite durations are clamped to 0-2550 ms and rounded down to 10 ms units.
   * Off defaults to on. Use stopBlink() for steady illumination.
   * Resolves when the HID report is sent; rejects on failure or disconnect.
   */ async setBlink(onMs, offMs = onMs) {
        const on = $39728e6fb1b2a12f$var$normalizeBlinkDuration(onMs);
        const off = $39728e6fb1b2a12f$var$normalizeBlinkDuration(offMs);
        this.blinkOnDuration = on;
        this.blinkOffDuration = off;
        return this.updateLightbar();
    }
    /** Disable hardware blinking while preserving the RGB color. */ stopBlink() {
        return this.setBlink(0, 0);
    }
    /**
   * Send Lightbar data to the controller.
   * @ignore
   */ updateLightbar() {
        return this.requestUpdate();
    }
    /** Red Color Intensity (0-255) */ get r() {
        return this.redIntensity;
    }
    set r(value) {
        this.redIntensity = (0, $bRZL8.clampOutputValue)(value);
        this.updateLightbar().catch((error)=>console.error(error));
    }
    /** Green Color Intensity (0-255) */ get g() {
        return this.greenIntensity;
    }
    set g(value) {
        this.greenIntensity = (0, $bRZL8.clampOutputValue)(value);
        this.updateLightbar().catch((error)=>console.error(error));
    }
    /** Blue Color Intensity (0-255) */ get b() {
        return this.blueIntensity;
    }
    set b(value) {
        this.blueIntensity = (0, $bRZL8.clampOutputValue)(value);
        this.updateLightbar().catch((error)=>console.error(error));
    }
    /**
   * Sets the lightbar color (RGB)
   * @param r - Red color intensity (0-255)
   * @param g - Green color intensity (0-255)
   * @param b - Blue color intensity (0-255)
   */ async setColorRGB(r, g, b) {
        this.redIntensity = (0, $bRZL8.clampOutputValue)(r);
        this.greenIntensity = (0, $bRZL8.clampOutputValue)(g);
        this.blueIntensity = (0, $bRZL8.clampOutputValue)(b);
        return this.updateLightbar();
    }
    /**
   * Sets the lightbar color (HSL)
   * @param h - Hue
   * @param s - Saturation
   * @param l - Lightness
   */ async setColorHSL(h, s, l) {
        const color = (0, $fw06t.hslToRgb)(h, s, l);
        return this.setColorRGB(color.r, color.g, color.b);
    }
}
function $39728e6fb1b2a12f$var$normalizeBlinkDuration(value) {
    if (!Number.isFinite(value)) throw new RangeError('Blink duration must be a finite number.');
    return Math.floor(Math.min(2550, Math.max(0, value)) / 10) * 10;
}

});
parcelRegister("bRZL8", function(module, exports) {

$parcel$export(module.exports, "clampOutputValue", () => $71d4911bfdd1de20$export$2a4cff35fdf60d5f);
/**
 * @module
 * @internal
 */ /** Limits an output value to 0–255 without rounding or changing NaN. */ function $71d4911bfdd1de20$export$2a4cff35fdf60d5f(value) {
    return Math.min(255, Math.max(0, value));
}

});

parcelRegister("fw06t", function(module, exports) {

$parcel$export(module.exports, "hslToRgb", () => $fd8b178996a9a1d1$export$29fb7152bd3f781a);
function $fd8b178996a9a1d1$var$processHue(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd8b178996a9a1d1$export$29fb7152bd3f781a(h, s, l) {
    const outColor = {
        r: 0,
        g: 0,
        b: 0
    };
    if (s === 0) outColor.r = outColor.g = outColor.b = l * 255 // Achromatic
    ;
    else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        outColor.r = $fd8b178996a9a1d1$var$processHue(p, q, h + 1 / 3) * 255;
        outColor.g = $fd8b178996a9a1d1$var$processHue(p, q, h) * 255;
        outColor.b = $fd8b178996a9a1d1$var$processHue(p, q, h - 1 / 3) * 255;
    }
    return outColor;
}

});


parcelRegister("4TzKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b89b808abb7958$export$2e2bcd8739ae039);

var $bRZL8 = parcelRequire("bRZL8");
class $70b89b808abb7958$export$2e2bcd8739ae039 {
    requestUpdate;
    /** @ignore */ constructor(requestUpdate){
        this.requestUpdate = requestUpdate;
        this.lightIntensity = 0;
        this.heavyIntensity = 0;
    }
    /** @ignore */ lightIntensity;
    /** @ignore */ heavyIntensity;
    /**
   * Sends rumble data to the controller.
   * @ignore
   */ updateRumble() {
        return this.requestUpdate();
    }
    /** Light Rumble Intensity (0-255) */ get light() {
        return this.lightIntensity;
    }
    set light(value) {
        this.lightIntensity = (0, $bRZL8.clampOutputValue)(value);
        this.updateRumble().catch((error)=>console.error(error));
    }
    /** Heavy Rumble Intensity (0-255) */ get heavy() {
        return this.heavyIntensity;
    }
    set heavy(value) {
        this.heavyIntensity = (0, $bRZL8.clampOutputValue)(value);
        this.updateRumble().catch((error)=>console.error(error));
    }
    /** Clears local motor values without sending a report. @internal */ reset() {
        this.lightIntensity = 0;
        this.heavyIntensity = 0;
    }
    /**
   * Set the rumble intensity
   * @param light - Light rumble intensity (0-255)
   * @param heavy - Heavy rumble intensity (0-255)
   */ async setRumbleIntensity(light, heavy) {
        this.lightIntensity = (0, $bRZL8.clampOutputValue)(light);
        this.heavyIntensity = (0, $bRZL8.clampOutputValue)(heavy);
        return this.updateRumble();
    }
}

});

parcelRegister("eNhXT", function(module, exports) {

$parcel$export(module.exports, "OutputController", () => $a30ec6c4bda7f3c5$export$99cd8bace54e5ae5);
/**
 * @module
 * @internal
 */ 
var $8T54A = parcelRequire("8T54A");

var $34ia2 = parcelRequire("34ia2");

var $jUnL6 = parcelRequire("jUnL6");
class $a30ec6c4bda7f3c5$export$99cd8bace54e5ae5 {
    snapshot;
    onReport;
    target;
    pending;
    queue;
    constructor(snapshot, onReport){
        this.snapshot = snapshot;
        this.onReport = onReport;
    }
    get hasPendingOutput() {
        return this.pending !== undefined;
    }
    attach(device, signal) {
        this.target = {
            device: device,
            signal: signal
        };
        this.queue = undefined;
    // Pending updates deliberately survive replacement before detection.
    }
    clear(reason) {
        this.cancelPending(reason);
        this.target = undefined;
        this.queue = undefined;
    }
    drain() {
        return this.queue;
    }
    cancelPending(reason) {
        const pending = this.pending;
        this.pending = undefined;
        pending?.forEach((update)=>update.reject(reason));
    }
    markReady() {
        const pending = this.pending;
        if (!pending) return;
        // Snapshot output after the input handler and synchronous updates finish.
        queueMicrotask(()=>{
            if (this.pending !== pending) return;
            this.pending = undefined;
            this.send().then(()=>pending.forEach((update)=>update.resolve()), (error)=>pending.forEach((update)=>update.reject(error)));
        });
    }
    enqueueOutputReport(device, reportId, data) {
        const signal = this.target?.signal;
        const send = ()=>{
            signal?.throwIfAborted();
            return device.sendReport(reportId, data);
        };
        const operation = this.queue ? this.queue.then(send) : send();
        const output = signal ? (0, $8T54A.abortable)(operation, signal) : operation;
        const queueTail = output.catch(()=>{});
        this.queue = queueTail;
        queueTail.then(()=>{
            if (this.queue === queueTail) this.queue = undefined;
        });
        return output;
    }
    async send() {
        const target = this.target;
        if (!target) throw new Error('Controller not connected. You must call .connect() first!');
        target.signal?.throwIfAborted();
        const state = this.snapshot();
        if (state.transport === (0, $34ia2.DualShock4Interface).Disconnected) return new Promise((resolve, reject)=>{
            this.pending ??= [];
            this.pending.push({
                resolve: resolve,
                reject: reject
            });
        });
        const report = (0, $jUnL6.buildOutputReport)(state.transport, state);
        this.onReport(report.raw);
        return this.enqueueOutputReport(target.device, report.reportId, report.data);
    }
}

});
parcelRegister("jUnL6", function(module, exports) {

$parcel$export(module.exports, "buildOutputReport", () => $44b461aa6fb3b2b0$export$2256684ac621e26f);
/**
 * @module
 * @internal
 */ 
var $34ia2 = parcelRequire("34ia2");

var $4bh06 = parcelRequire("4bh06");
function $44b461aa6fb3b2b0$export$2256684ac621e26f(transport, state) {
    if (transport === (0, $34ia2.DualShock4Interface).USB) {
        const report = new Uint8Array(32);
        // Report ID
        report[0] = 0x05;
        // Enable Rumble (0x01), Lightbar (0x02)
        report[1] = 3;
        // Light rumble motor
        report[4] = state.rumble.light;
        // Heavy rumble motor
        report[5] = state.rumble.heavy;
        // Lightbar Red
        report[6] = state.lightbar.r;
        // Lightbar Green
        report[7] = state.lightbar.g;
        // Lightbar Blue
        report[8] = state.lightbar.b;
        $44b461aa6fb3b2b0$var$writeLightbarBlink(report, 1, 9, state.lightbar);
        $44b461aa6fb3b2b0$var$writeAudioVolumes(report, 1, 19, state.audio);
        return {
            reportId: report[0],
            data: report.slice(1),
            raw: report.buffer
        };
    } else {
        const report = new Uint8Array(79);
        // Header
        report[0] = 0xA2;
        // Report ID
        report[1] = 0x11;
        // Poll Rate
        report[2] = 0x80;
        // Enable rumble and lights
        report[4] = 3;
        // Light rumble motor
        report[7] = state.rumble.light;
        // Heavy rumble motor
        report[8] = state.rumble.heavy;
        // Lightbar Red
        report[9] = state.lightbar.r;
        // Lightbar Green
        report[10] = state.lightbar.g;
        // Lightbar Blue
        report[11] = state.lightbar.b;
        $44b461aa6fb3b2b0$var$writeLightbarBlink(report, 4, 12, state.lightbar);
        $44b461aa6fb3b2b0$var$writeAudioVolumes(report, 4, 22, state.audio);
        new DataView(report.buffer).setUint32(75, (0, $4bh06.crc32)(report.subarray(0, 75)), true);
        return {
            reportId: report[1],
            data: report.slice(2),
            raw: report.buffer
        };
    }
}
/** Configure blinking only after an explicit request, including zero timings to stop it. */ function $44b461aa6fb3b2b0$var$writeLightbarBlink(report, flagsOffset, timingOffset, lightbar) {
    if (lightbar.blinkOn == null || lightbar.blinkOff == null) return;
    report[flagsOffset] |= 0x04;
    report[timingOffset] = lightbar.blinkOn / 10;
    report[timingOffset + 1] = lightbar.blinkOff / 10;
}
/** Set only explicitly configured audio levels, leaving other channels unchanged. */ function $44b461aa6fb3b2b0$var$writeAudioVolumes(report, flagsOffset, volumeOffset, audio) {
    if (!audio) return;
    if (audio.headphonesLeft !== null) {
        report[flagsOffset] |= 0x10;
        report[volumeOffset] = audio.headphonesLeft;
    }
    if (audio.headphonesRight !== null) {
        report[flagsOffset] |= 0x20;
        report[volumeOffset + 1] = audio.headphonesRight;
    }
    if (audio.microphone != null) {
        report[flagsOffset] |= 0x40;
        report[volumeOffset + 2] = audio.microphone;
    }
    if (audio.speaker !== null) {
        report[flagsOffset] |= 0x80;
        report[volumeOffset + 3] = audio.speaker;
    }
}

});


parcelRegister("62Nu6", function(module, exports) {

$parcel$export(module.exports, "normalizeInputReport", () => $c881df6fccb445cc$export$430904ad4eaf4afb);
$parcel$export(module.exports, "isValidBluetoothInputReport", () => $c881df6fccb445cc$export$101b5820e08526f4);
$parcel$export(module.exports, "detectInputInterface", () => $c881df6fccb445cc$export$ddde0e4448ce815);
$parcel$export(module.exports, "isMinimalBluetoothReport", () => $c881df6fccb445cc$export$56241768020e7624);
$parcel$export(module.exports, "getInputStateData", () => $c881df6fccb445cc$export$e59ed9c22e16b30f);
$parcel$export(module.exports, "updateControllerState", () => $c881df6fccb445cc$export$76fa79fdf2013a23);
/**
 * @module
 * @internal
 */ 
var $34ia2 = parcelRequire("34ia2");

var $etdYl = parcelRequire("etdYl");

var $4bh06 = parcelRequire("4bh06");

var $iFlaE = parcelRequire("iFlaE");
const $c881df6fccb445cc$var$basicInputReportId = 0x01;
const $c881df6fccb445cc$var$usbInputReportLength = 63;
const $c881df6fccb445cc$var$minimalBluetoothInputReportLength = 9;
const $c881df6fccb445cc$var$bluetoothInputReportLength = 77;
const $c881df6fccb445cc$var$bluetoothInputCrcOffset = 73;
const $c881df6fccb445cc$var$bluetoothInputStateOffset = 2;
function $c881df6fccb445cc$export$430904ad4eaf4afb(reportId, data, collections) {
    const reports = [];
    const visit = (items)=>{
        for (const collection of items){
            reports.push(...collection.inputReports ?? []);
            visit(collection.children ?? []);
        }
    };
    visit(collections);
    if (!reports.some((report)=>report.reportId === (0, $etdYl.bluetoothInputReportId))) return data;
    const length = reportId === $c881df6fccb445cc$var$basicInputReportId ? $c881df6fccb445cc$var$minimalBluetoothInputReportLength : reportId === (0, $etdYl.bluetoothInputReportId) ? $c881df6fccb445cc$var$bluetoothInputReportLength : undefined;
    if (!length || data.byteLength <= length) return data;
    // Chromium reconstructs each Windows report with padding to the collection's
    // maximum input length, including reports 0x01 (9 bytes) and 0x11 (77 bytes).
    const declaredLength = Math.max(0, ...reports.filter((report)=>report.reportId === reportId).map((report)=>Math.ceil((report.items ?? []).reduce((bits, item)=>bits + (item.reportSize ?? 0) * (item.reportCount ?? 0), 0) / 8)));
    if (data.byteLength !== declaredLength) return data;
    return new DataView(data.buffer, data.byteOffset, length);
}
function $c881df6fccb445cc$export$101b5820e08526f4(data) {
    if (data.byteLength !== $c881df6fccb445cc$var$bluetoothInputReportLength) return false;
    const crcData = new Uint8Array(2 + $c881df6fccb445cc$var$bluetoothInputCrcOffset);
    crcData[0] = 0xA1;
    crcData[1] = (0, $etdYl.bluetoothInputReportId);
    crcData.set(new Uint8Array(data.buffer, data.byteOffset, $c881df6fccb445cc$var$bluetoothInputCrcOffset), 2);
    return (0, $4bh06.crc32)(crcData) === data.getUint32($c881df6fccb445cc$var$bluetoothInputCrcOffset, true);
}
function $c881df6fccb445cc$export$ddde0e4448ce815(reportId, data) {
    if (reportId === $c881df6fccb445cc$var$basicInputReportId && data.byteLength === $c881df6fccb445cc$var$usbInputReportLength) return (0, $34ia2.DualShock4Interface).USB;
    if ($c881df6fccb445cc$export$56241768020e7624(reportId, data) || reportId === (0, $etdYl.bluetoothInputReportId)) return (0, $34ia2.DualShock4Interface).Bluetooth;
}
function $c881df6fccb445cc$export$56241768020e7624(reportId, data) {
    return reportId === $c881df6fccb445cc$var$basicInputReportId && data.byteLength === $c881df6fccb445cc$var$minimalBluetoothInputReportLength;
}
function $c881df6fccb445cc$export$e59ed9c22e16b30f(reportId, data, transport) {
    if (transport === (0, $34ia2.DualShock4Interface).USB && reportId === $c881df6fccb445cc$var$basicInputReportId && data.byteLength === $c881df6fccb445cc$var$usbInputReportLength) return data;
    if (transport === (0, $34ia2.DualShock4Interface).Bluetooth && $c881df6fccb445cc$export$56241768020e7624(reportId, data)) return data;
    if (transport === (0, $34ia2.DualShock4Interface).Bluetooth && reportId === (0, $etdYl.bluetoothInputReportId)) return new DataView(data.buffer, data.byteOffset + $c881df6fccb445cc$var$bluetoothInputStateOffset, $c881df6fccb445cc$var$bluetoothInputCrcOffset - $c881df6fccb445cc$var$bluetoothInputStateOffset);
}
function $c881df6fccb445cc$export$76fa79fdf2013a23(state, data) {
    $c881df6fccb445cc$var$updateAxes(state, data);
    $c881df6fccb445cc$var$updateButtons(state, data);
    state.reportCounter = data.getUint8(6) >> 2;
    // Basic Bluetooth input contains buttons/sticks/triggers, but no sensors.
    if (data.byteLength === $c881df6fccb445cc$var$minimalBluetoothInputReportLength) return;
    $c881df6fccb445cc$var$updateBattery(state, data);
    $c881df6fccb445cc$var$updateAccessoryConnections(state, data);
    $c881df6fccb445cc$var$updateMotion(state, data);
    $c881df6fccb445cc$var$updateTouchpad(state, data);
}
function $c881df6fccb445cc$var$updateAxes(state, data) {
    // Update thumbsticks
    state.axes.leftStickX = (0, $iFlaE.normalizeThumbstick)(data.getUint8(0));
    state.axes.leftStickY = (0, $iFlaE.normalizeThumbstick)(data.getUint8(1));
    state.axes.rightStickX = (0, $iFlaE.normalizeThumbstick)(data.getUint8(2));
    state.axes.rightStickY = (0, $iFlaE.normalizeThumbstick)(data.getUint8(3));
    // Update Triggers
    state.axes.l2 = (0, $iFlaE.normalizeTrigger)(data.getUint8(7));
    state.axes.r2 = (0, $iFlaE.normalizeTrigger)(data.getUint8(8));
}
function $c881df6fccb445cc$var$updateButtons(state, data) {
    // Update main buttons
    const faceButtonsAndDPad = data.getUint8(4);
    state.buttons.triangle = !!(faceButtonsAndDPad & 0x80);
    state.buttons.circle = !!(faceButtonsAndDPad & 0x40);
    state.buttons.cross = !!(faceButtonsAndDPad & 0x20);
    state.buttons.square = !!(faceButtonsAndDPad & 0x10);
    // Update D-Pad
    const dPad = faceButtonsAndDPad & 0x0F;
    state.buttons.dPadUp = dPad === 7 || dPad === 0 || dPad === 1;
    state.buttons.dPadRight = dPad === 1 || dPad === 2 || dPad === 3;
    state.buttons.dPadDown = dPad === 3 || dPad === 4 || dPad === 5;
    state.buttons.dPadLeft = dPad === 5 || dPad === 6 || dPad === 7;
    // Update additional buttons
    const shoulderMenuAndStickButtons = data.getUint8(5);
    state.buttons.l1 = !!(shoulderMenuAndStickButtons & 0x01);
    state.buttons.r1 = !!(shoulderMenuAndStickButtons & 0x02);
    state.buttons.l2 = !!(shoulderMenuAndStickButtons & 0x04);
    state.buttons.r2 = !!(shoulderMenuAndStickButtons & 0x08);
    state.buttons.share = !!(shoulderMenuAndStickButtons & 0x10);
    state.buttons.options = !!(shoulderMenuAndStickButtons & 0x20);
    state.buttons.l3 = !!(shoulderMenuAndStickButtons & 0x40);
    state.buttons.r3 = !!(shoulderMenuAndStickButtons & 0x80);
    const psAndTouchpadButtons = data.getUint8(6);
    state.buttons.playStation = !!(psAndTouchpadButtons & 0x01);
    state.buttons.touchPadClick = !!(psAndTouchpadButtons & 0x02);
}
function $c881df6fccb445cc$var$updateBattery(state, data) {
    // Update battery level
    const batteryData = data.getUint8(29);
    const batteryCapacity = batteryData & 0x0F;
    const cableConnected = Boolean(batteryData & 0x10);
    state.cableConnected = cableConnected;
    if (!cableConnected || batteryCapacity <= 10) {
        state.batteryCapacity = batteryCapacity < 10 ? batteryCapacity * 10 + 5 : 100;
        state.batteryStatus = cableConnected ? 'charging' : 'discharging';
    } else if (batteryCapacity === 11) {
        state.batteryCapacity = 100;
        state.batteryStatus = 'full';
    } else {
        state.batteryCapacity = null;
        state.batteryStatus = batteryCapacity >= 14 ? 'error' : 'unknown';
    }
}
function $c881df6fccb445cc$var$updateAccessoryConnections(state, data) {
    const status = data.getUint8(29);
    state.headphonesConnected = Boolean(status & 0x20);
    state.microphoneConnected = Boolean(status & 0x40);
    state.externalDeviceConnected = Boolean(status & 0x80);
}
function $c881df6fccb445cc$var$updateMotion(state, data) {
    state.sensorTimestamp = data.getUint16(9, true);
    // Update motion input
    state.axes.gyroX = data.getInt16(12, true);
    state.axes.gyroY = data.getInt16(14, true);
    state.axes.gyroZ = data.getInt16(16, true);
    state.axes.accelX = data.getInt16(18, true);
    state.axes.accelY = data.getInt16(20, true);
    state.axes.accelZ = data.getInt16(22, true);
}
function $c881df6fccb445cc$var$updateTouchpad(state, data) {
    // Update touchpad
    const frames = [];
    const touchReportSize = 9;
    const firstTouchReportOffset = 33;
    const maxTouchReports = Math.floor((data.byteLength - firstTouchReportOffset) / touchReportSize);
    const numTouchReports = Math.min(data.getUint8(32), maxTouchReports);
    for(let reportIndex = 0; reportIndex < numTouchReports; reportIndex++){
        const reportOffset = firstTouchReportOffset + reportIndex * touchReportSize;
        const touches = [];
        for(let pointIndex = 0; pointIndex < 2; pointIndex++){
            const pointOffset = reportOffset + 1 + pointIndex * 4;
            const contact = data.getUint8(pointOffset);
            if (!(contact & 0x80)) touches.push({
                touchId: contact & 0x7F,
                x: (data.getUint8(pointOffset + 2) & 0x0F) << 8 | data.getUint8(pointOffset + 1),
                y: data.getUint8(pointOffset + 3) << 4 | (data.getUint8(pointOffset + 2) & 0xF0) >> 4
            });
        }
        frames.push({
            frameCounter: data.getUint8(reportOffset),
            touches: touches
        });
    }
    const newestFrame = frames[frames.length - 1];
    state.touchpad.frames = frames;
    state.touchpad.frameCounter = newestFrame?.frameCounter ?? null;
    // Keep current contacts independently mutable from the recorded frame snapshot.
    state.touchpad.touches = newestFrame?.touches.map((touch)=>({
            ...touch
        })) ?? [];
}

});
parcelRegister("iFlaE", function(module, exports) {

$parcel$export(module.exports, "normalizeThumbstick", () => $a6498d7f8c587f28$export$e72163076922bd1c);
$parcel$export(module.exports, "normalizeTrigger", () => $a6498d7f8c587f28$export$3d93550646bfb03b);
/**
 * @module
 * @internal
 */ function $a6498d7f8c587f28$export$e72163076922bd1c(input, deadZone = 0) {
    const rel = (input - 128) / (input < 128 ? 128 : 127);
    if (Math.abs(rel) <= deadZone) return 0;
    return Math.min(1, Math.max(-1, rel));
}
function $a6498d7f8c587f28$export$3d93550646bfb03b(input, deadZone = 0) {
    const rel = input / 255;
    if (rel <= deadZone) return 0;
    return Math.min(1, Math.max(0, rel));
}

});




parcelRegister("7fVR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5486cfce9e08ddf0$export$2e2bcd8739ae039);
let $5486cfce9e08ddf0$var$script;



let $5486cfce9e08ddf0$var$initialize = ()=>{
    $5486cfce9e08ddf0$var$script = (parcelRequire("di93L"));
    if ($5486cfce9e08ddf0$var$script.__esModule) $5486cfce9e08ddf0$var$script = $5486cfce9e08ddf0$var$script.default;
    $5486cfce9e08ddf0$var$script.render = (parcelRequire("iY8q8")).render;
    (parcelRequire("aER3u")).default($5486cfce9e08ddf0$var$script);
    $5486cfce9e08ddf0$var$script.__scopeId = 'data-v-63f4ba';
    $5486cfce9e08ddf0$var$script.__file = "HeadphoneControls.vue";
};
$5486cfce9e08ddf0$var$initialize();
var $5486cfce9e08ddf0$export$2e2bcd8739ae039 = $5486cfce9e08ddf0$var$script;

});
parcelRegister("di93L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ad3fbd97b93a68d$export$2e2bcd8739ae039);
parcelRequire("ifmbe");
var $9Xpaa = parcelRequire("9Xpaa");
var $lG4lo = parcelRequire("lG4lo");

var $1rZet = parcelRequire("1rZet");

var $7zcQn = parcelRequire("7zcQn");

var $dSvR3 = parcelRequire("dSvR3");
const $9ad3fbd97b93a68d$var$exampleUrl = new URL((0, (/*@__PURE__*/$parcel$interopDefault($7zcQn))), document.baseURI);
const $9ad3fbd97b93a68d$var$messages = {
    ready: 'Output ready. Use the stereo test to confirm sound in your headphones.',
    'controller-disconnected': 'Connect the controller to use headphone audio.',
    'insecure-context': 'Audio output selection requires HTTPS or localhost.',
    'api-unavailable': 'This browser does not support the required audio output APIs.',
    'v1-usb-audio-unavailable': 'DualShock 4 v1 does not expose headphone audio over a USB cable.',
    'bluetooth-audio-unavailable': "Standard Bluetooth does not expose headphone audio on DualShock 4 v1 or v2. Use the Sony DUALSHOCK\xae4 USB Wireless Adaptor (CUH-ZWA1), or a USB cable for v2.",
    'selection-required': 'A possible controller output was found. Select it to verify routing.',
    'permission-or-device-unavailable': 'No controller output is visible yet. Allow access and check the connection.',
    'permission-denied': "Audio device access was denied or blocked. Check this site\u2019s browser permissions.",
    'output-unavailable': 'The selected output is unavailable. Check the connection and select an output again.',
    'enumeration-failed': 'The browser could not list audio devices. Try checking support again.',
    'routing-failed': 'The browser could not use this output. Select it again or check the system sound settings.'
};
var $9ad3fbd97b93a68d$export$2e2bcd8739ae039 = {
    name: 'HeadphoneControls',
    props: {
        headphones: {
            type: Object,
            required: true
        }
    },
    setup (props) {
        // Native Web Audio/EventTarget objects must not be called through Vue's deep proxy.
        const headphones = (0, $lG4lo.toRaw)(props.headphones);
        const support = (0, $lG4lo.shallowRef)(null);
        const outputs = (0, $lG4lo.shallowRef)([]);
        const selected = (0, $lG4lo.ref)('');
        const busy = (0, $lG4lo.ref)(false);
        const playing = (0, $lG4lo.ref)(false);
        const checking = (0, $lG4lo.ref)(false);
        const checkResult = (0, $lG4lo.ref)('');
        const error = (0, $lG4lo.ref)('');
        let refreshVersion = 0;
        let disposed = false;
        let activeStream = null;
        function stop() {
            headphones.stop();
            activeStream?.stop();
            activeStream = null;
            playing.value = false;
        }
        async function playDemoStream(createStream) {
            stop();
            const producer = createStream((cause)=>{
                if (activeStream !== producer) return;
                error.value = cause.message;
                stop();
            });
            activeStream = producer;
            producer.finished.then(()=>{
                if (activeStream === producer) stop();
            });
            try {
                await Promise.all([
                    headphones.play(producer.stream),
                    producer.start()
                ]);
                if (activeStream === producer) playing.value = true;
            } catch (cause) {
                if (activeStream === producer) stop();
                throw cause;
            }
        }
        async function refresh(selectController = false) {
            const version = ++refreshVersion;
            const next = await headphones.checkSupport();
            const availableOutputs = next.outputs.filter((0, $dSvR3.isControllerOutput));
            if (disposed || version !== refreshVersion) return;
            support.value = next;
            if (next.supported !== true) stop();
            selected.value = headphones.outputDeviceId || '';
            outputs.value = availableOutputs;
            if (selectController && next.supported !== false && !headphones.outputDeviceId) {
                if (availableOutputs.length === 1) {
                    await headphones.setOutput(availableOutputs[0].deviceId);
                    await refresh();
                }
            }
        }
        async function run(operation) {
            busy.value = true;
            error.value = '';
            try {
                await operation();
            } catch (cause) {
                if (cause.name !== 'AbortError') error.value = cause.message || String(cause);
            } finally{
                busy.value = false;
                if (!disposed) await refresh();
            }
        }
        async function checkSupport() {
            if (busy.value) return;
            busy.value = true;
            checking.value = true;
            checkResult.value = '';
            error.value = '';
            try {
                await refresh(true);
                if (!disposed) {
                    const result = support.value?.supported === true ? 'Audio output ready.' : support.value?.supported === false ? 'Audio unavailable.' : 'Support not confirmed.';
                    const reason = $9ad3fbd97b93a68d$var$messages[support.value?.reason] || 'Check the controller connection and audio output.';
                    checkResult.value = `${result} ${reason} Checked at ${new Date().toLocaleTimeString()}. Visible DualShock audio outputs: ${outputs.value.length}.`;
                }
            } catch (cause) {
                if (!disposed) error.value = cause.message || String(cause);
            } finally{
                checking.value = false;
                busy.value = false;
            }
        }
        const onChange = ()=>{
            refresh();
        };
        (0, $9Xpaa.onMounted)(()=>{
            headphones.addEventListener('change', onChange);
            run(()=>refresh(true));
        });
        (0, $9Xpaa.onBeforeUnmount)(()=>{
            disposed = true;
            headphones.removeEventListener('change', onChange);
            stop();
            headphones.reset();
        });
        return {
            support: support,
            outputs: outputs,
            selected: selected,
            busy: busy,
            playing: playing,
            checking: checking,
            checkResult: checkResult,
            error: error,
            checkSupport: checkSupport,
            ready: (0, $9Xpaa.computed)(()=>support.value?.supported === true),
            unavailable: (0, $9Xpaa.computed)(()=>[
                    'controller-disconnected',
                    'insecure-context',
                    'api-unavailable'
                ].includes(support.value?.reason)),
            supportMessage: (0, $9Xpaa.computed)(()=>$9ad3fbd97b93a68d$var$messages[support.value?.reason] || "Checking audio support\u2026"),
            requestOutput: ()=>run(async ()=>{
                    await headphones.requestOutput();
                    await refresh(true);
                }),
            selectOutput: ()=>run(()=>{
                    stop();
                    return headphones.setOutput(selected.value);
                }),
            testHeadphones: ()=>run(()=>playDemoStream((0, $1rZet.createHeadphoneTestStream))),
            stop: stop,
            playExample: ()=>run(()=>playDemoStream((onError)=>(0, $1rZet.createHeadphoneMediaStream)($9ad3fbd97b93a68d$var$exampleUrl, onError)))
        };
    }
};

});
parcelRegister("1rZet", function(module, exports) {

$parcel$export(module.exports, "createHeadphoneTestStream", () => $b4af6f2900ca7b7f$export$ba238d8b55d3c640);
$parcel$export(module.exports, "createHeadphoneMediaStream", () => $b4af6f2900ca7b7f$export$68c7b6e0c282bf1f);

var $8T54A = parcelRequire("8T54A");
function $b4af6f2900ca7b7f$var$createDemoStream(build, onError) {
    const context = new AudioContext();
    const destination = context.createMediaStreamDestination();
    const lifetime = new AbortController();
    let producer;
    let started = false;
    let finishPlayback;
    const finished = new Promise((resolve)=>{
        finishPlayback = resolve;
    });
    const close = (reason = new DOMException('Demo playback stopped.', 'AbortError'))=>{
        if (lifetime.signal.aborted) return;
        lifetime.abort(reason);
        producer?.stop();
        destination.stream.getTracks().forEach((track)=>track.stop());
        destination.disconnect();
        context.close().catch(()=>{});
        finishPlayback();
    };
    const stop = ()=>close();
    const fail = (error)=>{
        if (lifetime.signal.aborted) return;
        close(error);
        onError?.(error);
    };
    try {
        producer = build(context, destination, stop, fail);
    } catch (error) {
        close(error);
        throw error;
    }
    return {
        stream: destination.stream,
        finished: finished,
        stop: stop,
        async start () {
            lifetime.signal.throwIfAborted();
            if (started) throw new DOMException('Create a new demo stream to play again.', 'InvalidStateError');
            started = true;
            try {
                await (0, $8T54A.abortable)(Promise.all([
                    context.resume(),
                    Promise.resolve().then(()=>{
                        lifetime.signal.throwIfAborted();
                        return producer.start();
                    })
                ]), lifetime.signal);
            } catch (error) {
                close(error);
                throw error;
            }
        }
    };
}
function $b4af6f2900ca7b7f$export$ba238d8b55d3c640() {
    return $b4af6f2900ca7b7f$var$createDemoStream((context, destination, finish)=>{
        const merger = context.createChannelMerger(2);
        merger.connect(destination);
        const oscillators = [
            context.createOscillator(),
            context.createOscillator()
        ];
        const gains = [
            context.createGain(),
            context.createGain()
        ];
        let ended = 0;
        oscillators.forEach((oscillator, channel)=>{
            oscillator.frequency.value = channel ? 660 : 440;
            gains[channel].gain.value = 0;
            oscillator.connect(gains[channel]);
            gains[channel].connect(merger, 0, channel);
            oscillator.onended = ()=>{
                if (++ended === 2) finish();
            };
        });
        return {
            start () {
                oscillators.forEach((oscillator, channel)=>{
                    const start = context.currentTime + 0.05 + channel * 0.6;
                    const gain = gains[channel].gain;
                    gain.setValueAtTime(0, start);
                    gain.linearRampToValueAtTime(0.1, start + 0.01);
                    gain.setValueAtTime(0.1, start + 0.39);
                    gain.linearRampToValueAtTime(0, start + 0.4);
                    oscillator.start(start);
                    oscillator.stop(start + 0.4);
                });
            },
            stop () {
                oscillators.forEach((oscillator)=>{
                    oscillator.onended = null;
                    try {
                        oscillator.stop();
                    } catch  {}
                    oscillator.disconnect();
                });
                gains.forEach((gain)=>gain.disconnect());
                merger.disconnect();
            }
        };
    });
}
function $b4af6f2900ca7b7f$export$68c7b6e0c282bf1f(media, onError) {
    return $b4af6f2900ca7b7f$var$createDemoStream((context, destination, finish, fail)=>{
        const element = new Audio();
        const source = context.createMediaElementSource(element);
        source.connect(destination) // Never connect this producer to the default speakers.
        ;
        element.src = media.href;
        element.preload = 'metadata';
        element.onended = finish;
        element.onerror = ()=>fail(new Error(`Audio file could not be played: ${element.error?.message || 'unsupported format or decoding error'}`));
        return {
            start: ()=>element.play(),
            stop () {
                element.onended = null;
                element.onerror = null;
                element.pause();
                element.removeAttribute('src');
                element.load();
                source.disconnect();
            }
        };
    }, onError);
}

});

parcelRegister("7zcQn", function(module, exports) {
module.exports = import.meta.resolve("RooBD");

});


parcelRegister("iY8q8", function(module, exports) {

$parcel$export(module.exports, "render", () => $dcf45cb703eab202$export$b3890eb0ae9dca99);
parcelRequire("ifmbe");
var $9Xpaa = parcelRequire("9Xpaa");
var $h3IIu = parcelRequire("h3IIu");
var $jE6au = parcelRequire("jE6au");
const $dcf45cb703eab202$var$_hoisted_1 = {
    class: "audio-controls",
    "aria-label": "Headphone audio"
};
const $dcf45cb703eab202$var$_hoisted_2 = {
    role: "status"
};
const $dcf45cb703eab202$var$_hoisted_3 = {
    key: 0
};
const $dcf45cb703eab202$var$_hoisted_4 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_5 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_6 = {
    role: "status",
    "aria-atomic": "true"
};
const $dcf45cb703eab202$var$_hoisted_7 = {
    key: 1
};
const $dcf45cb703eab202$var$_hoisted_8 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_9 = [
    "value"
];
const $dcf45cb703eab202$var$_hoisted_10 = {
    key: 2,
    role: "status"
};
const $dcf45cb703eab202$var$_hoisted_11 = {
    class: "audio-actions"
};
const $dcf45cb703eab202$var$_hoisted_12 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_13 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_14 = [
    "disabled"
];
const $dcf45cb703eab202$var$_hoisted_15 = {
    key: 3,
    role: "alert"
};
function $dcf45cb703eab202$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("section", $dcf45cb703eab202$var$_hoisted_1, [
        _cache[9] || (_cache[9] = (0, $9Xpaa.createElementVNode)("h4", null, "Headphone audio", -1)),
        (0, $9Xpaa.createElementVNode)("p", $dcf45cb703eab202$var$_hoisted_2, (0, $h3IIu.toDisplayString)($setup.supportMessage), 1),
        $setup.support?.requiresAdapter ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("p", $dcf45cb703eab202$var$_hoisted_3, " Use the Sony DUALSHOCK\xae4 USB Wireless Adaptor (CUH-ZWA1) for wireless headphone audio on PC. An ordinary Bluetooth dongle does not replace this receiver. DualShock 4 v2 also supports wired USB audio. ")) : (0, $9Xpaa.createCommentVNode)("", true),
        _cache[10] || (_cache[10] = (0, $9Xpaa.createElementVNode)("p", null, [
            (0, $9Xpaa.createTextVNode)(" Plug headphones into the controller and look for "),
            (0, $9Xpaa.createElementVNode)("b", null, "Wireless Controller"),
            (0, $9Xpaa.createTextVNode)(" or "),
            (0, $9Xpaa.createElementVNode)("b", null, "DUALSHOCK\xae4 USB Wireless Adaptor"),
            (0, $9Xpaa.createTextVNode)(". If several controllers share this name, select an output and use the left/right test to identify it. ")
        ], -1)),
        (0, $9Xpaa.createElementVNode)("button", {
            type: "button",
            disabled: $setup.busy || $setup.unavailable,
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.requestOutput && $setup.requestOutput(...args))
        }, "Allow audio output access", 8, $dcf45cb703eab202$var$_hoisted_4),
        (0, $9Xpaa.createElementVNode)("button", {
            type: "button",
            disabled: $setup.busy,
            onClick: _cache[1] || (_cache[1] = (...args)=>$setup.checkSupport && $setup.checkSupport(...args))
        }, (0, $h3IIu.toDisplayString)($setup.checking ? "Checking\u2026" : 'Check support'), 9, $dcf45cb703eab202$var$_hoisted_5),
        (0, $9Xpaa.createElementVNode)("p", $dcf45cb703eab202$var$_hoisted_6, (0, $h3IIu.toDisplayString)($setup.checkResult), 1),
        _cache[11] || (_cache[11] = (0, $9Xpaa.createElementVNode)("p", {
            class: "audio-hint"
        }, " The browser opens an output picker when available. Otherwise it asks for microphone access to reveal the output list; capture stops immediately and no recording is saved. ", -1)),
        $setup.outputs.length ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("label", $dcf45cb703eab202$var$_hoisted_7, [
            _cache[8] || (_cache[8] = (0, $9Xpaa.createTextVNode)(" Audio output ", -1)),
            (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.selected = $event),
                disabled: $setup.busy,
                onChange: _cache[3] || (_cache[3] = (...args)=>$setup.selectOutput && $setup.selectOutput(...args))
            }, [
                _cache[7] || (_cache[7] = (0, $9Xpaa.createElementVNode)("option", {
                    disabled: "",
                    value: ""
                }, "Select an output", -1)),
                ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), null, (0, $9Xpaa.renderList)($setup.outputs, (output, index)=>{
                    return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("option", {
                        key: output.deviceId,
                        value: output.deviceId
                    }, (0, $h3IIu.toDisplayString)(index + 1) + ". " + (0, $h3IIu.toDisplayString)(output.label || 'Unnamed output'), 9, $dcf45cb703eab202$var$_hoisted_9);
                }), 128))
            ], 40, $dcf45cb703eab202$var$_hoisted_8), [
                [
                    (0, $jE6au.vModelSelect),
                    $setup.selected
                ]
            ])
        ])) : $setup.support && !$setup.unavailable ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("p", $dcf45cb703eab202$var$_hoisted_10, " DualShock audio output not found. Allow audio output access and check the connection: use a USB cable for DualShock 4 v2 or the Sony DUALSHOCK\xae4 USB Wireless Adaptor (CUH-ZWA1). ")) : (0, $9Xpaa.createCommentVNode)("", true),
        (0, $9Xpaa.createElementVNode)("div", $dcf45cb703eab202$var$_hoisted_11, [
            (0, $9Xpaa.createElementVNode)("button", {
                type: "button",
                disabled: $setup.busy || !$setup.ready,
                onClick: _cache[4] || (_cache[4] = (...args)=>$setup.testHeadphones && $setup.testHeadphones(...args))
            }, "Test left, then right", 8, $dcf45cb703eab202$var$_hoisted_12),
            (0, $9Xpaa.createElementVNode)("button", {
                type: "button",
                disabled: $setup.busy || !$setup.ready,
                onClick: _cache[5] || (_cache[5] = (...args)=>$setup.playExample && $setup.playExample(...args))
            }, "Play example.mp3", 8, $dcf45cb703eab202$var$_hoisted_13),
            (0, $9Xpaa.createElementVNode)("button", {
                type: "button",
                disabled: !$setup.playing,
                onClick: _cache[6] || (_cache[6] = (...args)=>$setup.stop && $setup.stop(...args))
            }, "Stop audio", 8, $dcf45cb703eab202$var$_hoisted_14)
        ]),
        _cache[12] || (_cache[12] = (0, $9Xpaa.createElementVNode)("p", {
            class: "audio-hint"
        }, "Playback uses the selected output; it does not change system audio.", -1)),
        $setup.error ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("p", $dcf45cb703eab202$var$_hoisted_15, (0, $h3IIu.toDisplayString)($setup.error), 1)) : (0, $9Xpaa.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("aER3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c26cb7623ff69a4$export$2e2bcd8739ae039);
let $7c26cb7623ff69a4$var$NOOP = ()=>{};
var $7c26cb7623ff69a4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("e1hCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34ed4263033fc2a$export$2e2bcd8739ae039);
let $a34ed4263033fc2a$var$script;



let $a34ed4263033fc2a$var$initialize = ()=>{
    $a34ed4263033fc2a$var$script = (parcelRequire("56KoT"));
    if ($a34ed4263033fc2a$var$script.__esModule) $a34ed4263033fc2a$var$script = $a34ed4263033fc2a$var$script.default;
    $a34ed4263033fc2a$var$script.render = (parcelRequire("cZsX5")).render;
    (parcelRequire("4Y54W")).default($a34ed4263033fc2a$var$script);
    $a34ed4263033fc2a$var$script.__scopeId = 'data-v-952aa5';
    $a34ed4263033fc2a$var$script.__file = "MicrophoneControls.vue";
};
$a34ed4263033fc2a$var$initialize();
var $a34ed4263033fc2a$export$2e2bcd8739ae039 = $a34ed4263033fc2a$var$script;

});
parcelRegister("56KoT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3b818170a55d34b8$export$2e2bcd8739ae039);
parcelRequire("ifmbe");
var $9Xpaa = parcelRequire("9Xpaa");
var $lG4lo = parcelRequire("lG4lo");

var $lBJQ5 = parcelRequire("lBJQ5");
const $3b818170a55d34b8$var$messages = {
    ready: 'Microphone capture is active. The level meter helps confirm the headset input.',
    'controller-disconnected': 'Connect the controller to use its headset microphone.',
    'insecure-context': 'Microphone access requires HTTPS or localhost.',
    'api-unavailable': 'This browser does not support microphone capture.',
    'v1-usb-audio-unavailable': 'DualShock 4 v1 does not expose headset audio through a USB cable.',
    'bluetooth-audio-unavailable': 'Standard Bluetooth does not expose the DualShock 4 headset microphone.',
    'selection-required': 'Select the controller microphone before starting capture.',
    'capture-required': 'Input selected. Start the microphone to verify capture.',
    'permission-or-device-unavailable': 'No controller microphone is visible yet. Allow access and check the connection.',
    'permission-denied': "Microphone access was denied or blocked. Check this site\u2019s browser permissions.",
    'input-unavailable': 'The microphone is unavailable or has ended. Check the connection and select an input again.',
    'enumeration-failed': 'The browser could not list microphones. Try checking support again.',
    'capture-failed': 'Capture failed. Check system input settings and whether another application is using the microphone.'
};
var $3b818170a55d34b8$export$2e2bcd8739ae039 = {
    name: 'MicrophoneControls',
    props: {
        microphone: {
            type: Object,
            required: true
        }
    },
    setup (props) {
        const microphone = (0, $lG4lo.toRaw)(props.microphone);
        const support = (0, $lG4lo.shallowRef)(null);
        const inputs = (0, $lG4lo.shallowRef)([]);
        const selected = (0, $lG4lo.ref)('');
        const busy = (0, $lG4lo.ref)(false);
        const capturing = (0, $lG4lo.ref)(false);
        const level = (0, $lG4lo.ref)(0);
        const error = (0, $lG4lo.ref)('');
        let disposed = false;
        let refreshVersion = 0;
        let actionVersion = 0;
        let context = null;
        let source = null;
        let animation = 0;
        function releaseMeter() {
            cancelAnimationFrame(animation);
            animation = 0;
            source?.disconnect();
            source = null;
            if (context) context.close().catch(()=>{});
            context = null;
            level.value = 0;
        }
        async function refresh() {
            const version = ++refreshVersion;
            const next = await microphone.checkSupport();
            if (disposed || version !== refreshVersion) return;
            support.value = next;
            inputs.value = next.inputs.filter((0, $lBJQ5.isControllerInput));
            selected.value = inputs.value.some((input)=>input.deviceId === microphone.inputDeviceId) ? microphone.inputDeviceId : '';
            capturing.value = !!microphone.stream;
            if (!capturing.value && !busy.value) releaseMeter();
        }
        async function run(operation) {
            const version = ++actionVersion;
            busy.value = true;
            error.value = '';
            try {
                await operation();
            } catch (cause) {
                if (!disposed && version === actionVersion && cause.name !== 'AbortError') error.value = cause.message || String(cause);
            } finally{
                if (!disposed && version === actionVersion) {
                    busy.value = false;
                    await refresh();
                }
            }
        }
        function stop() {
            actionVersion++;
            busy.value = false;
            microphone.stop();
            capturing.value = false;
            releaseMeter();
        }
        async function startMeter() {
            releaseMeter();
            if (typeof AudioContext === 'undefined') throw new Error('This browser cannot display a live microphone level.');
            const activeContext = new AudioContext();
            context = activeContext;
            try {
                // Start both browser operations directly from the click, preserving user activation.
                const [stream] = await Promise.all([
                    microphone.start(),
                    activeContext.resume()
                ]);
                if (disposed || context !== activeContext || microphone.stream !== stream) return;
                source = activeContext.createMediaStreamSource(stream);
                const analyser = activeContext.createAnalyser();
                analyser.fftSize = 1024;
                source.connect(analyser);
                // The analyser has no connection to destination: there is no microphone feedback.
                const samples = new Float32Array(analyser.fftSize);
                const update = ()=>{
                    if (disposed || context !== activeContext || microphone.stream !== stream) {
                        releaseMeter();
                        return;
                    }
                    analyser.getFloatTimeDomainData(samples);
                    const rms = Math.sqrt(samples.reduce((sum, sample)=>sum + sample * sample, 0) / samples.length);
                    level.value = Math.min(1, rms);
                    animation = requestAnimationFrame(update);
                };
                update();
            } catch (cause) {
                if (context === activeContext) {
                    microphone.stop();
                    releaseMeter();
                }
                throw cause;
            }
        }
        const onChange = ()=>{
            capturing.value = !!microphone.stream;
            if (!capturing.value && !busy.value) releaseMeter();
            refresh();
        };
        (0, $9Xpaa.onMounted)(()=>{
            microphone.addEventListener('change', onChange);
            refresh();
        });
        (0, $9Xpaa.onBeforeUnmount)(()=>{
            disposed = true;
            actionVersion++;
            microphone.removeEventListener('change', onChange);
            microphone.reset();
            releaseMeter();
        });
        return {
            support: support,
            inputs: inputs,
            selected: selected,
            busy: busy,
            capturing: capturing,
            level: level,
            error: error,
            stop: stop,
            supportMessage: (0, $9Xpaa.computed)(()=>$3b818170a55d34b8$var$messages[support.value?.reason] || "Checking microphone support\u2026"),
            unavailable: (0, $9Xpaa.computed)(()=>[
                    'controller-disconnected',
                    'insecure-context',
                    'api-unavailable'
                ].includes(support.value?.reason)),
            requestInput: ()=>run(()=>{
                    releaseMeter();
                    return microphone.requestInput();
                }),
            selectInput: ()=>run(()=>{
                    releaseMeter();
                    return microphone.setInput(selected.value);
                }),
            checkSupport: ()=>run(refresh),
            start: ()=>run(startMeter)
        };
    }
};

});

parcelRegister("cZsX5", function(module, exports) {

$parcel$export(module.exports, "render", () => $9751a3c8d5dd9b18$export$b3890eb0ae9dca99);
parcelRequire("ifmbe");
var $9Xpaa = parcelRequire("9Xpaa");
var $h3IIu = parcelRequire("h3IIu");
var $jE6au = parcelRequire("jE6au");
const $9751a3c8d5dd9b18$var$_hoisted_1 = {
    class: "audio-controls",
    "aria-label": "Headset microphone"
};
const $9751a3c8d5dd9b18$var$_hoisted_2 = {
    role: "status"
};
const $9751a3c8d5dd9b18$var$_hoisted_3 = [
    "disabled"
];
const $9751a3c8d5dd9b18$var$_hoisted_4 = [
    "disabled"
];
const $9751a3c8d5dd9b18$var$_hoisted_5 = {
    key: 0
};
const $9751a3c8d5dd9b18$var$_hoisted_6 = [
    "disabled"
];
const $9751a3c8d5dd9b18$var$_hoisted_7 = [
    "value"
];
const $9751a3c8d5dd9b18$var$_hoisted_8 = {
    key: 1,
    role: "status"
};
const $9751a3c8d5dd9b18$var$_hoisted_9 = {
    class: "audio-actions"
};
const $9751a3c8d5dd9b18$var$_hoisted_10 = [
    "disabled"
];
const $9751a3c8d5dd9b18$var$_hoisted_11 = [
    "disabled"
];
const $9751a3c8d5dd9b18$var$_hoisted_12 = [
    "value"
];
const $9751a3c8d5dd9b18$var$_hoisted_13 = {
    role: "status"
};
const $9751a3c8d5dd9b18$var$_hoisted_14 = {
    key: 2,
    role: "alert"
};
function $9751a3c8d5dd9b18$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("section", $9751a3c8d5dd9b18$var$_hoisted_1, [
        _cache[9] || (_cache[9] = (0, $9Xpaa.createElementVNode)("h4", null, "Headset microphone", -1)),
        (0, $9Xpaa.createElementVNode)("p", $9751a3c8d5dd9b18$var$_hoisted_2, (0, $h3IIu.toDisplayString)($setup.supportMessage), 1),
        _cache[10] || (_cache[10] = (0, $9Xpaa.createElementVNode)("p", null, [
            (0, $9Xpaa.createTextVNode)(" Plug a headset with a microphone into the controller\u2019s 3.5 mm jack. Select its "),
            (0, $9Xpaa.createElementVNode)("b", null, "Wireless Controller"),
            (0, $9Xpaa.createTextVNode)(" or "),
            (0, $9Xpaa.createElementVNode)("b", null, "DUALSHOCK\xae4 USB Wireless Adaptor"),
            (0, $9Xpaa.createTextVNode)(" input, then start the microphone and speak to check the level. If several controllers have the same name, test them individually. ")
        ], -1)),
        _cache[11] || (_cache[11] = (0, $9Xpaa.createElementVNode)("p", {
            class: "audio-hint"
        }, " The headset microphone is available with a USB cable on DualShock 4 v2, or with the Sony DUALSHOCK\xae4 USB Wireless Adaptor (CUH-ZWA1) on v1/v2, provided the system exposes its audio input. An ordinary Bluetooth dongle does not support the headset microphone. ", -1)),
        (0, $9Xpaa.createElementVNode)("button", {
            type: "button",
            disabled: $setup.busy || $setup.unavailable,
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.requestInput && $setup.requestInput(...args))
        }, "Allow microphone access", 8, $9751a3c8d5dd9b18$var$_hoisted_3),
        (0, $9Xpaa.createElementVNode)("button", {
            type: "button",
            disabled: $setup.busy,
            onClick: _cache[1] || (_cache[1] = (...args)=>$setup.checkSupport && $setup.checkSupport(...args))
        }, "Check microphone support", 8, $9751a3c8d5dd9b18$var$_hoisted_4),
        _cache[12] || (_cache[12] = (0, $9Xpaa.createElementVNode)("p", {
            class: "audio-hint"
        }, " Allow access briefly opens the browser\u2019s default microphone to reveal device names, then stops it. Start microphone captures only the input you select. No recording is saved or sent, and your voice is not played back. ", -1)),
        $setup.inputs.length ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("label", $9751a3c8d5dd9b18$var$_hoisted_5, [
            _cache[7] || (_cache[7] = (0, $9Xpaa.createTextVNode)(" Microphone input ", -1)),
            (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.selected = $event),
                disabled: $setup.busy || $setup.unavailable,
                onChange: _cache[3] || (_cache[3] = (...args)=>$setup.selectInput && $setup.selectInput(...args))
            }, [
                _cache[6] || (_cache[6] = (0, $9Xpaa.createElementVNode)("option", {
                    disabled: "",
                    value: ""
                }, "Select a microphone", -1)),
                ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), null, (0, $9Xpaa.renderList)($setup.inputs, (input, index)=>{
                    return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("option", {
                        key: input.deviceId,
                        value: input.deviceId
                    }, (0, $h3IIu.toDisplayString)(index + 1) + ". " + (0, $h3IIu.toDisplayString)(input.label || 'Unnamed input'), 9, $9751a3c8d5dd9b18$var$_hoisted_7);
                }), 128))
            ], 40, $9751a3c8d5dd9b18$var$_hoisted_6), [
                [
                    (0, $jE6au.vModelSelect),
                    $setup.selected
                ]
            ])
        ])) : $setup.support && !$setup.unavailable ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("p", $9751a3c8d5dd9b18$var$_hoisted_8, " No controller microphone is visible. Allow microphone access and check the headset, controller connection and system input settings. ")) : (0, $9Xpaa.createCommentVNode)("", true),
        (0, $9Xpaa.createElementVNode)("div", $9751a3c8d5dd9b18$var$_hoisted_9, [
            (0, $9Xpaa.createElementVNode)("button", {
                type: "button",
                disabled: $setup.busy || $setup.unavailable || !$setup.selected || $setup.capturing,
                onClick: _cache[4] || (_cache[4] = (...args)=>$setup.start && $setup.start(...args))
            }, "Start microphone", 8, $9751a3c8d5dd9b18$var$_hoisted_10),
            (0, $9Xpaa.createElementVNode)("button", {
                type: "button",
                disabled: !$setup.busy && !$setup.capturing,
                onClick: _cache[5] || (_cache[5] = (...args)=>$setup.stop && $setup.stop(...args))
            }, "Stop microphone", 8, $9751a3c8d5dd9b18$var$_hoisted_11)
        ]),
        (0, $9Xpaa.createElementVNode)("label", null, [
            _cache[8] || (_cache[8] = (0, $9Xpaa.createTextVNode)(" Input level ", -1)),
            (0, $9Xpaa.createElementVNode)("meter", {
                min: "0",
                max: "1",
                value: $setup.level,
                "aria-label": "Microphone input level"
            }, null, 8, $9751a3c8d5dd9b18$var$_hoisted_12),
            (0, $9Xpaa.createTextVNode)(" " + (0, $h3IIu.toDisplayString)(Math.round($setup.level * 100)) + "% ", 1)
        ]),
        (0, $9Xpaa.createElementVNode)("p", $9751a3c8d5dd9b18$var$_hoisted_13, (0, $h3IIu.toDisplayString)($setup.capturing ? 'Microphone is active. Speak into the headset.' : 'Microphone is stopped.'), 1),
        $setup.error ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("p", $9751a3c8d5dd9b18$var$_hoisted_14, (0, $h3IIu.toDisplayString)($setup.error), 1)) : (0, $9Xpaa.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("4Y54W", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e0b490e9f8ff06$export$2e2bcd8739ae039);
let $39e0b490e9f8ff06$var$NOOP = ()=>{};
var $39e0b490e9f8ff06$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("8s5Dp", function(module, exports) {

$parcel$export(module.exports, "render", () => $62754f29111e4955$export$b3890eb0ae9dca99);
parcelRequire("ifmbe");
var $9Xpaa = parcelRequire("9Xpaa");
var $h3IIu = parcelRequire("h3IIu");
var $jE6au = parcelRequire("jE6au");
const $62754f29111e4955$var$_hoisted_1 = {
    class: "params"
};
const $62754f29111e4955$var$_hoisted_2 = [
    "onUpdate:modelValue"
];
const $62754f29111e4955$var$_hoisted_3 = [
    "onUpdate:modelValue"
];
const $62754f29111e4955$var$_hoisted_4 = [
    "onUpdate:modelValue"
];
const $62754f29111e4955$var$_hoisted_5 = [
    "onUpdate:modelValue"
];
const $62754f29111e4955$var$_hoisted_6 = [
    "onUpdate:modelValue"
];
const $62754f29111e4955$var$_hoisted_7 = {
    class: "buttons"
};
const $62754f29111e4955$var$_hoisted_8 = {
    class: "name"
};
const $62754f29111e4955$var$_hoisted_9 = {
    class: "analogs"
};
const $62754f29111e4955$var$_hoisted_10 = {
    class: "name"
};
const $62754f29111e4955$var$_hoisted_11 = {
    class: "touchpad"
};
const $62754f29111e4955$var$_hoisted_12 = {
    key: 0
};
const $62754f29111e4955$var$_hoisted_13 = {
    key: 1
};
function $62754f29111e4955$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HeadphoneControls = (0, $9Xpaa.resolveComponent)("HeadphoneControls");
    const _component_MicrophoneControls = (0, $9Xpaa.resolveComponent)("MicrophoneControls");
    return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", null, [
        ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), null, (0, $9Xpaa.renderList)($data.controllers, (controller, i)=>{
            return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", {
                key: i
            }, [
                (0, $9Xpaa.createElementVNode)("h2", null, " Controller #" + (0, $h3IIu.toDisplayString)(i) + " (" + (0, $h3IIu.toDisplayString)(controller.state.interface.toUpperCase()) + ", Battery: " + (0, $h3IIu.toDisplayString)(controller.state.batteryCapacity === null ? 'unknown' : `${controller.state.batteryCapacity}%`) + " [" + (0, $h3IIu.toDisplayString)(controller.state.batteryStatus) + "]) ", 1),
                (0, $9Xpaa.createElementVNode)("div", $62754f29111e4955$var$_hoisted_1, [
                    _cache[1] || (_cache[1] = (0, $9Xpaa.createElementVNode)("h4", null, "Lightbar Color", -1)),
                    _cache[2] || (_cache[2] = (0, $9Xpaa.createElementVNode)("label", null, "R: ", -1)),
                    (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "255",
                        "onUpdate:modelValue": ($event)=>controller.lightbar.r = $event
                    }, null, 8, $62754f29111e4955$var$_hoisted_2), [
                        [
                            (0, $jE6au.vModelText),
                            controller.lightbar.r
                        ]
                    ]),
                    (0, $9Xpaa.createTextVNode)(" (" + (0, $h3IIu.toDisplayString)(controller.lightbar.r) + ")", 1),
                    _cache[3] || (_cache[3] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
                    _cache[4] || (_cache[4] = (0, $9Xpaa.createElementVNode)("label", null, "G: ", -1)),
                    (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "255",
                        "onUpdate:modelValue": ($event)=>controller.lightbar.g = $event
                    }, null, 8, $62754f29111e4955$var$_hoisted_3), [
                        [
                            (0, $jE6au.vModelText),
                            controller.lightbar.g
                        ]
                    ]),
                    (0, $9Xpaa.createTextVNode)(" (" + (0, $h3IIu.toDisplayString)(controller.lightbar.g) + ")", 1),
                    _cache[5] || (_cache[5] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
                    _cache[6] || (_cache[6] = (0, $9Xpaa.createElementVNode)("label", null, "B: ", -1)),
                    (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "255",
                        "onUpdate:modelValue": ($event)=>controller.lightbar.b = $event
                    }, null, 8, $62754f29111e4955$var$_hoisted_4), [
                        [
                            (0, $jE6au.vModelText),
                            controller.lightbar.b
                        ]
                    ]),
                    (0, $9Xpaa.createTextVNode)(" (" + (0, $h3IIu.toDisplayString)(controller.lightbar.b) + ") ", 1),
                    _cache[7] || (_cache[7] = (0, $9Xpaa.createElementVNode)("h4", null, "Rumble", -1)),
                    _cache[8] || (_cache[8] = (0, $9Xpaa.createElementVNode)("label", null, "Weak: ", -1)),
                    (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "255",
                        "onUpdate:modelValue": ($event)=>controller.rumble.light = $event
                    }, null, 8, $62754f29111e4955$var$_hoisted_5), [
                        [
                            (0, $jE6au.vModelText),
                            controller.rumble.light
                        ]
                    ]),
                    (0, $9Xpaa.createTextVNode)(" (" + (0, $h3IIu.toDisplayString)(controller.rumble.light) + ")", 1),
                    _cache[9] || (_cache[9] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
                    _cache[10] || (_cache[10] = (0, $9Xpaa.createElementVNode)("label", null, "Strong: ", -1)),
                    (0, $9Xpaa.withDirectives)((0, $9Xpaa.createElementVNode)("input", {
                        type: "range",
                        min: "0",
                        max: "255",
                        "onUpdate:modelValue": ($event)=>controller.rumble.heavy = $event
                    }, null, 8, $62754f29111e4955$var$_hoisted_6), [
                        [
                            (0, $jE6au.vModelText),
                            controller.rumble.heavy
                        ]
                    ]),
                    (0, $9Xpaa.createTextVNode)(" (" + (0, $h3IIu.toDisplayString)(controller.rumble.heavy) + ") ", 1)
                ]),
                (0, $9Xpaa.createVNode)(_component_HeadphoneControls, {
                    headphones: controller.audio.headphones
                }, null, 8, [
                    "headphones"
                ]),
                (0, $9Xpaa.createVNode)(_component_MicrophoneControls, {
                    microphone: controller.audio.microphone
                }, null, 8, [
                    "microphone"
                ]),
                (0, $9Xpaa.createElementVNode)("div", $62754f29111e4955$var$_hoisted_7, [
                    _cache[12] || (_cache[12] = (0, $9Xpaa.createElementVNode)("h3", null, "Buttons", -1)),
                    ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), null, (0, $9Xpaa.renderList)(controller.state.buttons, (button, btnKey)=>{
                        return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", {
                            class: "btn",
                            key: btnKey,
                            style: (0, $h3IIu.normalizeStyle)({
                                opacity: button ? 1 : 0.5
                            })
                        }, [
                            (0, $9Xpaa.createElementVNode)("b", $62754f29111e4955$var$_hoisted_8, (0, $h3IIu.toDisplayString)(btnKey), 1),
                            _cache[11] || (_cache[11] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
                            (0, $9Xpaa.createTextVNode)(" " + (0, $h3IIu.toDisplayString)(button ? '1.00' : '0.00'), 1)
                        ], 4);
                    }), 128))
                ]),
                (0, $9Xpaa.createElementVNode)("div", $62754f29111e4955$var$_hoisted_9, [
                    _cache[14] || (_cache[14] = (0, $9Xpaa.createElementVNode)("h3", null, "Analogs", -1)),
                    ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), null, (0, $9Xpaa.renderList)(controller.state.axes, (analog, anaKey)=>{
                        return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", {
                            class: "analog",
                            key: anaKey,
                            style: (0, $h3IIu.normalizeStyle)({
                                opacity: 0.5 + Math.min(0.5, Math.abs(analog) * .5)
                            })
                        }, [
                            (0, $9Xpaa.createElementVNode)("b", $62754f29111e4955$var$_hoisted_10, (0, $h3IIu.toDisplayString)(anaKey), 1),
                            _cache[13] || (_cache[13] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
                            (0, $9Xpaa.createTextVNode)(" " + (0, $h3IIu.toDisplayString)(analog.toFixed(2)), 1)
                        ], 4);
                    }), 128))
                ]),
                (0, $9Xpaa.createElementVNode)("div", $62754f29111e4955$var$_hoisted_11, [
                    _cache[15] || (_cache[15] = (0, $9Xpaa.createElementVNode)("h3", null, "Touchpad", -1)),
                    !controller.state.touchpad.touches.length ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", $62754f29111e4955$var$_hoisted_12, " No touches detected. ")) : ((0, $9Xpaa.openBlock)(true), (0, $9Xpaa.createElementBlock)((0, $9Xpaa.Fragment), {
                        key: 1
                    }, (0, $9Xpaa.renderList)(controller.state.touchpad.touches, (touch)=>{
                        return (0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", {
                            key: touch.touchId
                        }, [
                            (0, $9Xpaa.createElementVNode)("b", null, "Touch #" + (0, $h3IIu.toDisplayString)(touch.touchId) + ":", 1),
                            (0, $9Xpaa.createTextVNode)(" " + (0, $h3IIu.toDisplayString)(touch.x) + ", " + (0, $h3IIu.toDisplayString)(touch.y), 1)
                        ]);
                    }), 128))
                ])
            ]);
        }), 128)),
        _cache[17] || (_cache[17] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
        _cache[18] || (_cache[18] = (0, $9Xpaa.createElementVNode)("br", null, null, -1)),
        $options.hidSupported ? ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.addController && $options.addController(...args))
        }, "Connect Controller")) : ((0, $9Xpaa.openBlock)(), (0, $9Xpaa.createElementBlock)("div", $62754f29111e4955$var$_hoisted_13, [
            ..._cache[16] || (_cache[16] = [
                (0, $9Xpaa.createTextVNode)(" WebHID is not available in this browser or page context.", -1),
                (0, $9Xpaa.createElementVNode)("br", null, null, -1),
                (0, $9Xpaa.createTextVNode)(" Use a supported desktop Chromium browser over HTTPS or localhost, and ", -1),
                (0, $9Xpaa.createElementVNode)("a", {
                    href: "https://developer.mozilla.org/docs/Web/API/WebHID_API#browser_compatibility"
                }, "check current browser compatibility", -1),
                (0, $9Xpaa.createTextVNode)(". ", -1)
            ])
        ]))
    ]);
}

});

parcelRegister("5FO2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $42179987b7ee7ba9$export$2e2bcd8739ae039);
let $42179987b7ee7ba9$var$NOOP = ()=>{};
var $42179987b7ee7ba9$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ifmbe");
var $jE6au = parcelRequire("jE6au");
let $245a20d5ca697fd8$var$script;



let $245a20d5ca697fd8$var$initialize = ()=>{
    $245a20d5ca697fd8$var$script = (parcelRequire("cgW3F"));
    if ($245a20d5ca697fd8$var$script.__esModule) $245a20d5ca697fd8$var$script = $245a20d5ca697fd8$var$script.default;
    $245a20d5ca697fd8$var$script.render = (parcelRequire("8s5Dp")).render;
    (parcelRequire("5FO2I")).default($245a20d5ca697fd8$var$script);
    $245a20d5ca697fd8$var$script.__scopeId = 'data-v-f61f2e';
    $245a20d5ca697fd8$var$script.__file = "Demo.vue";
};
$245a20d5ca697fd8$var$initialize();
var $245a20d5ca697fd8$export$2e2bcd8739ae039 = $245a20d5ca697fd8$var$script;


(0, $jE6au.createApp)((0, $245a20d5ca697fd8$export$2e2bcd8739ae039)).mount('#app');


//# sourceMappingURL=demo.07d963ce.js.map
